import { Translation } from 'tools/translation';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Duration: { input: string; output: string; }
  Email: { input: string; output: string; }
  Password: { input: string; output: string; }
  Tag: { input: any; output: any; }
  Time: { input: string; output: string; }
  Translation: { input: Translation; output: Translation; }
  Uint32: { input: any; output: any; }
  Upload: { input: any; output: any; }
  UploadFile: { input: any; output: any; }
  UploadImage: { input: any; output: any; }
};

export type AemResistanceHeaterHardwareConfigInput = {
  canDHW?: InputMaybe<Scalars['Boolean']['input']>;
  canSH?: InputMaybe<Scalars['Boolean']['input']>;
  phase1Allowed?: InputMaybe<Scalars['Boolean']['input']>;
  phase2Allowed?: InputMaybe<Scalars['Boolean']['input']>;
  phase3Allowed?: InputMaybe<Scalars['Boolean']['input']>;
  sinkSupplyTempOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type AccessToken = {
  __typename?: 'AccessToken';
  accessToken: Scalars['String']['output'];
};

export type AuthTokens = {
  __typename?: 'AuthTokens';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum BackupHeaterType {
  None = 'NONE',
  OnOff = 'ON_OFF',
  Opentherm = 'OPENTHERM'
}

export enum CocType {
  DutchKvk = 'dutchKVK',
  Other = 'other'
}

export type Change = {
  __typename?: 'Change';
  changedByGroup?: Maybe<Scalars['String']['output']>;
  changedByUser?: Maybe<Scalars['String']['output']>;
  fromValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  toValue: Scalars['String']['output'];
};

export type ColWidths = {
  __typename?: 'ColWidths';
  key: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export enum Color {
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Fuchsia = 'FUCHSIA',
  Green = 'GREEN',
  Indigo = 'INDIGO',
  Lime = 'LIME',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Teal = 'TEAL',
  Yellow = 'YELLOW'
}

export enum ConnectionType {
  None = 'NONE',
  Wired = 'WIRED',
  WiredAndWireless = 'WIRED_AND_WIRELESS',
  Wireless = 'WIRELESS'
}

export type ControllerSettingsData = {
  __typename?: 'ControllerSettingsData';
  backupHeater: BackupHeaterType;
  chSetpMaxTemp: Scalars['Float']['output'];
  delayHPCheckMin: Scalars['Int']['output'];
  delayHPOffMin: Scalars['Int']['output'];
  delayHPOnMin: Scalars['Int']['output'];
  delayHPPostRunMin: Scalars['Float']['output'];
  hysBHOff: Scalars['Float']['output'];
  hysBHOn: Scalars['Float']['output'];
  hysHPOff: Scalars['Float']['output'];
  hysHPOn: Scalars['Float']['output'];
  manualCoolingMode: ManualCoolingMode;
  minCoolingPerc: Scalars['Float']['output'];
  sourceBivTemp: Scalars['Float']['output'];
};

export type ControllerSettingsInput = {
  backupHeater?: InputMaybe<BackupHeaterType>;
  chSetpMaxTemp?: InputMaybe<Scalars['Float']['input']>;
  delayHPCheckMin?: InputMaybe<Scalars['Int']['input']>;
  delayHPOffMin?: InputMaybe<Scalars['Int']['input']>;
  delayHPOnMin?: InputMaybe<Scalars['Int']['input']>;
  delayHPPostRunMin?: InputMaybe<Scalars['Float']['input']>;
  hysBHOff?: InputMaybe<Scalars['Float']['input']>;
  hysBHOn?: InputMaybe<Scalars['Float']['input']>;
  hysHPOff?: InputMaybe<Scalars['Float']['input']>;
  hysHPOn?: InputMaybe<Scalars['Float']['input']>;
  manualCoolingMode?: InputMaybe<ManualCoolingMode>;
  minCoolingPerc?: InputMaybe<Scalars['Float']['input']>;
  sourceBivTemp?: InputMaybe<Scalars['Float']['input']>;
};

export type Credentials = {
  email: Scalars['Email']['input'];
  password: Scalars['String']['input'];
};

export type DhwHeatSourceUnlockSettingsInput = {
  resistanceHeaterUnlockPolicyType?: InputMaybe<HeatSourceUnlockPolicyType>;
};

export type DhwScheduler = {
  __typename?: 'DHWScheduler';
  blockDHWEnabled?: Maybe<Scalars['Boolean']['output']>;
  blockOffTime?: Maybe<SchedulerTime>;
  blockOnTime?: Maybe<SchedulerTime>;
  forceDHWEnabled?: Maybe<Scalars['Boolean']['output']>;
  forceOffTime?: Maybe<SchedulerTime>;
  forceOnTime?: Maybe<SchedulerTime>;
  schedulerEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type DhwSchedulerInput = {
  blockDHWEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  blockOffTime?: InputMaybe<SchedulerTimeInput>;
  blockOnTime?: InputMaybe<SchedulerTimeInput>;
  forceDHWEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  forceOffTime?: InputMaybe<SchedulerTimeInput>;
  forceOnTime?: InputMaybe<SchedulerTimeInput>;
  schedulerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  from: Scalars['Time']['output'];
  until: Scalars['Time']['output'];
};

export type DefrostStatus = {
  __typename?: 'DefrostStatus';
  allowed: Scalars['Boolean']['output'];
  connectedToHeatPump: Scalars['Boolean']['output'];
  currentSourceTemp?: Maybe<Scalars['Float']['output']>;
  fault?: Maybe<HeatPumpAlert>;
  id: Scalars['String']['output'];
  initialSourceTemp?: Maybe<Scalars['Float']['output']>;
  latestEnd?: Maybe<Scalars['Time']['output']>;
  running: Scalars['Boolean']['output'];
  started?: Maybe<Scalars['Time']['output']>;
};

export enum DetectionStatus {
  Detected = 'DETECTED',
  NotDetected = 'NOT_DETECTED',
  Skipped = 'SKIPPED',
  Waiting = 'WAITING'
}

export type ElectricityData = {
  __typename?: 'ElectricityData';
  power: Scalars['Float']['output'];
};

export enum ElectricityMeterType {
  ElectricElement = 'ELECTRIC_ELEMENT',
  HeatPump = 'HEAT_PUMP'
}

export type Event = {
  __typename?: 'Event';
  data: EventData;
  level: EventLevel;
  start: Scalars['Time']['output'];
  stop?: Maybe<Scalars['Time']['output']>;
  type: EventType;
};

export type EventData = HpErrorData | ModbusChangeData;

export enum EventLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum EventType {
  HpError = 'HP_ERROR',
  MbChange = 'MB_CHANGE'
}

export type ExternalDeviceData = {
  hasCoolingDemand?: Maybe<Scalars['Boolean']['output']>;
  hasDhwDemand?: Maybe<Scalars['Boolean']['output']>;
  hasFault?: Maybe<Scalars['Boolean']['output']>;
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  isCoolingActive?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  oemFaultCode?: Maybe<Scalars['Int']['output']>;
  sinkReturnTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ExternalHeaterType>;
};

export enum ExternalHeaterType {
  Cascade = 'CASCADE',
  OnOff = 'ON_OFF',
  Opentherm = 'OPENTHERM'
}

export type FirstClaim = {
  __typename?: 'FirstClaim';
  timestamp: Scalars['Time']['output'];
  userId: Scalars['ID']['output'];
};

export type FlushingStatus = {
  __typename?: 'FlushingStatus';
  allowed: Scalars['Boolean']['output'];
  connectedToHeatPump: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['Time']['output']>;
  fault?: Maybe<HeatPumpAlert>;
  id: Scalars['String']['output'];
  pumpsRunning: Scalars['Boolean']['output'];
  started?: Maybe<Scalars['Time']['output']>;
};

export type Group = {
  __typename?: 'Group';
  cocNumber?: Maybe<Scalars['String']['output']>;
  cocType?: Maybe<CocType>;
  createdAt: Scalars['Time']['output'];
  createdBy: User;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  heatPumpName?: Maybe<Scalars['String']['output']>;
  heatPumps: Array<HeatPump>;
  id: Scalars['ID']['output'];
  interfaces: Array<Interface>;
  isDeleted: Scalars['Boolean']['output'];
  isOrganization: Scalars['Boolean']['output'];
  labels: Array<Label>;
  members: Array<User>;
  name: Scalars['String']['output'];
};

export type GroupTransferInformation = {
  __typename?: 'GroupTransferInformation';
  groupID: Scalars['ID']['output'];
  groupName: Scalars['String']['output'];
  ownerOfHPIDs?: Maybe<Array<Scalars['String']['output']>>;
  transferPossible: TransferPossible;
};

export type HpErrorData = {
  __typename?: 'HPErrorData';
  errors: Array<Scalars['Int']['output']>;
};

export type HwDetectStatus = {
  __typename?: 'HWDetectStatus';
  aem?: Maybe<DetectionStatus>;
  allowed: Scalars['Boolean']['output'];
  ambientSensor?: Maybe<DetectionStatus>;
  connectedToHeatPump: Scalars['Boolean']['output'];
  dhwTankSensor?: Maybe<DetectionStatus>;
  hpm1?: Maybe<DetectionStatus>;
  hpm2?: Maybe<DetectionStatus>;
  id: Scalars['String']['output'];
  modbusExtensionBoard?: Maybe<DetectionStatus>;
  modbusExtensionHp?: Maybe<DetectionStatus>;
  otExternal?: Maybe<DetectionStatus>;
  otThermostat?: Maybe<DetectionStatus>;
  running: Scalars['Boolean']['output'];
  started?: Maybe<Scalars['Time']['output']>;
};

export type HeatData = {
  __typename?: 'HeatData';
  flow: Scalars['Float']['output'];
  power: Scalars['Float']['output'];
};

export enum HeatMeterType {
  DomesticHotWater = 'DOMESTIC_HOT_WATER',
  Heating = 'HEATING',
  Source = 'SOURCE'
}

export type HeatPump = {
  accessLevel?: Maybe<HeatPumpAccessLevel>;
  alerts: Array<HeatPumpAlert>;
  connectionType?: Maybe<ConnectionType>;
  controller: HeatPumpControllerState;
  externalDevice: ExternalDeviceData;
  features: Array<HeatPumpFeature>;
  groups: Array<Group>;
  heatPumpModule: HeatPumpModuleData;
  id: Scalars['String']['output'];
  isOnline: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Label>>;
  lastStatus?: Maybe<Scalars['Time']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Group>;
  resistanceHeater: ResistanceHeaterData;
  settings: HeatPumpSettings;
  softwareVersion?: Maybe<Scalars['String']['output']>;
};

export enum HeatPumpAccessLevel {
  Member = 'Member',
  Owner = 'Owner'
}

export type HeatPumpAlert = {
  __typename?: 'HeatPumpAlert';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: HeatPumpAlertSeverity;
};

export type HeatPumpAlertHistory = {
  __typename?: 'HeatPumpAlertHistory';
  alerts: Array<HistoricHeatPumpAlert>;
  id: Scalars['String']['output'];
};

export enum HeatPumpAlertSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum HeatPumpAuxRelayMode {
  Off = 'OFF',
  Opentherm = 'OPENTHERM',
  Smatrix = 'SMATRIX',
  Unset = 'UNSET'
}

export type HeatPumpCircuitCoolingCurveSettings = {
  ambientTemp20SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp30SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp40SinkSupplySetpTemp: Scalars['Float']['output'];
  startAmbientTemp: Scalars['Float']['output'];
};

export type HeatPumpCircuitCoolingCurveSettingsInput = {
  ambientTemp20SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  ambientTemp30SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  ambientTemp40SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  startAmbientTemp?: InputMaybe<Scalars['Float']['input']>;
  startDegreeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type HeatPumpCircuitCoolingSettings = {
  curve: HeatPumpCircuitCoolingCurveSettings;
  openThermSinkSupplySetpTemp: Scalars['Float']['output'];
};

export type HeatPumpCircuitCoolingSettingsInput = {
  curve?: InputMaybe<HeatPumpCircuitCoolingCurveSettingsInput>;
  onOffSinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  openThermDewPointControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  openThermSinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  roomSetpTemp?: InputMaybe<Scalars['Float']['input']>;
  roomSetpUpperHysteresis?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatPumpCircuitHeatingCurveSettings = {
  ambientTemp0SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp10SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp20SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTempNeg10SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTempNeg20SinkSupplySetpTemp: Scalars['Float']['output'];
  startAmbientTemp: Scalars['Float']['output'];
};

export type HeatPumpCircuitHeatingCurveSettingsInput = {
  ambientTemp0SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  ambientTemp10SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  ambientTemp20SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  ambientTempNeg10SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  ambientTempNeg20SinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  startAmbientTemp?: InputMaybe<Scalars['Float']['input']>;
  startDegreeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type HeatPumpCircuitHeatingSettings = {
  curve: HeatPumpCircuitHeatingCurveSettings;
  openThermSinkSupplyMaxSetpTemp: Scalars['Float']['output'];
};

export type HeatPumpCircuitHeatingSettingsInput = {
  curve?: InputMaybe<HeatPumpCircuitHeatingCurveSettingsInput>;
  onOffSinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  openThermSinkSupplyMaxSetpTemp?: InputMaybe<Scalars['Float']['input']>;
  roomSetpLowerHysteresis?: InputMaybe<Scalars['Float']['input']>;
  roomSetpTemp?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatPumpCircuitSettings = {
  cooling: HeatPumpCircuitCoolingSettings;
  heating: HeatPumpCircuitHeatingSettings;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HeatPumpCircuitSettingsInput = {
  cooling?: InputMaybe<HeatPumpCircuitCoolingSettingsInput>;
  coolingControlType?: InputMaybe<PikaSpaceConditioningControlType>;
  followsHeatingControlType?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<HeatPumpCircuitHeatingSettingsInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mantovaControlType?: InputMaybe<MantovaSpaceConditioningControlType>;
  pikaControlType?: InputMaybe<PikaSpaceConditioningControlType>;
};

export type HeatPumpCompressorSettingsInput = {
  compressorMinOffMin?: InputMaybe<Scalars['Int']['input']>;
  maxModulationPerc?: InputMaybe<Scalars['Float']['input']>;
  minModulationPerc?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatPumpControllerDomesticHotWaterState = {
  hasDemand?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  modulationLevels: HeatPumpModulationLevelsState;
  status: HeatPumpOperationalStatus;
  tankSetpTemp?: Maybe<Scalars['Float']['output']>;
  tankTemp?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpControllerSpaceConditioningState = {
  ambientTemp?: Maybe<Scalars['Float']['output']>;
  coolingModulationLevels: HeatPumpModulationLevelsState;
  coolingStatus: HeatPumpOperationalStatus;
  hasCoolingDemand?: Maybe<Scalars['Boolean']['output']>;
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  heatingModulationLevels: HeatPumpModulationLevelsState;
  heatingStatus: HeatPumpOperationalStatus;
  isCoolingActive?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  roomSetpTemp?: Maybe<Scalars['Float']['output']>;
  roomTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpControllerState = {
  domesticHotWater: HeatPumpControllerDomesticHotWaterState;
  spaceConditioning: HeatPumpControllerSpaceConditioningState;
};

export type HeatPumpDhwSettings = {
  dhwSetpLowerHysteresis: Scalars['Float']['output'];
  dhwSetpUpperHysteresis: Scalars['Float']['output'];
  isDHWEnabled: Scalars['Boolean']['output'];
  isLegionellaEnabled?: Maybe<Scalars['Boolean']['output']>;
  legionellaDay?: Maybe<Weekday>;
  schedulerEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HeatPumpDhwSettingsInput = {
  autoSetpTemp?: InputMaybe<Scalars['Float']['input']>;
  boostEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dhwSetpLowerHysteresis?: InputMaybe<Scalars['Float']['input']>;
  dhwSetpUpperHysteresis?: InputMaybe<Scalars['Float']['input']>;
  isDHWEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLegionellaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSchedulerBlockingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSchedulerForcingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  legionellaDay?: InputMaybe<Weekday>;
  modulationPerc?: InputMaybe<Scalars['Float']['input']>;
  profile?: InputMaybe<PikaScheduleProfile>;
  profileComfort?: InputMaybe<PikaDhwProfileSettingsInput>;
  profileEco?: InputMaybe<PikaDhwProfileSettingsInput>;
  profileNormal?: InputMaybe<PikaDhwProfileSettingsInput>;
  schedulerBlockingEndTime?: InputMaybe<Scalars['Duration']['input']>;
  schedulerBlockingStartTime?: InputMaybe<Scalars['Duration']['input']>;
  schedulerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerEntries?: InputMaybe<Array<PikaScheduleItemSettingInput>>;
  schedulerTime?: InputMaybe<Scalars['Duration']['input']>;
  tankType?: InputMaybe<PikaDhwTankType>;
};

export enum HeatPumpFeature {
  ProgDefrost = 'PROG_DEFROST',
  ProgFlushing = 'PROG_FLUSHING',
  ProgHardwareDetection = 'PROG_HARDWARE_DETECTION'
}

export enum HeatPumpFlushingMode {
  Balancing = 'BALANCING',
  Flushing = 'FLUSHING',
  Off = 'OFF'
}

export type HeatPumpGeneralSettingsInput = {
  desiredSoftwareVersion?: InputMaybe<Scalars['String']['input']>;
  isBeta?: InputMaybe<Scalars['Boolean']['input']>;
  showPerformanceData?: InputMaybe<Scalars['Boolean']['input']>;
  spaceConditioningToDHWPrioWeight?: InputMaybe<Scalars['Int']['input']>;
};

export type HeatPumpHardwareSettings = {
  otExternal?: Maybe<OtExternalHardwareConfig>;
};

export type HeatPumpHardwareSettingsInput = {
  aemResistanceHeater?: InputMaybe<AemResistanceHeaterHardwareConfigInput>;
  isOTExternalHeaterPresent?: InputMaybe<Scalars['Boolean']['input']>;
  modbusRTU?: InputMaybe<ModbusRtuHardwareConfigInput>;
  modbusTCP?: InputMaybe<ModbusTcpHardwareConfigInput>;
  onOffExternalHeater?: InputMaybe<OnOffExternalHeaterHardwareConfigInput>;
  otExternal?: InputMaybe<OtExternalHardwareConfigInput>;
};

export type HeatPumpInfo = {
  __typename?: 'HeatPumpInfo';
  connected: Scalars['Boolean']['output'];
};

export type HeatPumpLimitSettings = {
  maxSinkSupplyLimitTemp: Scalars['Float']['output'];
  minSinkSupplyLimitTemp: Scalars['Float']['output'];
  minSourceLimitTemp?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpLimitSettingsInput = {
  maxSinkSupplyLimitTemp?: InputMaybe<Scalars['Float']['input']>;
  maxSourceLimitPress?: InputMaybe<Scalars['Float']['input']>;
  minSinkSupplyLimitTemp?: InputMaybe<Scalars['Float']['input']>;
  minSourceLimitTemp?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatPumpModulationLevelsState = {
  external?: Maybe<Scalars['Float']['output']>;
  heatPump?: Maybe<Scalars['Float']['output']>;
  resistanceHeater?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpModuleActuators = {
  compressorFreq?: Maybe<Scalars['Float']['output']>;
  isCompressorRunning?: Maybe<Scalars['Boolean']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpModuleData = {
  actuators: HeatPumpModuleActuators;
  sensors: HeatPumpModuleSensors;
  state: HeatPumpModuleState;
};

export type HeatPumpModuleSensors = {
  condenserTemp?: Maybe<Scalars['Float']['output']>;
  dischargeLineTemp?: Maybe<Scalars['Float']['output']>;
  sinkPumpFlow?: Maybe<Scalars['Float']['output']>;
  sinkReturnTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  sourcePumpFlow?: Maybe<Scalars['Float']['output']>;
  sourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  sourceSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export enum HeatPumpModuleState {
  Cooling = 'COOLING',
  Dhw = 'DHW',
  Heating = 'HEATING',
  Off = 'OFF'
}

export enum HeatPumpOperationalStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Demand = 'DEMAND',
  Fault = 'FAULT',
  Standby = 'STANDBY'
}

export type HeatPumpOverrideSettings = {
  dhwTankTemp?: Maybe<Scalars['Float']['output']>;
  forceDhwValve?: Maybe<Scalars['Boolean']['output']>;
  isDhwTankTempEnabled?: Maybe<Scalars['Boolean']['output']>;
  isForceDhwValveEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSinkPumpPercEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSourcePumpPercEnabled?: Maybe<Scalars['Boolean']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpOverrideSettingsInput = {
  ambientTemp?: InputMaybe<Scalars['Float']['input']>;
  btAux2?: InputMaybe<Scalars['Float']['input']>;
  dhwTankTemp?: InputMaybe<Scalars['Float']['input']>;
  forceDhwValve?: InputMaybe<Scalars['Boolean']['input']>;
  isAmbientTempEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isBTAux2Enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDhwTankTempEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isForceDhwValveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSinkPumpPercEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSourcePumpPercEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sinkPumpPerc?: InputMaybe<Scalars['Float']['input']>;
  sourcePumpPerc?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatPumpPageFilter = {
  __typename?: 'HeatPumpPageFilter';
  offlineHeatPumps: Scalars['Boolean']['output'];
  searchText: Scalars['String']['output'];
};

export type HeatPumpPumpSettings = {
  coolingDT?: Maybe<Scalars['Float']['output']>;
  heatingDT?: Maybe<Scalars['Float']['output']>;
  maxPerc?: Maybe<Scalars['Float']['output']>;
  minPerc?: Maybe<Scalars['Float']['output']>;
  startUpPerc?: Maybe<Scalars['Float']['output']>;
};

export type HeatPumpPumpSettingsInput = {
  coolingDT?: InputMaybe<Scalars['Float']['input']>;
  heatingDT?: InputMaybe<Scalars['Float']['input']>;
  maxPerc?: InputMaybe<Scalars['Float']['input']>;
  minPerc?: InputMaybe<Scalars['Float']['input']>;
  startUpPerc?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatPumpSettings = {
  circuit1: HeatPumpCircuitSettings;
  dhw: HeatPumpDhwSettings;
  hardware?: Maybe<HeatPumpHardwareSettings>;
  limits: HeatPumpLimitSettings;
  overrides?: Maybe<HeatPumpOverrideSettings>;
  sinkPump?: Maybe<HeatPumpPumpSettings>;
  sourcePump?: Maybe<HeatPumpPumpSettings>;
  spaceConditioning: HeatPumpSpaceConditioningSettings;
};

export type HeatPumpSettingsInput = {
  auxIO?: InputMaybe<PikaAuxIoSettingsInput>;
  circuit1?: InputMaybe<HeatPumpCircuitSettingsInput>;
  compressor?: InputMaybe<HeatPumpCompressorSettingsInput>;
  dhw?: InputMaybe<HeatPumpDhwSettingsInput>;
  dhwUnlockSettings?: InputMaybe<DhwHeatSourceUnlockSettingsInput>;
  general?: InputMaybe<HeatPumpGeneralSettingsInput>;
  hardware?: InputMaybe<HeatPumpHardwareSettingsInput>;
  limits?: InputMaybe<HeatPumpLimitSettingsInput>;
  overrides?: InputMaybe<HeatPumpOverrideSettingsInput>;
  powerBudget?: InputMaybe<PikaPowerBudgetSettingsInput>;
  program?: InputMaybe<PikaProgramSettingsInput>;
  sinkPump?: InputMaybe<HeatPumpPumpSettingsInput>;
  sourcePump?: InputMaybe<HeatPumpPumpSettingsInput>;
  spaceConditioning?: InputMaybe<HeatPumpSpaceConditioningSettingsInput>;
  spaceHeatingUnlockSettings?: InputMaybe<SpaceHeatingHeatSourceUnlockSettingsInput>;
};

export type HeatPumpSpaceConditioningSettings = {
  isCoolingEnabled: Scalars['Boolean']['output'];
  isHeatingEnabled: Scalars['Boolean']['output'];
};

export type HeatPumpSpaceConditioningSettingsInput = {
  isCoolingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHeatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spaceCoolingProfile?: InputMaybe<PikaScheduleProfile>;
  spaceCoolingProfileComfort?: InputMaybe<PikaScProfileSettingsInput>;
  spaceCoolingProfileEco?: InputMaybe<PikaScProfileSettingsInput>;
  spaceCoolingProfileNormal?: InputMaybe<PikaScProfileSettingsInput>;
  spaceCoolingSchedulerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spaceCoolingSchedulerEntries?: InputMaybe<Array<PikaScheduleItemSettingInput>>;
  spaceCoolingSinkCircuitType?: InputMaybe<PikaSinkCircuitType>;
  spaceHeatingBackupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spaceHeatingBoostEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spaceHeatingProfile?: InputMaybe<PikaScheduleProfile>;
  spaceHeatingProfileComfort?: InputMaybe<PikaShProfileSettingsInput>;
  spaceHeatingProfileEco?: InputMaybe<PikaShProfileSettingsInput>;
  spaceHeatingProfileNormal?: InputMaybe<PikaShProfileSettingsInput>;
  spaceHeatingSchedulerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spaceHeatingSchedulerEntries?: InputMaybe<Array<PikaScheduleItemSettingInput>>;
  spaceHeatingSinkCircuitType?: InputMaybe<PikaSinkCircuitType>;
};

export type HeatPumpTimeSeries = {
  __typename?: 'HeatPumpTimeSeries';
  data: Array<HeatPumpTimeSeriesEntry>;
  id: Scalars['String']['output'];
};

export type HeatPumpTimeSeriesEntry = {
  alerts: Array<HeatPumpAlert>;
  controller: HeatPumpControllerState;
  externalDevice: ExternalDeviceData;
  heatPumpModule: HeatPumpModuleData;
  resistanceHeater: ResistanceHeaterData;
  timestamp: Scalars['Time']['output'];
};

export enum HeatPumpType {
  Hp3_5 = 'HP3_5',
  Hp5 = 'HP5'
}

export enum HeatSourceUnlockPolicyPriority {
  Prio0 = 'PRIO0',
  Prio1 = 'PRIO1',
  Prio2 = 'PRIO2'
}

export enum HeatSourceUnlockPolicyType {
  Always = 'ALWAYS',
  Disabled = 'DISABLED',
  Erorrorthresholds = 'ERORRORTHRESHOLDS',
  Onlyerror = 'ONLYERROR',
  Onlythresholds = 'ONLYTHRESHOLDS'
}

export type HistoricHeatPumpAlert = {
  __typename?: 'HistoricHeatPumpAlert';
  alert: HeatPumpAlert;
  end?: Maybe<Scalars['Time']['output']>;
  start: Scalars['Time']['output'];
};

export type Interface = {
  __typename?: 'Interface';
  accessLevel?: Maybe<HeatPumpAccessLevel>;
  certificateValidUntil?: Maybe<Scalars['Time']['output']>;
  controller: ControllerSettingsData;
  eventLog: Array<Event>;
  firmwareVersion: InterfaceFirmwareVersion;
  firstClaim?: Maybe<FirstClaim>;
  groupInterfaceName?: Maybe<Scalars['String']['output']>;
  groups: Array<Group>;
  heatPumpConnected: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  interfaceOwner?: Maybe<Group>;
  ioTHubID: Scalars['String']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastMessage?: Maybe<Scalars['Time']['output']>;
  logs: InterfaceLogs;
  mBusElectricityMeters: Array<MBusElectricityMeter>;
  mBusHeatMeters: Array<MBusHeatMeter>;
  name?: Maybe<Scalars['String']['output']>;
  openTherm?: Maybe<OpenThermData>;
  openThermBoilerConnected: Scalars['Boolean']['output'];
  openThermThermostatConnected: Scalars['Boolean']['output'];
  pvtHeatPump?: Maybe<PvtHeatPumpData>;
  slave?: Maybe<Interface>;
  status?: Maybe<InterfaceStatus>;
  updateStatus?: Maybe<UpdateStatus>;
};


export type InterfaceIsOnlineArgs = {
  pingDevice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InterfaceLogsArgs = {
  from: Scalars['Time']['input'];
  interval?: InputMaybe<Scalars['Duration']['input']>;
  until?: InputMaybe<Scalars['Time']['input']>;
};


export type InterfacePvtHeatPumpArgs = {
  fromDB?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterfaceFirmwareVersion = {
  __typename?: 'InterfaceFirmwareVersion';
  available: Scalars['Boolean']['output'];
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  version: Scalars['String']['output'];
};

export type InterfaceLog = {
  __typename?: 'InterfaceLog';
  boiler?: Maybe<OpenThermData>;
  domesticHotWaterHeatMeter?: Maybe<HeatData>;
  electricElementElectricityMeter?: Maybe<ElectricityData>;
  heatPumpElectricityMeter?: Maybe<ElectricityData>;
  heatingHeatMeter?: Maybe<HeatData>;
  mBusElectricity: Array<MBusElectricityData>;
  mBusHeat: Array<MBusHeatData>;
  pvtHeatPump?: Maybe<PvtHeatPumpData>;
  sourceHeatMeter?: Maybe<HeatData>;
  thermostat?: Maybe<OpenThermData>;
  timestamp: Scalars['Time']['output'];
};

export type InterfaceLogs = {
  __typename?: 'InterfaceLogs';
  data: Array<InterfaceLog>;
};

export type InterfaceStatus = {
  __typename?: 'InterfaceStatus';
  operatorName: Scalars['String']['output'];
  signalStrength: Scalars['Int']['output'];
};

export type Label = {
  __typename?: 'Label';
  color: Color;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LabelInput = {
  color: Color;
  name: Scalars['String']['input'];
};

export enum Language {
  De = 'de',
  En = 'en',
  Nl = 'nl'
}

export enum LogPeriod {
  LastDay = 'lastDay',
  LastHour = 'lastHour',
  LastMonth = 'lastMonth',
  LastWeek = 'lastWeek',
  LastYear = 'lastYear',
  Realtime = 'realtime'
}

export type MBusElectricityData = {
  __typename?: 'MBusElectricityData';
  data: ElectricityData;
  mBusId: Scalars['String']['output'];
};

export type MBusElectricityMeter = {
  __typename?: 'MBusElectricityMeter';
  id: Scalars['String']['output'];
  type?: Maybe<ElectricityMeterType>;
};

export type MBusHeatData = {
  __typename?: 'MBusHeatData';
  data: HeatData;
  mBusId: Scalars['String']['output'];
};

export type MBusHeatMeter = {
  __typename?: 'MBusHeatMeter';
  id: Scalars['String']['output'];
  type?: Maybe<HeatMeterType>;
};

export type MantovaCircuitCoolingCurveSettings = HeatPumpCircuitCoolingCurveSettings & {
  __typename?: 'MantovaCircuitCoolingCurveSettings';
  ambientTemp20SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp30SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp40SinkSupplySetpTemp: Scalars['Float']['output'];
  startAmbientTemp: Scalars['Float']['output'];
  startDegreeMinutes: Scalars['Int']['output'];
};

export type MantovaCircuitCoolingSettings = HeatPumpCircuitCoolingSettings & {
  __typename?: 'MantovaCircuitCoolingSettings';
  curve: MantovaCircuitCoolingCurveSettings;
  openThermSinkSupplySetpTemp: Scalars['Float']['output'];
  roomSetpTemp: Scalars['Float']['output'];
  roomSetpUpperHysteresis: Scalars['Float']['output'];
};

export type MantovaCircuitHeatingCurveSettings = HeatPumpCircuitHeatingCurveSettings & {
  __typename?: 'MantovaCircuitHeatingCurveSettings';
  ambientTemp0SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp10SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp20SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTempNeg10SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTempNeg20SinkSupplySetpTemp: Scalars['Float']['output'];
  startAmbientTemp: Scalars['Float']['output'];
  startDegreeMinutes: Scalars['Int']['output'];
};

export type MantovaCircuitHeatingSettings = HeatPumpCircuitHeatingSettings & {
  __typename?: 'MantovaCircuitHeatingSettings';
  curve: MantovaCircuitHeatingCurveSettings;
  openThermSinkSupplyMaxSetpTemp: Scalars['Float']['output'];
  roomSetpLowerHysteresis: Scalars['Float']['output'];
  roomSetpTemp: Scalars['Float']['output'];
};

export type MantovaCircuitSettings = HeatPumpCircuitSettings & {
  __typename?: 'MantovaCircuitSettings';
  controlType: MantovaSpaceConditioningControlType;
  cooling: MantovaCircuitCoolingSettings;
  heating: MantovaCircuitHeatingSettings;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MantovaControllerDomesticHotWaterState = HeatPumpControllerDomesticHotWaterState & {
  __typename?: 'MantovaControllerDomesticHotWaterState';
  hasDemand?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  modulationLevels: MantovaModulationLevelsState;
  status: HeatPumpOperationalStatus;
  tankSetpTemp?: Maybe<Scalars['Float']['output']>;
  tankTemp?: Maybe<Scalars['Float']['output']>;
};

export type MantovaControllerSpaceConditioningState = HeatPumpControllerSpaceConditioningState & {
  __typename?: 'MantovaControllerSpaceConditioningState';
  ambientTemp?: Maybe<Scalars['Float']['output']>;
  coolingModulationLevels: MantovaModulationLevelsState;
  coolingStatus: HeatPumpOperationalStatus;
  hasCoolingDemand?: Maybe<Scalars['Boolean']['output']>;
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  heatingModulationLevels: MantovaModulationLevelsState;
  heatingStatus: HeatPumpOperationalStatus;
  isCoolingActive?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  roomSetpTemp?: Maybe<Scalars['Float']['output']>;
  roomTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export type MantovaControllerState = HeatPumpControllerState & {
  __typename?: 'MantovaControllerState';
  domesticHotWater: MantovaControllerDomesticHotWaterState;
  spaceConditioning: MantovaControllerSpaceConditioningState;
};

export type MantovaDhwSettings = HeatPumpDhwSettings & {
  __typename?: 'MantovaDHWSettings';
  autoSetpTemp: Scalars['Float']['output'];
  dhwSetpLowerHysteresis: Scalars['Float']['output'];
  dhwSetpUpperHysteresis: Scalars['Float']['output'];
  isDHWEnabled: Scalars['Boolean']['output'];
  isLegionellaEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSchedulerBlockingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSchedulerForcingEnabled?: Maybe<Scalars['Boolean']['output']>;
  legionellaDay?: Maybe<Weekday>;
  schedulerBlockingEndTime?: Maybe<Scalars['Duration']['output']>;
  schedulerBlockingStartTime?: Maybe<Scalars['Duration']['output']>;
  schedulerEnabled?: Maybe<Scalars['Boolean']['output']>;
  schedulerTime?: Maybe<Scalars['Duration']['output']>;
};

export type MantovaExternalDeviceData = ExternalDeviceData & {
  __typename?: 'MantovaExternalDeviceData';
  hasCoolingDemand?: Maybe<Scalars['Boolean']['output']>;
  hasDhwDemand?: Maybe<Scalars['Boolean']['output']>;
  hasFault?: Maybe<Scalars['Boolean']['output']>;
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  isCoolingActive?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  oemFaultCode?: Maybe<Scalars['Int']['output']>;
  sinkReturnTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ExternalHeaterType>;
};

export type MantovaFirmwareVersion = {
  __typename?: 'MantovaFirmwareVersion';
  available: Scalars['Boolean']['output'];
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

export type MantovaHardwareSettings = HeatPumpHardwareSettings & {
  __typename?: 'MantovaHardwareSettings';
  otExternal?: Maybe<MantovaOtExternalHardwareConfig>;
};

export type MantovaHeatPump = HeatPump & {
  __typename?: 'MantovaHeatPump';
  accessLevel?: Maybe<HeatPumpAccessLevel>;
  alerts: Array<HeatPumpAlert>;
  connectionType: ConnectionType;
  controller: MantovaControllerState;
  externalDevice: MantovaExternalDeviceData;
  features: Array<HeatPumpFeature>;
  groups: Array<Group>;
  heatPumpModule: MantovaModuleData;
  id: Scalars['String']['output'];
  isOnline: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Label>>;
  lastStatus?: Maybe<Scalars['Time']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Group>;
  resistanceHeater: MantovaResistanceHeaterData;
  settings: MantovaSettings;
  softwareVersion?: Maybe<Scalars['String']['output']>;
};

export type MantovaLimitSettings = HeatPumpLimitSettings & {
  __typename?: 'MantovaLimitSettings';
  maxSinkSupplyLimitTemp: Scalars['Float']['output'];
  minSinkSupplyLimitTemp: Scalars['Float']['output'];
  minSourceLimitTemp?: Maybe<Scalars['Float']['output']>;
};

export type MantovaModulationLevelsState = HeatPumpModulationLevelsState & {
  __typename?: 'MantovaModulationLevelsState';
  external?: Maybe<Scalars['Float']['output']>;
  heatPump?: Maybe<Scalars['Float']['output']>;
  resistanceHeater?: Maybe<Scalars['Float']['output']>;
};

export type MantovaModuleActuators = HeatPumpModuleActuators & {
  __typename?: 'MantovaModuleActuators';
  compressorFreq?: Maybe<Scalars['Float']['output']>;
  isCompressorRunning?: Maybe<Scalars['Boolean']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
};

export type MantovaModuleData = HeatPumpModuleData & {
  __typename?: 'MantovaModuleData';
  actuators: MantovaModuleActuators;
  sensors: MantovaModuleSensors;
  state: HeatPumpModuleState;
};

export type MantovaModuleSensors = HeatPumpModuleSensors & {
  __typename?: 'MantovaModuleSensors';
  condenserTemp?: Maybe<Scalars['Float']['output']>;
  dischargeLineTemp?: Maybe<Scalars['Float']['output']>;
  sinkPumpFlow?: Maybe<Scalars['Float']['output']>;
  sinkReturnTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  sourcePumpFlow?: Maybe<Scalars['Float']['output']>;
  sourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  sourceSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export type MantovaOtExternalHardwareConfig = OtExternalHardwareConfig & {
  __typename?: 'MantovaOTExternalHardwareConfig';
  canSH?: Maybe<Scalars['Boolean']['output']>;
};

export type MantovaOverrideSettings = HeatPumpOverrideSettings & {
  __typename?: 'MantovaOverrideSettings';
  btAux2?: Maybe<Scalars['Float']['output']>;
  dhwTankTemp?: Maybe<Scalars['Float']['output']>;
  forceDhwValve?: Maybe<Scalars['Boolean']['output']>;
  isBTAux2Enabled?: Maybe<Scalars['Boolean']['output']>;
  isDhwTankTempEnabled?: Maybe<Scalars['Boolean']['output']>;
  isForceDhwValveEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSinkPumpPercEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSourcePumpPercEnabled?: Maybe<Scalars['Boolean']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
};

export type MantovaPumpSettings = HeatPumpPumpSettings & {
  __typename?: 'MantovaPumpSettings';
  coolingDT?: Maybe<Scalars['Float']['output']>;
  heatingDT?: Maybe<Scalars['Float']['output']>;
  maxPerc?: Maybe<Scalars['Float']['output']>;
  minPerc?: Maybe<Scalars['Float']['output']>;
  startUpPerc?: Maybe<Scalars['Float']['output']>;
};

export type MantovaResistanceHeaterData = ResistanceHeaterData & {
  __typename?: 'MantovaResistanceHeaterData';
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  maxModulationLevel?: Maybe<Scalars['Float']['output']>;
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export type MantovaSettings = HeatPumpSettings & {
  __typename?: 'MantovaSettings';
  circuit1: MantovaCircuitSettings;
  dhw: MantovaDhwSettings;
  hardware?: Maybe<MantovaHardwareSettings>;
  limits: MantovaLimitSettings;
  overrides: MantovaOverrideSettings;
  sinkPump: MantovaPumpSettings;
  sourcePump: MantovaPumpSettings;
  spaceConditioning: MantovaSpaceConditioningSettings;
};

export enum MantovaSpaceConditioningControlType {
  DmControl = 'DM_CONTROL',
  Opentherm = 'OPENTHERM',
  RoomSensor = 'ROOM_SENSOR',
  Thermostat = 'THERMOSTAT'
}

export type MantovaSpaceConditioningSettings = HeatPumpSpaceConditioningSettings & {
  __typename?: 'MantovaSpaceConditioningSettings';
  isCoolingEnabled: Scalars['Boolean']['output'];
  isHeatingEnabled: Scalars['Boolean']['output'];
  spaceHeatingBackupEnabled: Scalars['Boolean']['output'];
  spaceHeatingBoostEnabled: Scalars['Boolean']['output'];
};

export type MantovaTimeSeriesEntry = HeatPumpTimeSeriesEntry & {
  __typename?: 'MantovaTimeSeriesEntry';
  alerts: Array<HeatPumpAlert>;
  controller: MantovaControllerState;
  externalDevice: MantovaExternalDeviceData;
  heatPumpModule: MantovaModuleData;
  resistanceHeater: MantovaResistanceHeaterData;
  timestamp: Scalars['Time']['output'];
};

export type MantovaUpdateMethodData = {
  __typename?: 'MantovaUpdateMethodData';
  crc: Scalars['Uint32']['output'];
  sas: Scalars['String']['output'];
  size: Scalars['Uint32']['output'];
};

export enum ManualCoolingMode {
  Inactive = 'INACTIVE',
  Off = 'OFF',
  On = 'ON'
}

export type ModbusChangeData = {
  __typename?: 'ModbusChangeData';
  address: Scalars['Int']['output'];
  user: User;
  value: Scalars['Int']['output'];
};

export type ModbusRtuHardwareConfigInput = {
  extensionBoardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  extensionHPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ModbusRegisterType {
  Holding = 'HOLDING',
  Input = 'INPUT'
}

export type ModbusTcpHardwareConfigInput = {
  serverMode?: InputMaybe<PikaModbusTcpServerMode>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add a label to a heat pump.
   *
   * Allowed if:
   * - You are in an organization
   * - This heat pump is in your group
   * - This label is in your group
   */
  addLabelToHeatPump: HeatPump;
  /**
   * Claims an heat pump by adding it to a group
   * Allowed if:
   * - You are app admin or mechanic
   * - Heat pump is unclaimed
   */
  claimHeatPump: Group;
  /**
   * Add a label to your group.
   *
   * Allowed if:
   * - You are in an organization
   */
  createLabel: Group;
  /**
   * Delete a label from your groupp.
   *
   * Allowed if:
   * - You are in an organization
   * - This label exists in your group
   * - The label is not assigned to any heat pump, unless `force` is true
   */
  deleteLabel: Group;
  /** Delete a notification */
  deleteNotification: Scalars['Boolean']['output'];
  /** Enable local CSR service for a heat pump */
  enableHeatPumpLocalCSRService: Scalars['Boolean']['output'];
  /** Enable real time logging for a heat pump */
  enableHeatPumpRealTimeLogs: Scalars['Boolean']['output'];
  /** Fetch the heat pump logs between from and until timestamps */
  fetchHeatPumpLogs: Scalars['Boolean']['output'];
  /** Change the settings of a single heatpump */
  heatPumpSettings: HeatPump;
  /**
   * Start/Extend an interactive session (should be called again in 60 seconds to extend interactive session).
   * It will log data every second while the interactive session is active.
   */
  interactiveSession: Scalars['Boolean']['output'];
  /**
   * Invite a new user to your group
   * Allowed if:
   * - You are app admin
   * - You are group admin
   * Not allowed if:
   * - You invite yourself (email is you own email)
   * - The group is not an organization
   */
  inviteNewUserToGroup: Scalars['Boolean']['output'];
  /**
   * Invite a new user to an heat pump.
   * If the user already has an account, the heat pump is added to their group and notification email is send.
   * If the user does not yet have an account, an invite email is send.
   * Allowed if:
   * - You are app admin
   * - You are group admin and your group is heat pump owner
   * Not allowed if:
   * - You invite yourself (email is you own email)
   */
  inviteUserToHeatPump: Scalars['Boolean']['output'];
  /** Mark a notification as read. This marks the nofification with the below ID as read for the current user */
  markNotificationRead: Notification;
  /** Reboot a single heat pump */
  rebootHeatPump: Scalars['Boolean']['output'];
  /**
   * Remove heat pump from a group if in it.
   * Allowed if:
   * - You are app admin
   * - You are group admin and remove your own group
   * - You are group admin and your group is owner of the heat pump (allowed to remove another group)
   * Not allowed if:
   * - Group to remove is owner and others have access
   */
  removeHeatPumpFromGroup?: Maybe<Group>;
  /**
   * Remove a label from a heat pump.
   *
   * Allowed if:
   * - You are in an organization
   * - This heat pump is in your group
   * - This label is in your group
   */
  removeLabelFromHeatPump: HeatPump;
  /**
   * Removes a user from a group
   * Allowed if:
   * - You are app admin
   * - You are group admin
   * - You are removing yourself
   * - User to remove is not the last group admin unless user to remove is the last member
   */
  removeUserFromGroup: Group;
  /** Reset a single heat pump */
  resetHeatPump: Scalars['Boolean']['output'];
  setDefaultInterfaceFirmware: InterfaceFirmwareVersion;
  setDefaultMantovaFirmware: MantovaFirmwareVersion;
  setDefaultPikaUpdate: PikaSoftwareVersion;
  /** Set/Change the name of a Interface */
  setInterfaceName: Interface;
  /** Set type of electricity meter (location of electricity meter) */
  setMBusElectricityMeterType: Interface;
  /** Set type of heat meter (location of heat meter) */
  setMBusHeatMeterType: Interface;
  /** Set/Change the interfaceID of the slave heat pump. nil can be passed for the slaveId to remove the slave */
  setSlave: Interface;
  /** Start the defrost program */
  startHeatPumpDefrostProgram: Scalars['Boolean']['output'];
  /** Start the flushing program */
  startHeatPumpFlushingProgram: Scalars['Boolean']['output'];
  /** Start the HW detect program */
  startHeatPumpHWDetectProgram: Scalars['Boolean']['output'];
  /** Stop the currently running program */
  stopHeatPumpProgram: Scalars['Boolean']['output'];
  /**
   * Transfer to a different group.
   * Allowed if:
   * - You have been invited to join this group
   * - You are not the only admin of a group
   * - If you are the only person in the group, if you do now own any heatpumps
   */
  transferToGroup: Group;
  /** Update the OpenTherm (hybrid) controller settings */
  updateControllerSettings: Array<Interface>;
  /** Does multiple seperate modbus writes to enable editing, setting a schedule and apply it to all week days */
  updateDHWScheduler: Scalars['Boolean']['output'];
  /**
   * Sets the group admin status of a group member
   * Allowed if:
   * - You are app admin
   * - You are group admin
   * Not allowed if:
   * - You are demoting the last admin
   * - User is not in the group
   * - User role does not change
   */
  updateGroupAdmin: Group;
  /**
   * Updates the name of a heat pump for your group
   * Allowed if:
   * - You are app admin
   * - You are group admin
   * Not allowed if:
   * - Heat Pump is not in the group
   * - Name doesn't change
   */
  updateGroupHeatPumpName: Group;
  /**
   * Updates the name of a group.
   * Allowed if:
   * - You are app admin
   * - You are group admin
   */
  updateGroupName: Group;
  /**
   * Set the heat pump access level of a group
   * Allowed if:
   * - You are app admin
   * - You are group admin and your group is heat pump owner
   * Not allowed if:
   * - Assigned access level is not owner (as of now)
   * - The group you want to change the access level of is owner
   */
  updateHeatPumpAccessLevel: Group;
  /** Update name of single heat pump */
  updateHeatPumpName: HeatPump;
  /** Update the interface firmware to one with the given build id, if no firmwareID is given the default firmware is used */
  updateInterfaceFirmware: Scalars['Boolean']['output'];
  /**
   * Update a label from your group.
   *
   * Allowed if:
   * - You are in an organization
   * - This label exists in your group
   */
  updateLabel: Group;
  /** Update the Mantova firmware to one with the given firmware version ID, if no firmwareID is given the default firmware is used */
  updateMantovaFirmware: Scalars['Boolean']['output'];
  /** Write data directly to a heat pump. There is a quite strict rate limit (100 requests per day) set on this mutation, since it uses cellular data to write the data */
  updatePvtHeatPump: Scalars['Boolean']['output'];
  /** Upsert a notification */
  upsertNotification: Notification;
  /**
   * Upsert a user (any information related to a person). If the user needs an account, createAccount should be used.
   * Allowed if:
   * - You are app admin
   * - You are updating yourself
   */
  upsertUser: User;
};


export type MutationAddLabelToHeatPumpArgs = {
  heatPumpId: Scalars['String']['input'];
  labelId: Scalars['ID']['input'];
};


export type MutationClaimHeatPumpArgs = {
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
};


export type MutationCreateLabelArgs = {
  input: LabelInput;
};


export type MutationDeleteLabelArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationEnableHeatPumpLocalCsrServiceArgs = {
  id: Scalars['String']['input'];
};


export type MutationEnableHeatPumpRealTimeLogsArgs = {
  id: Scalars['String']['input'];
};


export type MutationFetchHeatPumpLogsArgs = {
  from?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['String']['input'];
  until?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationHeatPumpSettingsArgs = {
  id: Scalars['String']['input'];
  settings: HeatPumpSettingsInput;
};


export type MutationInteractiveSessionArgs = {
  interfaceId: Scalars['String']['input'];
};


export type MutationInviteNewUserToGroupArgs = {
  email: Scalars['Email']['input'];
  groupId: Scalars['ID']['input'];
};


export type MutationInviteUserToHeatPumpArgs = {
  email: Scalars['Email']['input'];
  heatPumpId: Scalars['String']['input'];
};


export type MutationMarkNotificationReadArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationRebootHeatPumpArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveHeatPumpFromGroupArgs = {
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
};


export type MutationRemoveLabelFromHeatPumpArgs = {
  heatPumpId: Scalars['String']['input'];
  labelId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromGroupArgs = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResetHeatPumpArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetDefaultInterfaceFirmwareArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultMantovaFirmwareArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultPikaUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetInterfaceNameArgs = {
  interfaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetMBusElectricityMeterTypeArgs = {
  interfaceId: Scalars['String']['input'];
  mBusId: Scalars['String']['input'];
  type?: InputMaybe<ElectricityMeterType>;
};


export type MutationSetMBusHeatMeterTypeArgs = {
  interfaceId: Scalars['String']['input'];
  mBusId: Scalars['String']['input'];
  type?: InputMaybe<HeatMeterType>;
};


export type MutationSetSlaveArgs = {
  interfaceId: Scalars['String']['input'];
  slaveId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartHeatPumpDefrostProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationStartHeatPumpFlushingProgramArgs = {
  duration: Scalars['Duration']['input'];
  id: Scalars['String']['input'];
};


export type MutationStartHeatPumpHwDetectProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationStopHeatPumpProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationTransferToGroupArgs = {
  groupID: Scalars['ID']['input'];
};


export type MutationUpdateControllerSettingsArgs = {
  interfaceIds: Array<Scalars['String']['input']>;
  settings: ControllerSettingsInput;
};


export type MutationUpdateDhwSchedulerArgs = {
  data: DhwSchedulerInput;
  interfaceIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateGroupAdminArgs = {
  admin: Scalars['Boolean']['input'];
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateGroupHeatPumpNameArgs = {
  heatPumpId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateGroupNameArgs = {
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateHeatPumpAccessLevelArgs = {
  accessLevel: HeatPumpAccessLevel;
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
};


export type MutationUpdateHeatPumpNameArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateInterfaceFirmwareArgs = {
  firmwareId?: InputMaybe<Scalars['ID']['input']>;
  interfaceIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateLabelArgs = {
  id: Scalars['ID']['input'];
  input: LabelInput;
};


export type MutationUpdateMantovaFirmwareArgs = {
  firmwareId?: InputMaybe<Scalars['ID']['input']>;
  interfaceIds: Array<Scalars['String']['input']>;
};


export type MutationUpdatePvtHeatPumpArgs = {
  data: PvtHeatPumpInput;
  interfaceIds: Array<Scalars['String']['input']>;
};


export type MutationUpsertNotificationArgs = {
  notification: NotificationInput;
};


export type MutationUpsertUserArgs = {
  user: NewUser;
};

export type NewAccount = {
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['Password']['input'];
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NewAccountTokenInput = {
  email: Scalars['String']['input'];
  role: Role;
};

export type NewGroup = {
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  cocType?: InputMaybe<CocType>;
  isOrganization: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NewUser = {
  email?: InputMaybe<Scalars['Email']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
  preferences?: InputMaybe<UserPreferencesInput>;
  roles?: InputMaybe<Array<Role>>;
};

export type Notification = {
  __typename?: 'Notification';
  content: Scalars['Translation']['output'];
  createdAt: Scalars['Time']['output'];
  expirationDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  severity?: Maybe<NotificationSeverity>;
  title: Scalars['Translation']['output'];
  type: NotificationType;
};

export type NotificationInput = {
  content: Scalars['Translation']['input'];
  expirationDate: Scalars['Time']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  severity?: InputMaybe<NotificationSeverity>;
  title: Scalars['Translation']['input'];
  type: NotificationType;
};

export enum NotificationSeverity {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

export type NotificationTranslationInput = {
  content: Scalars['String']['input'];
  language: Language;
  title: Scalars['String']['input'];
};

export enum NotificationType {
  Banner = 'banner',
  Notification = 'notification'
}

export type OtExternalHardwareConfig = {
  canSH?: Maybe<Scalars['Boolean']['output']>;
};

export type OtExternalHardwareConfigInput = {
  canSH?: InputMaybe<Scalars['Boolean']['input']>;
  sinkSupplyTempOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type OnOffExternalHeaterHardwareConfigInput = {
  canDHW?: InputMaybe<Scalars['Boolean']['input']>;
  canSH?: InputMaybe<Scalars['Boolean']['input']>;
  modulationPercThreshold?: InputMaybe<Scalars['Float']['input']>;
  sinkSupplyTempHystLow?: InputMaybe<Scalars['Float']['input']>;
  sinkSupplyTempHystUp?: InputMaybe<Scalars['Float']['input']>;
  sinkSupplyTempOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type OpenThermData = {
  __typename?: 'OpenThermData';
  chActive?: Maybe<Scalars['Boolean']['output']>;
  chEnable?: Maybe<Scalars['Boolean']['output']>;
  chFeedTemp?: Maybe<Scalars['Float']['output']>;
  chReturnTemp?: Maybe<Scalars['Float']['output']>;
  chSetpMaxTemp?: Maybe<Scalars['Float']['output']>;
  chSetpTemp?: Maybe<Scalars['Float']['output']>;
  coolingEnable?: Maybe<Scalars['Boolean']['output']>;
  coolingPercSetp?: Maybe<Scalars['Float']['output']>;
  dhwActive?: Maybe<Scalars['Boolean']['output']>;
  dhwEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwSetpTemp?: Maybe<Scalars['Float']['output']>;
  dhwTemp?: Maybe<Scalars['Float']['output']>;
  hasAirPressFault?: Maybe<Scalars['Boolean']['output']>;
  hasFault?: Maybe<Scalars['Boolean']['output']>;
  hasFlameFault?: Maybe<Scalars['Boolean']['output']>;
  hasWaterOverTempFault?: Maybe<Scalars['Boolean']['output']>;
  hasWaterPressFault?: Maybe<Scalars['Boolean']['output']>;
  isCooling?: Maybe<Scalars['Boolean']['output']>;
  isHeating?: Maybe<Scalars['Boolean']['output']>;
  modulationLevelPerc?: Maybe<Scalars['Float']['output']>;
  needsService?: Maybe<Scalars['Boolean']['output']>;
  oemFaultCode?: Maybe<Scalars['Int']['output']>;
  roomSetpTemp?: Maybe<Scalars['Float']['output']>;
  roomTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaAemResistanceHeaterHardwareConfig = {
  __typename?: 'PikaAEMResistanceHeaterHardwareConfig';
  canDHW?: Maybe<Scalars['Boolean']['output']>;
  canSH?: Maybe<Scalars['Boolean']['output']>;
  phase1Allowed?: Maybe<Scalars['Boolean']['output']>;
  phase2Allowed?: Maybe<Scalars['Boolean']['output']>;
  phase3Allowed?: Maybe<Scalars['Boolean']['output']>;
  sinkSupplyTempOffset?: Maybe<Scalars['Float']['output']>;
};

export type PikaAuxIoSettings = {
  __typename?: 'PikaAuxIOSettings';
  aux3InputFunction?: Maybe<PikaAuxInputFunction>;
  aux4InputFunction?: Maybe<PikaAuxInputFunction>;
  aux5InputFunction?: Maybe<PikaAuxInputFunction>;
  auxRelay1Function?: Maybe<PikaAuxRelayFunction>;
  auxRelay2Function?: Maybe<PikaAuxRelayFunction>;
};

export type PikaAuxIoSettingsInput = {
  aux3InputFunction?: InputMaybe<PikaAuxInputFunction>;
  aux4InputFunction?: InputMaybe<PikaAuxInputFunction>;
  aux5InputFunction?: InputMaybe<PikaAuxInputFunction>;
  auxRelay1Function?: InputMaybe<PikaAuxRelayFunction>;
  auxRelay2Function?: InputMaybe<PikaAuxRelayFunction>;
};

export enum PikaAuxInputFunction {
  AmbientTemp = 'AMBIENT_TEMP',
  DhwTankTemp = 'DHW_TANK_TEMP',
  ExternalSinkSupplyTemp = 'EXTERNAL_SINK_SUPPLY_TEMP',
  None = 'NONE',
  OnOffCooling = 'ON_OFF_COOLING',
  OnOffHeating = 'ON_OFF_HEATING',
  ParallelBufferBottomTemp = 'PARALLEL_BUFFER_BOTTOM_TEMP',
  ParallelBufferTopTemp = 'PARALLEL_BUFFER_TOP_TEMP',
  PowerLimit = 'POWER_LIMIT',
  Reset = 'RESET'
}

export enum PikaAuxRelayFunction {
  Cooling = 'COOLING',
  Fault = 'FAULT',
  None = 'NONE',
  OnOffExternal = 'ON_OFF_EXTERNAL',
  SpaceConditioningActive = 'SPACE_CONDITIONING_ACTIVE'
}

export type PikaCircuitCoolingCurveSettings = HeatPumpCircuitCoolingCurveSettings & {
  __typename?: 'PikaCircuitCoolingCurveSettings';
  ambientTemp20SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp30SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp40SinkSupplySetpTemp: Scalars['Float']['output'];
  startAmbientTemp: Scalars['Float']['output'];
};

export type PikaCircuitCoolingSettings = HeatPumpCircuitCoolingSettings & {
  __typename?: 'PikaCircuitCoolingSettings';
  curve: PikaCircuitCoolingCurveSettings;
  onOffSinkSupplySetpTemp: Scalars['Float']['output'];
  openThermDewPointControlEnabled?: Maybe<Scalars['Boolean']['output']>;
  openThermSinkSupplySetpTemp: Scalars['Float']['output'];
};

export type PikaCircuitHeatingCurveSettings = HeatPumpCircuitHeatingCurveSettings & {
  __typename?: 'PikaCircuitHeatingCurveSettings';
  ambientTemp0SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp10SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTemp20SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTempNeg10SinkSupplySetpTemp: Scalars['Float']['output'];
  ambientTempNeg20SinkSupplySetpTemp: Scalars['Float']['output'];
  startAmbientTemp: Scalars['Float']['output'];
};

export type PikaCircuitHeatingSettings = HeatPumpCircuitHeatingSettings & {
  __typename?: 'PikaCircuitHeatingSettings';
  curve: PikaCircuitHeatingCurveSettings;
  onOffSinkSupplySetpTemp: Scalars['Float']['output'];
  openThermSinkSupplyMaxSetpTemp: Scalars['Float']['output'];
};

export type PikaCircuitSettings = HeatPumpCircuitSettings & {
  __typename?: 'PikaCircuitSettings';
  controlType: PikaSpaceConditioningControlType;
  cooling: PikaCircuitCoolingSettings;
  coolingControlType?: Maybe<PikaSpaceConditioningControlType>;
  followsHeatingControlType?: Maybe<Scalars['Boolean']['output']>;
  heating: PikaCircuitHeatingSettings;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PikaCompressorSettings = {
  __typename?: 'PikaCompressorSettings';
  compressorMinOffMin?: Maybe<Scalars['Int']['output']>;
  maxModulationPerc?: Maybe<Scalars['Float']['output']>;
  minModulationPerc?: Maybe<Scalars['Float']['output']>;
};

export type PikaControllerDomesticHotWaterState = HeatPumpControllerDomesticHotWaterState & {
  __typename?: 'PikaControllerDomesticHotWaterState';
  hasDemand?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  modulationLevels: PikaModulationLevelsState;
  status: HeatPumpOperationalStatus;
  tankSetpTemp?: Maybe<Scalars['Float']['output']>;
  tankTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaControllerSpaceConditioningState = HeatPumpControllerSpaceConditioningState & {
  __typename?: 'PikaControllerSpaceConditioningState';
  ambientTemp?: Maybe<Scalars['Float']['output']>;
  coolingModulationLevels: PikaModulationLevelsState;
  coolingStatus: HeatPumpOperationalStatus;
  hasCoolingDemand?: Maybe<Scalars['Boolean']['output']>;
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  heatingModulationLevels: PikaModulationLevelsState;
  heatingStatus: HeatPumpOperationalStatus;
  isCoolingActive?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  modulationLevelSetpPerc?: Maybe<Scalars['Float']['output']>;
  parallelBufferBottomTemp?: Maybe<Scalars['Float']['output']>;
  parallelBufferTopTemp?: Maybe<Scalars['Float']['output']>;
  relativeHumidity?: Maybe<Scalars['Float']['output']>;
  roomSetpTemp?: Maybe<Scalars['Float']['output']>;
  roomTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaControllerState = HeatPumpControllerState & {
  __typename?: 'PikaControllerState';
  domesticHotWater: PikaControllerDomesticHotWaterState;
  programState?: Maybe<PikaProgramState>;
  spaceConditioning: PikaControllerSpaceConditioningState;
};

export type PikaDhwHeatSourceUnlockSettings = {
  __typename?: 'PikaDHWHeatSourceUnlockSettings';
  resistanceHeaterUnlockPolicyType?: Maybe<HeatSourceUnlockPolicyType>;
};

export type PikaDhwProfileSettings = {
  __typename?: 'PikaDHWProfileSettings';
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  tankTempHystLow?: Maybe<Scalars['Float']['output']>;
  tankTempSetpoint?: Maybe<Scalars['Float']['output']>;
};

export type PikaDhwProfileSettingsInput = {
  modulationPerc?: InputMaybe<Scalars['Float']['input']>;
  tankTempHystLow?: InputMaybe<Scalars['Float']['input']>;
  tankTempSetpoint?: InputMaybe<Scalars['Float']['input']>;
};

export type PikaDhwSettings = HeatPumpDhwSettings & {
  __typename?: 'PikaDHWSettings';
  dhwSetpLowerHysteresis: Scalars['Float']['output'];
  dhwSetpUpperHysteresis: Scalars['Float']['output'];
  isDHWEnabled: Scalars['Boolean']['output'];
  isLegionellaEnabled?: Maybe<Scalars['Boolean']['output']>;
  legionellaDay?: Maybe<Weekday>;
  modulationPerc: Scalars['Float']['output'];
  profile?: Maybe<PikaScheduleProfile>;
  profileComfort?: Maybe<PikaDhwProfileSettings>;
  profileEco?: Maybe<PikaDhwProfileSettings>;
  profileNormal?: Maybe<PikaDhwProfileSettings>;
  schedulerEnabled?: Maybe<Scalars['Boolean']['output']>;
  schedulerEntries?: Maybe<Array<PikaScheduleItemSetting>>;
  tankType?: Maybe<PikaDhwTankType>;
};

export enum PikaDhwTankType {
  ThermalBattery = 'THERMAL_BATTERY',
  Water = 'WATER'
}

export type PikaExternalDeviceData = ExternalDeviceData & {
  __typename?: 'PikaExternalDeviceData';
  hasCoolingDemand?: Maybe<Scalars['Boolean']['output']>;
  hasDhwDemand?: Maybe<Scalars['Boolean']['output']>;
  hasFault?: Maybe<Scalars['Boolean']['output']>;
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  isCoolingActive?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  oemFaultCode?: Maybe<Scalars['Int']['output']>;
  sinkReturnTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ExternalHeaterType>;
};

export type PikaGeneralSettings = {
  __typename?: 'PikaGeneralSettings';
  desiredSoftwareVersion?: Maybe<Scalars['String']['output']>;
  isBeta: Scalars['Boolean']['output'];
  showPerformanceData?: Maybe<Scalars['Boolean']['output']>;
  spaceConditioningToDHWPrioWeight?: Maybe<Scalars['Int']['output']>;
};

export type PikaHardwareSettings = HeatPumpHardwareSettings & {
  __typename?: 'PikaHardwareSettings';
  aemResistanceHeater?: Maybe<PikaAemResistanceHeaterHardwareConfig>;
  modbusRTU?: Maybe<PikaModbusRtuHardwareConfig>;
  modbusTCP?: Maybe<PikaModbusTcpHardwareConfig>;
  onOffExternalHeater?: Maybe<PikaOnOffExternalHeaterHardwareConfig>;
  otExternal?: Maybe<PikaOtExternalHardwareConfig>;
};

export type PikaHeatPump = HeatPump & {
  __typename?: 'PikaHeatPump';
  accessLevel?: Maybe<HeatPumpAccessLevel>;
  alerts: Array<HeatPumpAlert>;
  connectionType: ConnectionType;
  controller: PikaControllerState;
  externalDevice: PikaExternalDeviceData;
  features: Array<HeatPumpFeature>;
  groups: Array<Group>;
  heatPumpModule: PikaModuleData;
  id: Scalars['String']['output'];
  isOnline: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Label>>;
  lastStatus?: Maybe<Scalars['Time']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Group>;
  pressures: PikaPressures;
  resistanceHeater: PikaResistanceHeaterData;
  settings: PikaSettings;
  softwareVersion?: Maybe<Scalars['String']['output']>;
  statistics: PikaStatistics;
};

export type PikaLimitSettings = HeatPumpLimitSettings & {
  __typename?: 'PikaLimitSettings';
  maxSinkSupplyLimitTemp: Scalars['Float']['output'];
  maxSourceLimitPress?: Maybe<Scalars['Float']['output']>;
  minSinkSupplyLimitTemp: Scalars['Float']['output'];
  minSourceLimitTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaModbusRtuHardwareConfig = {
  __typename?: 'PikaModbusRTUHardwareConfig';
  extensionBoardEnabled?: Maybe<Scalars['Boolean']['output']>;
  extensionHPEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PikaModbusTcpHardwareConfig = {
  __typename?: 'PikaModbusTCPHardwareConfig';
  serverMode?: Maybe<PikaModbusTcpServerMode>;
};

export enum PikaModbusTcpServerMode {
  Insecure = 'INSECURE',
  Off = 'OFF',
  Secure = 'SECURE'
}

export type PikaModulationLevelsState = HeatPumpModulationLevelsState & {
  __typename?: 'PikaModulationLevelsState';
  external?: Maybe<Scalars['Float']['output']>;
  heatPump?: Maybe<Scalars['Float']['output']>;
  resistanceHeater?: Maybe<Scalars['Float']['output']>;
};

export type PikaModuleActuators = HeatPumpModuleActuators & {
  __typename?: 'PikaModuleActuators';
  compressorFreq?: Maybe<Scalars['Float']['output']>;
  isCompressorRunning?: Maybe<Scalars['Boolean']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
};

export type PikaModuleData = HeatPumpModuleData & {
  __typename?: 'PikaModuleData';
  actuators: PikaModuleActuators;
  sensors: PikaModuleSensors;
  state: HeatPumpModuleState;
};

export type PikaModuleSensors = HeatPumpModuleSensors & {
  __typename?: 'PikaModuleSensors';
  condenserTemp?: Maybe<Scalars['Float']['output']>;
  dischargeLineTemp?: Maybe<Scalars['Float']['output']>;
  sinkPumpFlow?: Maybe<Scalars['Float']['output']>;
  sinkReturnTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  sourcePumpFlow?: Maybe<Scalars['Float']['output']>;
  sourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  sourceSupplyTemp?: Maybe<Scalars['Float']['output']>;
  suctionLineTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaOtExternalHardwareConfig = OtExternalHardwareConfig & {
  __typename?: 'PikaOTExternalHardwareConfig';
  canSH?: Maybe<Scalars['Boolean']['output']>;
  sinkSupplyTempOffset?: Maybe<Scalars['Float']['output']>;
};

export type PikaOnOffExternalHeaterHardwareConfig = {
  __typename?: 'PikaOnOffExternalHeaterHardwareConfig';
  canDHW?: Maybe<Scalars['Boolean']['output']>;
  canSH?: Maybe<Scalars['Boolean']['output']>;
  hasOnOffRelayAndSensor?: Maybe<Scalars['Boolean']['output']>;
  modulationPercThreshold?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTempHystLow?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTempHystUp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTempOffset?: Maybe<Scalars['Float']['output']>;
};

export type PikaOverrideSettings = HeatPumpOverrideSettings & {
  __typename?: 'PikaOverrideSettings';
  ambientTemp?: Maybe<Scalars['Float']['output']>;
  dhwTankTemp?: Maybe<Scalars['Float']['output']>;
  forceDhwValve?: Maybe<Scalars['Boolean']['output']>;
  isAmbientTempEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDhwTankTempEnabled?: Maybe<Scalars['Boolean']['output']>;
  isForceDhwValveEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSinkPumpPercEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSourcePumpPercEnabled?: Maybe<Scalars['Boolean']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
};

export type PikaPowerBudgetSettings = {
  __typename?: 'PikaPowerBudgetSettings';
  isOTThermPowerBudgetEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PikaPowerBudgetSettingsInput = {
  isOTThermPowerBudgetEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PikaPressures = {
  __typename?: 'PikaPressures';
  sink?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['Float']['output']>;
};

export type PikaProgramDefrostSettings = {
  __typename?: 'PikaProgramDefrostSettings';
  maxModulationPerc?: Maybe<Scalars['Float']['output']>;
  maxRunDuration?: Maybe<Scalars['Duration']['output']>;
  minSinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sourceSupplyDoneTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaProgramDefrostSettingsInput = {
  maxModulationPerc?: InputMaybe<Scalars['Float']['input']>;
  maxRunDuration?: InputMaybe<Scalars['Duration']['input']>;
  minSinkSupplyTemp?: InputMaybe<Scalars['Float']['input']>;
  sinkSupplySetpTemp?: InputMaybe<Scalars['Float']['input']>;
  sourceSupplyDoneTemp?: InputMaybe<Scalars['Float']['input']>;
};

export type PikaProgramSettings = {
  __typename?: 'PikaProgramSettings';
  /** Readable by all users, only admin, mechanic and expert can change it (see PikaProgramSettingsInput) */
  defrost?: Maybe<PikaProgramDefrostSettings>;
};

export type PikaProgramSettingsInput = {
  defrost?: InputMaybe<PikaProgramDefrostSettingsInput>;
};

export enum PikaProgramState {
  Defrost = 'DEFROST',
  Flushing = 'FLUSHING',
  Hwdetect = 'HWDETECT',
  Off = 'OFF',
  Shutdown = 'SHUTDOWN'
}

export type PikaPumpSettings = HeatPumpPumpSettings & {
  __typename?: 'PikaPumpSettings';
  coolingDT?: Maybe<Scalars['Float']['output']>;
  heatingDT?: Maybe<Scalars['Float']['output']>;
  maxPerc?: Maybe<Scalars['Float']['output']>;
  minPerc?: Maybe<Scalars['Float']['output']>;
  startUpPerc?: Maybe<Scalars['Float']['output']>;
};

export type PikaResistanceHeaterData = ResistanceHeaterData & {
  __typename?: 'PikaResistanceHeaterData';
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  maxModulationLevel?: Maybe<Scalars['Float']['output']>;
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export type PikaScProfileSettings = {
  __typename?: 'PikaSCProfileSettings';
  coolingCurveOffset?: Maybe<Scalars['Float']['output']>;
  maxModulationRampUpRate?: Maybe<Scalars['Float']['output']>;
};

export type PikaScProfileSettingsInput = {
  coolingCurveOffset?: InputMaybe<Scalars['Float']['input']>;
  maxModulationRampUpRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PikaShProfileSettings = {
  __typename?: 'PikaSHProfileSettings';
  heatingCurveOffset?: Maybe<Scalars['Float']['output']>;
  maxModulationPerc?: Maybe<Scalars['Float']['output']>;
  maxModulationRampUpRate?: Maybe<Scalars['Float']['output']>;
};

export type PikaShProfileSettingsInput = {
  heatingCurveOffset?: InputMaybe<Scalars['Float']['input']>;
  maxModulationPerc?: InputMaybe<Scalars['Float']['input']>;
  maxModulationRampUpRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PikaScheduleItemSetting = {
  __typename?: 'PikaScheduleItemSetting';
  days: Array<Weekday>;
  force?: Maybe<Scalars['Boolean']['output']>;
  from: Scalars['Duration']['output'];
  profile: PikaScheduleProfile;
  to: Scalars['Duration']['output'];
};

export type PikaScheduleItemSettingInput = {
  days: Array<Weekday>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['Duration']['input'];
  profile: PikaScheduleProfile;
  to: Scalars['Duration']['input'];
};

export enum PikaScheduleProfile {
  Blocking = 'BLOCKING',
  Comfort = 'COMFORT',
  Economy = 'ECONOMY',
  Normal = 'NORMAL'
}

export type PikaSettings = HeatPumpSettings & {
  __typename?: 'PikaSettings';
  auxIO: PikaAuxIoSettings;
  circuit1: PikaCircuitSettings;
  compressor: PikaCompressorSettings;
  dhw: PikaDhwSettings;
  dhwUnlockSettings: PikaDhwHeatSourceUnlockSettings;
  general: PikaGeneralSettings;
  hardware: PikaHardwareSettings;
  limits: PikaLimitSettings;
  overrides: PikaOverrideSettings;
  powerBudget: PikaPowerBudgetSettings;
  program?: Maybe<PikaProgramSettings>;
  sinkPump: PikaPumpSettings;
  sourcePump: PikaPumpSettings;
  spaceConditioning: PikaSpaceConditioningSettings;
  spaceHeatingUnlockSettings: PikaSpaceHeatingHeatSourceUnlockSettings;
};

export enum PikaSinkCircuitType {
  Direct = 'DIRECT',
  ParallelBuffer = 'PARALLEL_BUFFER'
}

export type PikaSoftwareVersion = {
  __typename?: 'PikaSoftwareVersion';
  available: Scalars['Boolean']['output'];
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  version: Scalars['String']['output'];
};

export enum PikaSpaceConditioningControlType {
  Curve = 'CURVE',
  Modbus = 'MODBUS',
  OnOffCurve = 'ON_OFF_CURVE',
  OnOffFixedSinkSupplyTemp = 'ON_OFF_FIXED_SINK_SUPPLY_TEMP',
  Opentherm = 'OPENTHERM'
}

export type PikaSpaceConditioningSettings = HeatPumpSpaceConditioningSettings & {
  __typename?: 'PikaSpaceConditioningSettings';
  isCoolingEnabled: Scalars['Boolean']['output'];
  isHeatingEnabled: Scalars['Boolean']['output'];
  spaceCoolingProfile?: Maybe<PikaScheduleProfile>;
  spaceCoolingProfileComfort?: Maybe<PikaScProfileSettings>;
  spaceCoolingProfileEco?: Maybe<PikaScProfileSettings>;
  spaceCoolingProfileNormal?: Maybe<PikaScProfileSettings>;
  spaceCoolingSchedulerEnabled?: Maybe<Scalars['Boolean']['output']>;
  spaceCoolingSchedulerEntries?: Maybe<Array<PikaScheduleItemSetting>>;
  spaceCoolingSinkCircuitType?: Maybe<PikaSinkCircuitType>;
  spaceHeatingProfile?: Maybe<PikaScheduleProfile>;
  spaceHeatingProfileComfort?: Maybe<PikaShProfileSettings>;
  spaceHeatingProfileEco?: Maybe<PikaShProfileSettings>;
  spaceHeatingProfileNormal?: Maybe<PikaShProfileSettings>;
  spaceHeatingSchedulerEnabled?: Maybe<Scalars['Boolean']['output']>;
  spaceHeatingSchedulerEntries?: Maybe<Array<PikaScheduleItemSetting>>;
  spaceHeatingSinkCircuitType?: Maybe<PikaSinkCircuitType>;
};

export type PikaSpaceHeatingHeatSourceUnlockSettings = {
  __typename?: 'PikaSpaceHeatingHeatSourceUnlockSettings';
  otExternalBivalentConfigAmbientTemp?: Maybe<Scalars['Float']['output']>;
  otExternalBivalentConfigEnabled?: Maybe<Scalars['Boolean']['output']>;
  otExternalBivalentConfigSourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  otExternalUnlockPolicyType?: Maybe<HeatSourceUnlockPolicyType>;
  otExternalWaitTimeMinutes?: Maybe<Scalars['Int']['output']>;
  resistanceHeaterBivalentConfigAmbientTemp?: Maybe<Scalars['Float']['output']>;
  resistanceHeaterBivalentConfigEnabled?: Maybe<Scalars['Boolean']['output']>;
  resistanceHeaterBivalentConfigSourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  resistanceHeaterUnlockPolicyType?: Maybe<HeatSourceUnlockPolicyType>;
  resistanceHeaterWaitTimeMinutes?: Maybe<Scalars['Int']['output']>;
};

export type PikaStatistics = {
  __typename?: 'PikaStatistics';
  coolingTotalElectricEnergyConsumedkWh?: Maybe<Scalars['Float']['output']>;
  coolingTotalThermalEnergyProducedkWh?: Maybe<Scalars['Float']['output']>;
  cop?: Maybe<Scalars['Float']['output']>;
  dhwTotalElectricEnergyConsumedkWh?: Maybe<Scalars['Float']['output']>;
  dhwTotalThermalEnergyProducedkWh?: Maybe<Scalars['Float']['output']>;
  electricPowerkW?: Maybe<Scalars['Float']['output']>;
  spaceHeatingTotalElectricEnergyConsumedkWh?: Maybe<Scalars['Float']['output']>;
  spaceHeatingTotalThermalEnergyProducedkWh?: Maybe<Scalars['Float']['output']>;
  thermalSinkPowerkW?: Maybe<Scalars['Float']['output']>;
};

export type PikaTimeSeriesEntry = HeatPumpTimeSeriesEntry & {
  __typename?: 'PikaTimeSeriesEntry';
  alerts: Array<HeatPumpAlert>;
  controller: PikaControllerState;
  externalDevice: PikaExternalDeviceData;
  heatPumpModule: PikaModuleData;
  pressures: PikaPressures;
  resistanceHeater: PikaResistanceHeaterData;
  statistics: PikaStatistics;
  timestamp: Scalars['Time']['output'];
};

export enum PvtHeatPumpAuxRelayMode {
  Off = 'OFF',
  Opentherm = 'OPENTHERM',
  Smatrix = 'SMATRIX',
  Unset = 'UNSET'
}

export type PvtHeatPumpData = {
  __typename?: 'PvtHeatPumpData';
  auxInputTemp?: Maybe<Scalars['Float']['output']>;
  auxRelayMode?: Maybe<PvtHeatPumpAuxRelayMode>;
  auxRelayOverride?: Maybe<Scalars['Boolean']['output']>;
  backupByErrorEnabled?: Maybe<Scalars['Boolean']['output']>;
  boostSinkTemp?: Maybe<Scalars['Float']['output']>;
  boostSourceTemp?: Maybe<Scalars['Float']['output']>;
  bt1OverrideValue?: Maybe<Scalars['Float']['output']>;
  bt2OverrideValue?: Maybe<Scalars['Float']['output']>;
  bt3OverrideValue?: Maybe<Scalars['Float']['output']>;
  bt4OverrideValue?: Maybe<Scalars['Float']['output']>;
  bt5OverrideValue?: Maybe<Scalars['Float']['output']>;
  bt6OverrideValue?: Maybe<Scalars['Float']['output']>;
  bt7OverrideValue?: Maybe<Scalars['Float']['output']>;
  btAux1OverrideValue?: Maybe<Scalars['Float']['output']>;
  btAux2OverrideValue?: Maybe<Scalars['Float']['output']>;
  btAux3OverrideValue?: Maybe<Scalars['Float']['output']>;
  compressorDischarge?: Maybe<Scalars['Float']['output']>;
  compressorOffTime?: Maybe<Scalars['Int']['output']>;
  compressorOffToOnDelaySec?: Maybe<Scalars['Int']['output']>;
  compressorOn?: Maybe<Scalars['Boolean']['output']>;
  condenserMaxTemp?: Maybe<Scalars['Float']['output']>;
  condenserNoCapDt?: Maybe<Scalars['Float']['output']>;
  condenserNoRefigDt?: Maybe<Scalars['Float']['output']>;
  coolingCurve?: Maybe<Scalars['Int']['output']>;
  coolingCurveOffset?: Maybe<Scalars['Int']['output']>;
  coolingValveEnabled?: Maybe<Scalars['Boolean']['output']>;
  curTimeDate?: Maybe<Scalars['Int']['output']>;
  curTimeDay?: Maybe<Scalars['Int']['output']>;
  curTimeHour?: Maybe<Scalars['Int']['output']>;
  curTimeMin?: Maybe<Scalars['Int']['output']>;
  curTimeMonth?: Maybe<Scalars['Int']['output']>;
  curTimeYear?: Maybe<Scalars['Int']['output']>;
  daylightSavingEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwActiveEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwActiveOrCombinedMinTime?: Maybe<Scalars['Int']['output']>;
  dhwActiveSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  dhwActiveSourceDeltaT?: Maybe<Scalars['Float']['output']>;
  dhwAutoTemp?: Maybe<Scalars['Float']['output']>;
  dhwBackupEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwBoilerTemp?: Maybe<Scalars['Float']['output']>;
  dhwBoostEnabled?: Maybe<Scalars['Boolean']['output']>;
  dhwBoostTemp?: Maybe<Scalars['Float']['output']>;
  dhwCombinedEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwCombinedSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  dhwDemand?: Maybe<Scalars['Boolean']['output']>;
  dhwEcoTemp?: Maybe<Scalars['Float']['output']>;
  dhwHysteresisLowerBound?: Maybe<Scalars['Float']['output']>;
  dhwHysteresisUpperBound?: Maybe<Scalars['Float']['output']>;
  dhwLegionelaDay?: Maybe<PvtHeatPumpDhwLegionelaDay>;
  dhwLegionelaEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwLegionelaTemp?: Maybe<Scalars['Float']['output']>;
  dhwLegionellaMaxCondensationTemp?: Maybe<Scalars['Float']['output']>;
  dhwMode?: Maybe<PvtHeatPumpDhwMode>;
  dhwPassiveEnable?: Maybe<Scalars['Boolean']['output']>;
  dhwPauseTime?: Maybe<Scalars['Int']['output']>;
  dhwPriorityTimeMin?: Maybe<Scalars['Int']['output']>;
  dhwScheduler?: Maybe<DhwScheduler>;
  dhwSinkMaxTemp?: Maybe<Scalars['Float']['output']>;
  dhwSinkMinTemp?: Maybe<Scalars['Float']['output']>;
  dhwState?: Maybe<PvtHeatPumpDhwState>;
  disableErrorDetect?: Maybe<Scalars['Boolean']['output']>;
  dmBoostHeating?: Maybe<Scalars['Int']['output']>;
  dmCoolingThreshold?: Maybe<Scalars['Int']['output']>;
  dmHeatingThreshold?: Maybe<Scalars['Int']['output']>;
  dmSc?: Maybe<Scalars['Int']['output']>;
  dmSh?: Maybe<Scalars['Int']['output']>;
  dmTOutdoorBoostHeating?: Maybe<Scalars['Float']['output']>;
  dmTOutdoorScEnable?: Maybe<Scalars['Float']['output']>;
  dmTOutdoorShEnable?: Maybe<Scalars['Float']['output']>;
  eb1ElectricHeaterRelayOverride?: Maybe<Scalars['Boolean']['output']>;
  electricElementOn?: Maybe<Scalars['Boolean']['output']>;
  enableSgInput?: Maybe<Scalars['Boolean']['output']>;
  envelopeBackupDhwGoBackHystTemp?: Maybe<Scalars['Float']['output']>;
  envelopeBackupShGoBackHystTemp?: Maybe<Scalars['Float']['output']>;
  envelopeBackupSourceHighTemp?: Maybe<Scalars['Float']['output']>;
  envelopeBackupSourceLowTemp?: Maybe<Scalars['Float']['output']>;
  envelopeSinkHighTemp?: Maybe<Scalars['Float']['output']>;
  envelopeSinkLowTemp?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Array<Scalars['Int']['output']>>;
  evapMaxTempHeating?: Maybe<Scalars['Float']['output']>;
  evapMinBt2HeatTemp?: Maybe<Scalars['Float']['output']>;
  evapNoCapDt?: Maybe<Scalars['Float']['output']>;
  evapNoRefigDt?: Maybe<Scalars['Float']['output']>;
  firmwareVersion?: Maybe<Scalars['Float']['output']>;
  flushingMode?: Maybe<PvtHeatPumpFlushingMode>;
  flushingPumpOffTimeSec?: Maybe<Scalars['Int']['output']>;
  flushingPumpOnTimeSec?: Maybe<Scalars['Int']['output']>;
  gp1Gp2PumpRelayOverride?: Maybe<Scalars['Boolean']['output']>;
  gp1PumpSourcePwmOverride?: Maybe<Scalars['Float']['output']>;
  gp2PumpSinkPwmOverride?: Maybe<Scalars['Float']['output']>;
  gq1Compressor1Override?: Maybe<Scalars['Boolean']['output']>;
  gq1Compressor2Override?: Maybe<Scalars['Boolean']['output']>;
  hasOnOffThermostatDemand?: Maybe<Scalars['Boolean']['output']>;
  heatSinkMode?: Maybe<PvtHeatPumpHeatSinkMode>;
  heatSourceMode?: Maybe<PvtHeatPumpHeatSourceMode>;
  heatingCurve?: Maybe<Scalars['Int']['output']>;
  heatingCurveOffset?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  inputOverrideMask?: Maybe<Array<PvtHeatPumpInputOverrideMask>>;
  maxCondensationTemp?: Maybe<Scalars['Float']['output']>;
  maxDischargeTemp?: Maybe<Scalars['Float']['output']>;
  maxLiquidlineCoolTemp?: Maybe<Scalars['Float']['output']>;
  minEvapCoolTemp?: Maybe<Scalars['Float']['output']>;
  outdoorHiTemp?: Maybe<Scalars['Float']['output']>;
  outdoorTempFilterTime?: Maybe<Scalars['Int']['output']>;
  outputOverrideMask?: Maybe<Array<PvtHeatPumpOutputOverrideMask>>;
  pasiveOperationMinSourceTemp?: Maybe<Scalars['Float']['output']>;
  passiveMinDeltaT?: Maybe<Scalars['Float']['output']>;
  pauseTimeMin?: Maybe<Scalars['Int']['output']>;
  preheatDeltaT?: Maybe<Scalars['Float']['output']>;
  pumpPiRegulatorGain?: Maybe<Scalars['Float']['output']>;
  pumpPiRegulatorIntegrationTimeSec?: Maybe<Scalars['Float']['output']>;
  pumpRelayOn?: Maybe<Scalars['Boolean']['output']>;
  qn2HeatSourceValveOverride?: Maybe<Scalars['Float']['output']>;
  qn3HeatSinkValveOverride?: Maybe<Scalars['Float']['output']>;
  qn44WayValveRelayOverride?: Maybe<Scalars['Boolean']['output']>;
  roomControlType?: Maybe<PvtHeatPumpRoomControlType>;
  roomTemperatureControl?: Maybe<PvtHeatPumpRoomTemperatureControl>;
  scActiveEnable?: Maybe<Scalars['Boolean']['output']>;
  scActiveSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  scActiveSourceDeltaT?: Maybe<Scalars['Float']['output']>;
  scCombineEnable?: Maybe<Scalars['Boolean']['output']>;
  scCombinedSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  scPasiveEnable?: Maybe<Scalars['Boolean']['output']>;
  scPassiveSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  scPriorityTimeMin?: Maybe<Scalars['Int']['output']>;
  scRoomHysteresisTemp?: Maybe<Scalars['Float']['output']>;
  scRoomSetpTemp?: Maybe<Scalars['Float']['output']>;
  sgAffectDhw?: Maybe<Scalars['Boolean']['output']>;
  sgAffectSc?: Maybe<Scalars['Boolean']['output']>;
  sgAffectSh?: Maybe<Scalars['Boolean']['output']>;
  sgAllowBhDhw?: Maybe<Scalars['Boolean']['output']>;
  sgAllowBhSh?: Maybe<Scalars['Boolean']['output']>;
  shActiveEnable?: Maybe<Scalars['Boolean']['output']>;
  shActiveSourceDeltaT?: Maybe<Scalars['Float']['output']>;
  shBackupEnable?: Maybe<Scalars['Boolean']['output']>;
  shBoostEnabled?: Maybe<Scalars['Boolean']['output']>;
  shCombineEnable?: Maybe<Scalars['Boolean']['output']>;
  shFloorActiveSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  shFloorCombinedSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  shPasiveEnable?: Maybe<Scalars['Boolean']['output']>;
  shPriorityTimeMin?: Maybe<Scalars['Int']['output']>;
  shRadiatorActiveSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  shRadiatorCombinedSinkDeltaT?: Maybe<Scalars['Float']['output']>;
  shRoomHysteresisTemp?: Maybe<Scalars['Float']['output']>;
  shRoomSetpTemp?: Maybe<Scalars['Float']['output']>;
  shType?: Maybe<PvtHeatPumpShType>;
  sinkCoolingPauseThresholdHystTemp?: Maybe<Scalars['Float']['output']>;
  sinkCoolingPauseThresholdTemp?: Maybe<Scalars['Float']['output']>;
  sinkInTemp?: Maybe<Scalars['Float']['output']>;
  sinkMaxShTemp?: Maybe<Scalars['Float']['output']>;
  sinkMinShTemp?: Maybe<Scalars['Float']['output']>;
  sinkOutTemp?: Maybe<Scalars['Float']['output']>;
  sinkPumpMaxSpeedPerc?: Maybe<Scalars['Float']['output']>;
  sinkPumpMinSpeedPerc?: Maybe<Scalars['Float']['output']>;
  sinkPumpPerc?: Maybe<Scalars['Float']['output']>;
  sinkReturnBeforeHP?: Maybe<Scalars['Float']['output']>;
  sinkSupplyBeforeBackup?: Maybe<Scalars['Float']['output']>;
  sourceInTemp?: Maybe<Scalars['Float']['output']>;
  sourceMaxTemp?: Maybe<Scalars['Float']['output']>;
  sourceMinTemp?: Maybe<Scalars['Float']['output']>;
  sourceOutTemp?: Maybe<Scalars['Float']['output']>;
  sourcePumpMaxSpeedPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpMinSpeedPerc?: Maybe<Scalars['Float']['output']>;
  sourcePumpPerc?: Maybe<Scalars['Float']['output']>;
  spaceActiveOrCombinedMinTime?: Maybe<Scalars['Int']['output']>;
  spaceCoolDemand?: Maybe<Scalars['Boolean']['output']>;
  spaceHeatDemand?: Maybe<Scalars['Boolean']['output']>;
  spaceHeatingCoolingPauseTime?: Maybe<Scalars['Int']['output']>;
  spaceHeatingCoolingState?: Maybe<PvtHeatPumpSpaceHeatingCoolingState>;
  startupCountdown?: Maybe<Scalars['Int']['output']>;
  startupTimeSec?: Maybe<Scalars['Int']['output']>;
  supplyTemp0CustomHeating?: Maybe<Scalars['Float']['output']>;
  supplyTemp10CustomHeating?: Maybe<Scalars['Float']['output']>;
  supplyTemp20CustomCooling?: Maybe<Scalars['Float']['output']>;
  supplyTemp20CustomHeating?: Maybe<Scalars['Float']['output']>;
  supplyTemp30CustomCooling?: Maybe<Scalars['Float']['output']>;
  supplyTemp30CustomHeating?: Maybe<Scalars['Float']['output']>;
  supplyTemp40CustomCooling?: Maybe<Scalars['Float']['output']>;
  supplyTempAtHiOutdoorTemp?: Maybe<Scalars['Float']['output']>;
  supplyTempAtLowOutdoorTemp?: Maybe<Scalars['Float']['output']>;
  supplyTempMin10CustomHeating?: Maybe<Scalars['Float']['output']>;
  supplyTempMin20CustomHeating?: Maybe<Scalars['Float']['output']>;
  supplyTempMin30CustomHeating?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['Time']['output'];
  valveCyclingEnabled?: Maybe<Scalars['Boolean']['output']>;
  valveCyclingStandbyThreshold?: Maybe<Scalars['Int']['output']>;
  valveCyclingTimeThreshold?: Maybe<Scalars['Int']['output']>;
};

export enum PvtHeatPumpDhwLegionelaDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum PvtHeatPumpDhwMode {
  Auto = 'AUTO',
  Boost = 'BOOST',
  Eco = 'ECO',
  Holiday = 'HOLIDAY',
  Off = 'OFF'
}

export enum PvtHeatPumpDhwState {
  Active = 'ACTIVE',
  Backup = 'BACKUP',
  Boost = 'BOOST',
  Combined = 'COMBINED',
  Off = 'OFF',
  Passive = 'PASSIVE',
  Pause = 'PAUSE',
  StartUp = 'START_UP'
}

export enum PvtHeatPumpFlushingMode {
  Balancing = 'BALANCING',
  Flushing = 'FLUSHING',
  Off = 'OFF'
}

export enum PvtHeatPumpHeatSinkMode {
  Dhw = 'DHW',
  Mixed = 'MIXED',
  Sh = 'SH'
}

export enum PvtHeatPumpHeatSourceMode {
  Active = 'ACTIVE',
  Mixed = 'MIXED',
  Passive = 'PASSIVE'
}

export type PvtHeatPumpInput = {
  auxRelayMode?: InputMaybe<PvtHeatPumpAuxRelayMode>;
  auxRelayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  backupByErrorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  boostSinkTemp?: InputMaybe<Scalars['Float']['input']>;
  boostSourceTemp?: InputMaybe<Scalars['Float']['input']>;
  bt1OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  bt2OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  bt3OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  bt4OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  bt5OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  bt6OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  bt7OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  btAux1OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  btAux2OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  btAux3OverrideValue?: InputMaybe<Scalars['Float']['input']>;
  compressorOffToOnDelaySec?: InputMaybe<Scalars['Int']['input']>;
  condenserMaxTemp?: InputMaybe<Scalars['Float']['input']>;
  condenserNoCapDt?: InputMaybe<Scalars['Float']['input']>;
  condenserNoRefigDt?: InputMaybe<Scalars['Float']['input']>;
  coolingCurve?: InputMaybe<Scalars['Int']['input']>;
  coolingCurveOffset?: InputMaybe<Scalars['Int']['input']>;
  curTimeDate?: InputMaybe<Scalars['Int']['input']>;
  curTimeDay?: InputMaybe<Scalars['Int']['input']>;
  curTimeHour?: InputMaybe<Scalars['Int']['input']>;
  curTimeMin?: InputMaybe<Scalars['Int']['input']>;
  curTimeMonth?: InputMaybe<Scalars['Int']['input']>;
  curTimeYear?: InputMaybe<Scalars['Int']['input']>;
  daylightSavingEnable?: InputMaybe<Scalars['Boolean']['input']>;
  dhwActiveEnable?: InputMaybe<Scalars['Boolean']['input']>;
  dhwActiveOrCombinedMinTime?: InputMaybe<Scalars['Int']['input']>;
  dhwActiveSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  dhwActiveSourceDeltaT?: InputMaybe<Scalars['Float']['input']>;
  dhwAutoTemp?: InputMaybe<Scalars['Float']['input']>;
  dhwBackupEnable?: InputMaybe<Scalars['Boolean']['input']>;
  dhwBoostEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dhwBoostTemp?: InputMaybe<Scalars['Float']['input']>;
  dhwCombinedEnable?: InputMaybe<Scalars['Boolean']['input']>;
  dhwCombinedSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  dhwEcoTemp?: InputMaybe<Scalars['Float']['input']>;
  dhwHysteresisLowerBound?: InputMaybe<Scalars['Float']['input']>;
  dhwHysteresisUpperBound?: InputMaybe<Scalars['Float']['input']>;
  dhwLegionelaDay?: InputMaybe<PvtHeatPumpDhwLegionelaDay>;
  dhwLegionelaEnable?: InputMaybe<Scalars['Boolean']['input']>;
  dhwLegionelaTemp?: InputMaybe<Scalars['Float']['input']>;
  dhwLegionellaMaxCondensationTemp?: InputMaybe<Scalars['Float']['input']>;
  dhwMode?: InputMaybe<PvtHeatPumpDhwMode>;
  dhwPassiveEnable?: InputMaybe<Scalars['Boolean']['input']>;
  dhwPriorityTimeMin?: InputMaybe<Scalars['Int']['input']>;
  dhwSinkMaxTemp?: InputMaybe<Scalars['Float']['input']>;
  dhwSinkMinTemp?: InputMaybe<Scalars['Float']['input']>;
  disableErrorDetect?: InputMaybe<Scalars['Boolean']['input']>;
  dmBoostHeating?: InputMaybe<Scalars['Int']['input']>;
  dmCoolingThreshold?: InputMaybe<Scalars['Int']['input']>;
  dmHeatingThreshold?: InputMaybe<Scalars['Int']['input']>;
  dmTOutdoorBoostHeating?: InputMaybe<Scalars['Float']['input']>;
  dmTOutdoorScEnable?: InputMaybe<Scalars['Float']['input']>;
  dmTOutdoorShEnable?: InputMaybe<Scalars['Float']['input']>;
  eb1ElectricHeaterRelayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  enableSgInput?: InputMaybe<Scalars['Boolean']['input']>;
  envelopeBackupDhwGoBackHystTemp?: InputMaybe<Scalars['Float']['input']>;
  envelopeBackupShGoBackHystTemp?: InputMaybe<Scalars['Float']['input']>;
  envelopeBackupSourceHighTemp?: InputMaybe<Scalars['Float']['input']>;
  envelopeBackupSourceLowTemp?: InputMaybe<Scalars['Float']['input']>;
  envelopeSinkHighTemp?: InputMaybe<Scalars['Float']['input']>;
  envelopeSinkLowTemp?: InputMaybe<Scalars['Float']['input']>;
  evapMaxTempHeating?: InputMaybe<Scalars['Float']['input']>;
  evapMinBt2HeatTemp?: InputMaybe<Scalars['Float']['input']>;
  evapNoCapDt?: InputMaybe<Scalars['Float']['input']>;
  evapNoRefigDt?: InputMaybe<Scalars['Float']['input']>;
  flushingMode?: InputMaybe<PvtHeatPumpFlushingMode>;
  flushingPumpOffTimeSec?: InputMaybe<Scalars['Int']['input']>;
  flushingPumpOnTimeSec?: InputMaybe<Scalars['Int']['input']>;
  gp1Gp2PumpRelayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  gp1PumpSourcePwmOverride?: InputMaybe<Scalars['Float']['input']>;
  gp2PumpSinkPwmOverride?: InputMaybe<Scalars['Float']['input']>;
  gq1Compressor1Override?: InputMaybe<Scalars['Boolean']['input']>;
  gq1Compressor2Override?: InputMaybe<Scalars['Boolean']['input']>;
  heatingCurve?: InputMaybe<Scalars['Int']['input']>;
  heatingCurveOffset?: InputMaybe<Scalars['Int']['input']>;
  inputOverrideMask?: InputMaybe<Array<PvtHeatPumpInputOverrideMask>>;
  maxCondensationTemp?: InputMaybe<Scalars['Float']['input']>;
  maxDischargeTemp?: InputMaybe<Scalars['Float']['input']>;
  maxLiquidlineCoolTemp?: InputMaybe<Scalars['Float']['input']>;
  minEvapCoolTemp?: InputMaybe<Scalars['Float']['input']>;
  outdoorHiTemp?: InputMaybe<Scalars['Float']['input']>;
  outdoorTempFilterTime?: InputMaybe<Scalars['Int']['input']>;
  outputOverrideMask?: InputMaybe<Array<PvtHeatPumpOutputOverrideMask>>;
  pasiveOperationMinSourceTemp?: InputMaybe<Scalars['Float']['input']>;
  passiveMinDeltaT?: InputMaybe<Scalars['Float']['input']>;
  pauseTimeMin?: InputMaybe<Scalars['Int']['input']>;
  preheatDeltaT?: InputMaybe<Scalars['Float']['input']>;
  pumpPiRegulatorGain?: InputMaybe<Scalars['Float']['input']>;
  pumpPiRegulatorIntegrationTimeSec?: InputMaybe<Scalars['Float']['input']>;
  qn2HeatSourceValveOverride?: InputMaybe<Scalars['Float']['input']>;
  qn3HeatSinkValveOverride?: InputMaybe<Scalars['Float']['input']>;
  qn44WayValveRelayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  resetErrors?: InputMaybe<Scalars['Boolean']['input']>;
  restartUnit?: InputMaybe<Scalars['Boolean']['input']>;
  roomControlType?: InputMaybe<PvtHeatPumpRoomControlType>;
  roomTemperatureControl?: InputMaybe<PvtHeatPumpRoomTemperatureControl>;
  scActiveEnable?: InputMaybe<Scalars['Boolean']['input']>;
  scActiveSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  scActiveSourceDeltaT?: InputMaybe<Scalars['Float']['input']>;
  scCombineEnable?: InputMaybe<Scalars['Boolean']['input']>;
  scCombinedSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  scPasiveEnable?: InputMaybe<Scalars['Boolean']['input']>;
  scPassiveSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  scPriorityTimeMin?: InputMaybe<Scalars['Int']['input']>;
  scRoomHysteresisTemp?: InputMaybe<Scalars['Float']['input']>;
  scRoomSetpTemp?: InputMaybe<Scalars['Float']['input']>;
  sgAffectDhw?: InputMaybe<Scalars['Boolean']['input']>;
  sgAffectSc?: InputMaybe<Scalars['Boolean']['input']>;
  sgAffectSh?: InputMaybe<Scalars['Boolean']['input']>;
  sgAllowBhDhw?: InputMaybe<Scalars['Boolean']['input']>;
  sgAllowBhSh?: InputMaybe<Scalars['Boolean']['input']>;
  shActiveEnable?: InputMaybe<Scalars['Boolean']['input']>;
  shActiveSourceDeltaT?: InputMaybe<Scalars['Float']['input']>;
  shBackupEnable?: InputMaybe<Scalars['Boolean']['input']>;
  shBoostEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  shCombineEnable?: InputMaybe<Scalars['Boolean']['input']>;
  shFloorActiveSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  shFloorCombinedSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  shPasiveEnable?: InputMaybe<Scalars['Boolean']['input']>;
  shPriorityTimeMin?: InputMaybe<Scalars['Int']['input']>;
  shRadiatorActiveSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  shRadiatorCombinedSinkDeltaT?: InputMaybe<Scalars['Float']['input']>;
  shRoomHysteresisTemp?: InputMaybe<Scalars['Float']['input']>;
  shRoomSetpTemp?: InputMaybe<Scalars['Float']['input']>;
  shType?: InputMaybe<PvtHeatPumpShType>;
  sinkCoolingPauseThresholdHystTemp?: InputMaybe<Scalars['Float']['input']>;
  sinkCoolingPauseThresholdTemp?: InputMaybe<Scalars['Float']['input']>;
  sinkMaxShTemp?: InputMaybe<Scalars['Float']['input']>;
  sinkMinShTemp?: InputMaybe<Scalars['Float']['input']>;
  sinkPumpMaxSpeedPerc?: InputMaybe<Scalars['Float']['input']>;
  sinkPumpMinSpeedPerc?: InputMaybe<Scalars['Float']['input']>;
  sourceMaxTemp?: InputMaybe<Scalars['Float']['input']>;
  sourceMinTemp?: InputMaybe<Scalars['Float']['input']>;
  sourcePumpMaxSpeedPerc?: InputMaybe<Scalars['Float']['input']>;
  sourcePumpMinSpeedPerc?: InputMaybe<Scalars['Float']['input']>;
  spaceActiveOrCombinedMinTime?: InputMaybe<Scalars['Int']['input']>;
  startupTimeSec?: InputMaybe<Scalars['Int']['input']>;
  supplyTemp0CustomHeating?: InputMaybe<Scalars['Float']['input']>;
  supplyTemp10CustomHeating?: InputMaybe<Scalars['Float']['input']>;
  supplyTemp20CustomCooling?: InputMaybe<Scalars['Float']['input']>;
  supplyTemp20CustomHeating?: InputMaybe<Scalars['Float']['input']>;
  supplyTemp30CustomCooling?: InputMaybe<Scalars['Float']['input']>;
  supplyTemp30CustomHeating?: InputMaybe<Scalars['Float']['input']>;
  supplyTemp40CustomCooling?: InputMaybe<Scalars['Float']['input']>;
  supplyTempAtHiOutdoorTemp?: InputMaybe<Scalars['Float']['input']>;
  supplyTempAtLowOutdoorTemp?: InputMaybe<Scalars['Float']['input']>;
  supplyTempMin10CustomHeating?: InputMaybe<Scalars['Float']['input']>;
  supplyTempMin20CustomHeating?: InputMaybe<Scalars['Float']['input']>;
  supplyTempMin30CustomHeating?: InputMaybe<Scalars['Float']['input']>;
};

export enum PvtHeatPumpInputOverrideMask {
  Bt_1 = 'BT_1',
  Bt_2 = 'BT_2',
  Bt_3 = 'BT_3',
  Bt_4 = 'BT_4',
  Bt_5 = 'BT_5',
  Bt_6 = 'BT_6',
  Bt_7 = 'BT_7',
  BtAux_1 = 'BT_AUX_1',
  BtAux_2 = 'BT_AUX_2',
  BtAux_3 = 'BT_AUX_3'
}

export enum PvtHeatPumpOutputOverrideMask {
  AuxRelay = 'AUX_RELAY',
  Eb_1ElectricHeaterRelay = 'EB_1_ELECTRIC_HEATER_RELAY',
  Gp_1Gp_2PumpRelay = 'GP_1_GP_2_PUMP_RELAY',
  Gp_1PumpSourcePwm = 'GP_1_PUMP_SOURCE_PWM',
  Gp_2PumpSinkPwm = 'GP_2_PUMP_SINK_PWM',
  Gq_1Compressor_1 = 'GQ_1_COMPRESSOR_1',
  Gq_1Compressor_2 = 'GQ_1_COMPRESSOR_2',
  Qn_2HeatSourceValve = 'QN_2_HEAT_SOURCE_VALVE',
  Qn_3HeatSinkValve = 'QN_3_HEAT_SINK_VALVE',
  Qn_4_4WayValveRelay = 'QN_4_4_WAY_VALVE_RELAY'
}

export enum PvtHeatPumpPrioritySchedulerSg {
  Scheduler = 'SCHEDULER',
  SgReady = 'SG_READY'
}

export enum PvtHeatPumpRoomControlType {
  DmControl = 'DM_CONTROL',
  Opentherm = 'OPENTHERM',
  RoomSensor = 'ROOM_SENSOR',
  Thermostat = 'THERMOSTAT'
}

export enum PvtHeatPumpRoomTemperatureControl {
  Cooling = 'COOLING',
  Heating = 'HEATING',
  HeatingAndCooling = 'HEATING_AND_COOLING',
  Off = 'OFF'
}

export enum PvtHeatPumpSchedulerCopyToAll {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Unused = 'UNUSED',
  Wednesday = 'WEDNESDAY'
}

export enum PvtHeatPumpSchedulerDhwMode {
  Auto = 'AUTO',
  Boost = 'BOOST',
  Eco = 'ECO',
  HighTemp = 'HIGH_TEMP',
  NoChange = 'NO_CHANGE'
}

export enum PvtHeatPumpSchedulerProfile {
  NotActive = 'NOT_ACTIVE',
  Profile_1 = 'PROFILE_1',
  Profile_2 = 'PROFILE_2',
  Profile_3 = 'PROFILE_3',
  Profile_4 = 'PROFILE_4',
  Profile_5 = 'PROFILE_5'
}

export enum PvtHeatPumpShType {
  Floor = 'FLOOR',
  Radiator = 'RADIATOR'
}

export enum PvtHeatPumpSpaceHeatingCoolingState {
  ActiveCool = 'ACTIVE_COOL',
  ActiveHeat = 'ACTIVE_HEAT',
  BackupHeat = 'BACKUP_HEAT',
  BoostHeat = 'BOOST_HEAT',
  CombinedCool = 'COMBINED_COOL',
  CombinedHeat = 'COMBINED_HEAT',
  CoolPause = 'COOL_PAUSE',
  HeatPause = 'HEAT_PAUSE',
  Off = 'OFF',
  PassiveCool = 'PASSIVE_COOL',
  PassiveHeat = 'PASSIVE_HEAT',
  Standby = 'STANDBY',
  Startup = 'STARTUP'
}

export type Query = {
  __typename?: 'Query';
  /** Historical alerts of the heat pump */
  alertHistory: HeatPumpAlertHistory;
  allHeatPumps: Array<HeatPump>;
  dateRange: DateRange;
  getInterfaceFirmwareUpdates: Array<InterfaceFirmwareVersion>;
  getMantovaFirmwareUpdates: Array<MantovaFirmwareVersion>;
  getPikaUpdates: Array<PikaSoftwareVersion>;
  /** Query a specific group by groupID */
  group: Group;
  /** Transfer to a different group information */
  groupTransferInformation: GroupTransferInformation;
  /** Query all registered groups */
  groups: Array<Group>;
  /** Get a single heat pump if it exists and the user has access */
  heatPump: HeatPump;
  /** Gets the current owner of the heat pump */
  heatPumpOwner?: Maybe<Group>;
  heatPumpPageFilter: HeatPumpPageFilter;
  /** Query the changelog of the heat pump. It lists all settings and how they where changed. */
  heatPumpSettingsChangeLog: Array<Change>;
  /** Get all heat pumps the current user has access to */
  heatPumps: Array<HeatPump>;
  /** Query a single Interface by Interface ID (everyone is allowed when you know the interfaceID) */
  interface?: Maybe<Interface>;
  /** Query all Interfaces the current user has access to */
  interfaces: Array<Interface>;
  logPeriod: LogPeriod;
  /** Query the currently logged in user */
  me: User;
  /** Query notifications for this user. Only admins are allowed to query expired notifications */
  notifications: Array<Notification>;
  settingsPageFilter: SettingsPageFilter;
  /** Time series logs of the heat pump */
  timeSeries: HeatPumpTimeSeries;
  /** Query users by role. If no roles specified, all users are returned */
  users: Array<User>;
};


export type QueryAlertHistoryArgs = {
  from: Scalars['Time']['input'];
  id: Scalars['String']['input'];
  until?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryAllHeatPumpsArgs = {
  hpType: HeatPumpType;
};


export type QueryGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryHeatPumpArgs = {
  id: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeatPumpOwnerArgs = {
  heatPumpId: Scalars['String']['input'];
};


export type QueryHeatPumpSettingsChangeLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryHeatPumpsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  preferDirect?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInterfaceArgs = {
  interfaceId: Scalars['String']['input'];
};


export type QueryInterfacesArgs = {
  interfaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryNotificationsArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<NotificationType>>;
};


export type QueryTimeSeriesArgs = {
  from: Scalars['Time']['input'];
  id: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['Duration']['input']>;
  until?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryUsersArgs = {
  roles?: InputMaybe<Array<Role>>;
};

export enum RateDuration {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Second = 'SECOND'
}

export type RefreshToken = {
  refreshToken: Scalars['String']['input'];
};

export type RequestNewAccountInput = {
  email: Scalars['String']['input'];
  heatPumpId: Scalars['String']['input'];
};

export type ResetPassword = {
  email: Scalars['String']['input'];
  password: Scalars['Password']['input'];
};

export type ResistanceHeaterData = {
  hasHeatingDemand?: Maybe<Scalars['Boolean']['output']>;
  isHeatingActive?: Maybe<Scalars['Boolean']['output']>;
  maxModulationLevel?: Maybe<Scalars['Float']['output']>;
  modulationPerc?: Maybe<Scalars['Float']['output']>;
  sinkSupplySetpTemp?: Maybe<Scalars['Float']['output']>;
  sinkSupplyTemp?: Maybe<Scalars['Float']['output']>;
};

export enum Role {
  Admin = 'admin',
  Expert = 'expert',
  Mechanic = 'mechanic',
  Resident = 'resident'
}

export type SchedulerTime = {
  __typename?: 'SchedulerTime';
  hour?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
};

export type SchedulerTimeInput = {
  hour?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchArrayItem = {
  __typename?: 'SearchArrayItem';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type SettingsPageFilter = {
  __typename?: 'SettingsPageFilter';
  searchText?: Maybe<Scalars['String']['output']>;
};

export type SpaceHeatingHeatSourceUnlockSettings = {
  aemResistanceHeaterPriority: HeatSourceUnlockPolicyPriority;
  otExternalPriority: HeatSourceUnlockPolicyPriority;
  prio1BivalentConfigAmbientTemp?: Maybe<Scalars['Float']['output']>;
  prio1BivalentConfigSourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  prio1UnlockPolicyType: HeatSourceUnlockPolicyType;
  prio1WaitTime: Scalars['Duration']['output'];
  prio2BivalentConfigAmbientTemp?: Maybe<Scalars['Float']['output']>;
  prio2BivalentConfigSourceReturnTemp?: Maybe<Scalars['Float']['output']>;
  prio2UnlockPolicyType: HeatSourceUnlockPolicyType;
  prio2WaitTime: Scalars['Duration']['output'];
};

export type SpaceHeatingHeatSourceUnlockSettingsInput = {
  otExternalBivalentConfigAmbientTemp?: InputMaybe<Scalars['Float']['input']>;
  otExternalBivalentConfigEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  otExternalBivalentConfigSourceReturnTemp?: InputMaybe<Scalars['Float']['input']>;
  otExternalUnlockPolicyType?: InputMaybe<HeatSourceUnlockPolicyType>;
  otExternalWaitTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  resistanceHeaterBivalentConfigAmbientTemp?: InputMaybe<Scalars['Float']['input']>;
  resistanceHeaterBivalentConfigEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  resistanceHeaterBivalentConfigSourceReturnTemp?: InputMaybe<Scalars['Float']['input']>;
  resistanceHeaterUnlockPolicyType?: InputMaybe<HeatSourceUnlockPolicyType>;
  resistanceHeaterWaitTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Defrost program status */
  heatPumpDefrostProgramStatus?: Maybe<DefrostStatus>;
  /** Flushing program status */
  heatPumpFlushingProgramStatus?: Maybe<FlushingStatus>;
  /** Hardware detection program status */
  heatPumpHWDetectProgramStatus?: Maybe<HwDetectStatus>;
};


export type SubscriptionHeatPumpDefrostProgramStatusArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionHeatPumpFlushingProgramStatusArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionHeatPumpHwDetectProgramStatusArgs = {
  id: Scalars['String']['input'];
};

export enum TransferPossible {
  ErrorHeatpumpOwner = 'ERROR_HEATPUMP_OWNER',
  ErrorOnlyAdmin = 'ERROR_ONLY_ADMIN',
  Ok = 'OK'
}

export enum UpdateDevice {
  Interface = 'INTERFACE',
  Mantova = 'MANTOVA'
}

export enum UpdateProgress {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Requested = 'REQUESTED'
}

export type UpdateStatus = {
  __typename?: 'UpdateStatus';
  device: UpdateDevice;
  message: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  progress: UpdateProgress;
  time: Scalars['Time']['output'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName: Scalars['String']['output'];
  group?: Maybe<Group>;
  hasAccount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isGroupAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumbers: Array<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  roles: Array<Role>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  excludedEmailNotificationHeatPumpIds: Array<Scalars['String']['output']>;
  faultEmailNotifications: Scalars['Boolean']['output'];
  language: Language;
  offlineEmailNotifications: Scalars['Boolean']['output'];
};

export type UserPreferencesInput = {
  excludedEmailNotificationHeatPumpIds: Array<Scalars['String']['input']>;
  faultEmailNotifications: Scalars['Boolean']['input'];
  language: Language;
  offlineEmailNotifications: Scalars['Boolean']['input'];
};

export enum Weekday {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type GetInterfaceFirmwareUpdatesInternalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterfaceFirmwareUpdatesInternalQuery = { __typename?: 'Query', getInterfaceFirmwareUpdates: Array<{ __typename?: 'InterfaceFirmwareVersion', id: string, default: boolean, description: string, name: string, timestamp: string, version: string, available: boolean }> };

export type GetMantovaFirmwareUpdatesInternalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMantovaFirmwareUpdatesInternalQuery = { __typename?: 'Query', getMantovaFirmwareUpdates: Array<{ __typename?: 'MantovaFirmwareVersion', id: string, name: string, available: boolean, default: boolean, version: number, description: string }> };

export type InterfaceFirmwareVersionExpertFragment = { __typename?: 'InterfaceFirmwareVersion', id: string, timestamp: string, version: string };

export type GetInterfaceFirmwareUpdatesExpertQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterfaceFirmwareUpdatesExpertQuery = { __typename?: 'Query', getInterfaceFirmwareUpdates: Array<{ __typename?: 'InterfaceFirmwareVersion', id: string, timestamp: string, version: string }> };

export type MantovaFirmwareVersionExpertFragment = { __typename?: 'MantovaFirmwareVersion', id: string, version: number };

export type GetMantovaFirmwareUpdatesExpertQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMantovaFirmwareUpdatesExpertQuery = { __typename?: 'Query', getMantovaFirmwareUpdates: Array<{ __typename?: 'MantovaFirmwareVersion', id: string, version: number }> };

export type GetCurrentInterfaceFirmwareVersionExpertQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type GetCurrentInterfaceFirmwareVersionExpertQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', id: string, timestamp: string, version: string } } | null };

export type GetCurrentInterfaceFirmwareVersionInternalQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type GetCurrentInterfaceFirmwareVersionInternalQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', name: string, timestamp: string } } | null };

export type GetCurrentFirmwareVersionExpertQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type GetCurrentFirmwareVersionExpertQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', timestamp: string } } | null };

export type GetCurrentFirmwareVersionQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type GetCurrentFirmwareVersionQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', name: string, timestamp: string } } | null };

export type UpdateStatusFragment = { __typename?: 'Interface', updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null };

export type GetCurrentUpdateStatusQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type GetCurrentUpdateStatusQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null } | null };

export type GetCurrentUpdateStatusListFieldsFragment = { __typename?: 'Interface', id: string, isOnline: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string, available: boolean }, updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null };

export type GetCurrentUpdateStatusListQueryVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetCurrentUpdateStatusListQuery = { __typename?: 'Query', interfaces: Array<{ __typename?: 'Interface', id: string, isOnline: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string, available: boolean }, updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null }> };

export type GetCurrentUpdateStatusHeatPumpListQueryVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetCurrentUpdateStatusHeatPumpListQuery = { __typename?: 'Query', interfaces: Array<{ __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null, updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null }> };

export type UpdateInterfaceFirmwareMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  firmwareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateInterfaceFirmwareMutation = { __typename?: 'Mutation', updateInterfaceFirmware: boolean };

export type UpdateMantovaFirmwareMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  firmwareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateMantovaFirmwareMutation = { __typename?: 'Mutation', updateMantovaFirmware: boolean };

export type SetDefaultInterfaceFirmwareMutationVariables = Exact<{
  firmwareId: Scalars['ID']['input'];
}>;


export type SetDefaultInterfaceFirmwareMutation = { __typename?: 'Mutation', setDefaultInterfaceFirmware: { __typename?: 'InterfaceFirmwareVersion', id: string, default: boolean } };

export type SetDefaultMantovaFirmwareMutationVariables = Exact<{
  firmwareId: Scalars['ID']['input'];
}>;


export type SetDefaultMantovaFirmwareMutation = { __typename?: 'Mutation', setDefaultMantovaFirmware: { __typename?: 'MantovaFirmwareVersion', id: string, default: boolean } };

export type MemberFieldsFragment = { __typename?: 'User', id: string, email?: string | null, isGroupAdmin?: boolean | null, name: string, isDeleted: boolean, deletedAt?: string | null };

export type GroupFieldsFragment = { __typename?: 'Group', id: string, isOrganization: boolean, name: string, isDeleted: boolean, members: Array<{ __typename?: 'User', id: string, email?: string | null, isGroupAdmin?: boolean | null, name: string, isDeleted: boolean, deletedAt?: string | null }> };

export type MemberFieldsSettingsFragment = { __typename?: 'User', id: string, name: string, email?: string | null, roles: Array<Role>, isDeleted: boolean, firstName: string, lastName: string, phoneNumbers: Array<string>, hasAccount: boolean, isGroupAdmin?: boolean | null };

export type GroupFieldsSettingsFragment = { __typename?: 'Group', id: string, name: string, isDeleted: boolean, isOrganization: boolean, members: Array<{ __typename?: 'User', id: string, name: string, email?: string | null, roles: Array<Role>, isDeleted: boolean, firstName: string, lastName: string, phoneNumbers: Array<string>, hasAccount: boolean, isGroupAdmin?: boolean | null }>, interfaces: Array<{ __typename?: 'Interface', id: string, groupInterfaceName?: string | null, accessLevel?: HeatPumpAccessLevel | null }> };

export type InterfaceGroupFieldsFragment = { __typename?: 'Interface', id: string, groupInterfaceName?: string | null, accessLevel?: HeatPumpAccessLevel | null };

export type MyGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGroupQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, isGroupAdmin?: boolean | null, group?: { __typename?: 'Group', id: string, isOrganization: boolean, name: string, isDeleted: boolean, interfaces: Array<{ __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, lastMessage?: string | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', errors?: Array<number> | null } | null }>, members: Array<{ __typename?: 'User', id: string, email?: string | null, isGroupAdmin?: boolean | null, name: string, isDeleted: boolean, deletedAt?: string | null }> } | null } };

export type MyGroupMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGroupMembersQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, group?: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string }> } | null } };

export type GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: string, name: string, isDeleted: boolean, isOrganization: boolean, members: Array<{ __typename?: 'User', id: string, name: string, email?: string | null, roles: Array<Role>, isDeleted: boolean, firstName: string, lastName: string, phoneNumbers: Array<string>, hasAccount: boolean, isGroupAdmin?: boolean | null }>, interfaces: Array<{ __typename?: 'Interface', id: string, groupInterfaceName?: string | null, accessLevel?: HeatPumpAccessLevel | null }> }> };

export type GroupQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type GroupQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, isDeleted: boolean, isOrganization: boolean, members: Array<{ __typename?: 'User', id: string, name: string, email?: string | null, roles: Array<Role>, isDeleted: boolean, firstName: string, lastName: string, phoneNumbers: Array<string>, hasAccount: boolean, isGroupAdmin?: boolean | null }>, interfaces: Array<{ __typename?: 'Interface', id: string, groupInterfaceName?: string | null, accessLevel?: HeatPumpAccessLevel | null }> } };

export type HeatPumpOwnerQueryVariables = Exact<{
  heatPumpId: Scalars['String']['input'];
}>;


export type HeatPumpOwnerQuery = { __typename?: 'Query', heatPumpOwner?: { __typename?: 'Group', name: string } | null };

export type RemoveUserFromGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', removeUserFromGroup: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string }> } };

export type LeaveGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type LeaveGroupMutation = { __typename?: 'Mutation', removeUserFromGroup: { __typename?: 'Group', id: string } };

export type ClaimHeatPumpMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
}>;


export type ClaimHeatPumpMutation = { __typename?: 'Mutation', claimHeatPump: { __typename?: 'Group', id: string, interfaces: Array<{ __typename?: 'Interface', id: string, accessLevel?: HeatPumpAccessLevel | null }> } };

export type RemoveHeatPumpFromGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
}>;


export type RemoveHeatPumpFromGroupMutation = { __typename?: 'Mutation', removeHeatPumpFromGroup?: { __typename?: 'Group', id: string, interfaces: Array<{ __typename?: 'Interface', id: string }> } | null };

export type RemoveGroupFromHeatPumpMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
}>;


export type RemoveGroupFromHeatPumpMutation = { __typename?: 'Mutation', removeHeatPumpFromGroup?: { __typename?: 'Group', id: string } | null };

export type UpdateGroupHeatPumpNameMutationVariables = Exact<{
  heatPumpId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGroupHeatPumpNameMutation = { __typename?: 'Mutation', updateGroupHeatPumpName: { __typename?: 'Group', id: string, interfaces: Array<{ __typename?: 'Interface', id: string, name?: string | null }> } };

export type UpdateGroupNameMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateGroupNameMutation = { __typename?: 'Mutation', updateGroupName: { __typename?: 'Group', id: string, name: string, isOrganization: boolean, isDeleted: boolean, members: Array<{ __typename?: 'User', id: string, name: string, isDeleted: boolean }> } };

export type InviteNewUserToGroupMutationVariables = Exact<{
  email: Scalars['Email']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type InviteNewUserToGroupMutation = { __typename?: 'Mutation', inviteNewUserToGroup: boolean };

export type UpdateGroupAdminMutationVariables = Exact<{
  admin: Scalars['Boolean']['input'];
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UpdateGroupAdminMutation = { __typename?: 'Mutation', updateGroupAdmin: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string, isGroupAdmin?: boolean | null }> } };

export type TransferHeatPumpOwnershipMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  heatPumpId: Scalars['String']['input'];
}>;


export type TransferHeatPumpOwnershipMutation = { __typename?: 'Mutation', updateHeatPumpAccessLevel: { __typename?: 'Group', id: string } };

export type InviteUserToHeatPumpMutationVariables = Exact<{
  email: Scalars['Email']['input'];
  heatPumpId: Scalars['String']['input'];
}>;


export type InviteUserToHeatPumpMutation = { __typename?: 'Mutation', inviteUserToHeatPump: boolean };

export type PvtHeatPumpSettingsFieldsWizardFragment = { __typename?: 'PvtHeatPumpData', id: string, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, firmwareVersion?: number | null, dhwMode?: PvtHeatPumpDhwMode | null, flushingMode?: PvtHeatPumpFlushingMode | null, shBackupEnable?: boolean | null, roomControlType?: PvtHeatPumpRoomControlType | null, dhwAutoTemp?: number | null, auxInputTemp?: number | null, shRoomSetpTemp?: number | null, shBoostEnabled?: boolean | null, boostSourceTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, shRoomHysteresisTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, errors?: Array<number> | null };

export type PvtHeatPumpSettingsFieldsFragment = { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, dhwMode?: PvtHeatPumpDhwMode | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, roomControlType?: PvtHeatPumpRoomControlType | null, shBackupEnable?: boolean | null, sinkMinShTemp?: number | null, sinkMaxShTemp?: number | null, flushingMode?: PvtHeatPumpFlushingMode | null, dhwAutoTemp?: number | null, shRoomSetpTemp?: number | null, shRoomHysteresisTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, shBoostEnabled?: boolean | null, dhwBoostEnabled?: boolean | null, boostSourceTemp?: number | null, errors?: Array<number> | null, enableSgInput?: boolean | null, sgAffectSh?: boolean | null, sgAffectSc?: boolean | null, sgAffectDhw?: boolean | null, sgAllowBhSh?: boolean | null, sgAllowBhDhw?: boolean | null, dmTOutdoorShEnable?: number | null, dmHeatingThreshold?: number | null, supplyTempMin30CustomHeating?: number | null, supplyTempMin20CustomHeating?: number | null, supplyTempMin10CustomHeating?: number | null, supplyTemp0CustomHeating?: number | null, supplyTemp10CustomHeating?: number | null, supplyTemp20CustomHeating?: number | null, supplyTemp30CustomHeating?: number | null, dmTOutdoorScEnable?: number | null, dmCoolingThreshold?: number | null, supplyTemp20CustomCooling?: number | null, supplyTemp30CustomCooling?: number | null, supplyTemp40CustomCooling?: number | null };

export type PvtHeatPumpAdminSettingDhwFragment = { __typename?: 'PvtHeatPumpData', id: string, dhwMode?: PvtHeatPumpDhwMode | null, dhwAutoTemp?: number | null, dhwEcoTemp?: number | null, dhwBoostTemp?: number | null, dhwPassiveEnable?: boolean | null, dhwCombinedEnable?: boolean | null, dhwActiveEnable?: boolean | null, dhwBackupEnable?: boolean | null, dhwLegionelaEnable?: boolean | null, dhwLegionelaTemp?: number | null, dhwLegionelaDay?: PvtHeatPumpDhwLegionelaDay | null, dhwLegionellaMaxCondensationTemp?: number | null, dhwHysteresisUpperBound?: number | null, dhwHysteresisLowerBound?: number | null };

export type PvtHeatPumpAdminSettingsGeneralFragment = { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, pauseTimeMin?: number | null, dhwPriorityTimeMin?: number | null, shPriorityTimeMin?: number | null, scPriorityTimeMin?: number | null, pasiveOperationMinSourceTemp?: number | null, passiveMinDeltaT?: number | null, preheatDeltaT?: number | null, enableSgInput?: boolean | null, sgAffectSh?: boolean | null, sgAffectSc?: boolean | null, sgAffectDhw?: boolean | null, sgAllowBhSh?: boolean | null, sgAllowBhDhw?: boolean | null };

export type PvtHeatPumpAdminSettingsHeatingCoolingFragment = { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, roomControlType?: PvtHeatPumpRoomControlType | null, shPasiveEnable?: boolean | null, shCombineEnable?: boolean | null, shActiveEnable?: boolean | null, shBackupEnable?: boolean | null, scPasiveEnable?: boolean | null, scCombineEnable?: boolean | null, scActiveEnable?: boolean | null, shRoomSetpTemp?: number | null, shRoomHysteresisTemp?: number | null, sinkMaxShTemp?: number | null, sinkMinShTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, supplyTempAtHiOutdoorTemp?: number | null, supplyTempAtLowOutdoorTemp?: number | null, outdoorHiTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, auxRelayMode?: PvtHeatPumpAuxRelayMode | null };

export type PvtHeatPumpAdminSettingsPumpsFragment = { __typename?: 'PvtHeatPumpData', id: string, flushingMode?: PvtHeatPumpFlushingMode | null, sourcePumpMaxSpeedPerc?: number | null, sinkPumpMaxSpeedPerc?: number | null, dhwActiveSourceDeltaT?: number | null, dhwCombinedSinkDeltaT?: number | null, dhwActiveSinkDeltaT?: number | null, shActiveSourceDeltaT?: number | null, shFloorActiveSinkDeltaT?: number | null, shRadiatorActiveSinkDeltaT?: number | null, shFloorCombinedSinkDeltaT?: number | null, shRadiatorCombinedSinkDeltaT?: number | null, scActiveSourceDeltaT?: number | null, scActiveSinkDeltaT?: number | null, scCombinedSinkDeltaT?: number | null, scPassiveSinkDeltaT?: number | null, sourcePumpMinSpeedPerc?: number | null, sinkPumpMinSpeedPerc?: number | null, pumpPiRegulatorGain?: number | null, pumpPiRegulatorIntegrationTimeSec?: number | null };

export type PvtHeatPumpAdminSecurityFragment = { __typename?: 'PvtHeatPumpData', id: string, maxCondensationTemp?: number | null, sourceMinTemp?: number | null, sourceMaxTemp?: number | null, maxDischargeTemp?: number | null, maxLiquidlineCoolTemp?: number | null, minEvapCoolTemp?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, evapMaxTempHeating?: number | null, evapNoCapDt?: number | null, condenserNoCapDt?: number | null, condenserMaxTemp?: number | null, evapNoRefigDt?: number | null, condenserNoRefigDt?: number | null, dhwSinkMinTemp?: number | null, dhwSinkMaxTemp?: number | null, evapMinBt2HeatTemp?: number | null, spaceActiveOrCombinedMinTime?: number | null, dhwActiveOrCombinedMinTime?: number | null, backupByErrorEnabled?: boolean | null, envelopeSinkHighTemp?: number | null, envelopeSinkLowTemp?: number | null, envelopeBackupSourceHighTemp?: number | null, envelopeBackupSourceLowTemp?: number | null, envelopeBackupDhwGoBackHystTemp?: number | null, envelopeBackupShGoBackHystTemp?: number | null };

export type PvtHeatPumpAdminOverrideFragment = { __typename?: 'PvtHeatPumpData', id: string, inputOverrideMask?: Array<PvtHeatPumpInputOverrideMask> | null, bt1OverrideValue?: number | null, bt2OverrideValue?: number | null, bt3OverrideValue?: number | null, bt4OverrideValue?: number | null, bt5OverrideValue?: number | null, bt6OverrideValue?: number | null, bt7OverrideValue?: number | null, btAux1OverrideValue?: number | null, btAux2OverrideValue?: number | null, btAux3OverrideValue?: number | null, outputOverrideMask?: Array<PvtHeatPumpOutputOverrideMask> | null, gq1Compressor1Override?: boolean | null, gq1Compressor2Override?: boolean | null, eb1ElectricHeaterRelayOverride?: boolean | null, qn44WayValveRelayOverride?: boolean | null, auxRelayOverride?: boolean | null, gp1Gp2PumpRelayOverride?: boolean | null, gp1PumpSourcePwmOverride?: number | null, gp2PumpSinkPwmOverride?: number | null, qn2HeatSourceValveOverride?: number | null, qn3HeatSinkValveOverride?: number | null };

export type PvtHeatPumpAdminDateTimeFragment = { __typename?: 'PvtHeatPumpData', id: string, curTimeMin?: number | null, curTimeHour?: number | null, curTimeDay?: number | null, curTimeDate?: number | null, curTimeMonth?: number | null, curTimeYear?: number | null, daylightSavingEnable?: boolean | null };

export type PvtHeatPumpSupplyCustomHeatingFragment = { __typename?: 'PvtHeatPumpData', dmTOutdoorShEnable?: number | null, dmHeatingThreshold?: number | null, supplyTempMin30CustomHeating?: number | null, supplyTempMin20CustomHeating?: number | null, supplyTempMin10CustomHeating?: number | null, supplyTemp0CustomHeating?: number | null, supplyTemp10CustomHeating?: number | null, supplyTemp20CustomHeating?: number | null, supplyTemp30CustomHeating?: number | null };

export type PvtHeatPumpSupplyCustomCoolingFragment = { __typename?: 'PvtHeatPumpData', dmTOutdoorScEnable?: number | null, dmCoolingThreshold?: number | null, supplyTemp20CustomCooling?: number | null, supplyTemp30CustomCooling?: number | null, supplyTemp40CustomCooling?: number | null };

export type PvtHeatPumpDmSetpointsFragment = { __typename?: 'PvtHeatPumpData', dmHeatingThreshold?: number | null, dmCoolingThreshold?: number | null, dmBoostHeating?: number | null, dmTOutdoorShEnable?: number | null, dmTOutdoorScEnable?: number | null, dmTOutdoorBoostHeating?: number | null, coolingCurveOffset?: number | null, heatingCurveOffset?: number | null, heatingCurve?: number | null, outdoorTempFilterTime?: number | null, coolingCurve?: number | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, supplyTemp20CustomCooling?: number | null, supplyTemp30CustomCooling?: number | null, supplyTemp40CustomCooling?: number | null, supplyTempMin30CustomHeating?: number | null, supplyTempMin20CustomHeating?: number | null, supplyTempMin10CustomHeating?: number | null, supplyTemp0CustomHeating?: number | null, supplyTemp10CustomHeating?: number | null, supplyTemp20CustomHeating?: number | null, supplyTemp30CustomHeating?: number | null };

export type PvtHeatPumpDhwSchedulerFragment = { __typename?: 'PvtHeatPumpData', id: string, dhwScheduler?: { __typename?: 'DHWScheduler', schedulerEnabled?: boolean | null, blockDHWEnabled?: boolean | null, forceDHWEnabled?: boolean | null, blockOnTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null, blockOffTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null, forceOnTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null, forceOffTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null } | null };

export type PvtHeatPumpAdminStatusFragment = { __typename?: 'Interface', id: string, ioTHubID: string, certificateValidUntil?: string | null };

export type HpErrorFieldsFragment = { __typename?: 'HPErrorData', errors: Array<number> };

export type ModbusChangeFieldsFragment = { __typename?: 'ModbusChangeData', value: number, address: number, user: { __typename?: 'User', name: string, email?: string | null, isDeleted: boolean } };

export type EventFieldsFragment = { __typename?: 'Event', type: EventType, level: EventLevel, start: string, stop?: string | null, data: { __typename?: 'HPErrorData', errors: Array<number> } | { __typename?: 'ModbusChangeData', value: number, address: number, user: { __typename?: 'User', name: string, email?: string | null, isDeleted: boolean } } };

export type ReadInterfaceEventLogQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadInterfaceEventLogQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, eventLog: Array<{ __typename?: 'Event', type: EventType, level: EventLevel, start: string, stop?: string | null, data: { __typename?: 'HPErrorData', errors: Array<number> } | { __typename?: 'ModbusChangeData', value: number, address: number, user: { __typename?: 'User', name: string, email?: string | null, isDeleted: boolean } } }> } | null };

export type PvtHeatPumpAdminSettingsFragment = { __typename?: 'PvtHeatPumpData', id: string, dhwMode?: PvtHeatPumpDhwMode | null, dhwAutoTemp?: number | null, dhwEcoTemp?: number | null, dhwBoostTemp?: number | null, dhwPassiveEnable?: boolean | null, dhwCombinedEnable?: boolean | null, dhwActiveEnable?: boolean | null, dhwBackupEnable?: boolean | null, dhwLegionelaEnable?: boolean | null, dhwLegionelaTemp?: number | null, dhwLegionelaDay?: PvtHeatPumpDhwLegionelaDay | null, dhwLegionellaMaxCondensationTemp?: number | null, dhwHysteresisUpperBound?: number | null, dhwHysteresisLowerBound?: number | null, firmwareVersion?: number | null, pauseTimeMin?: number | null, dhwPriorityTimeMin?: number | null, shPriorityTimeMin?: number | null, scPriorityTimeMin?: number | null, pasiveOperationMinSourceTemp?: number | null, passiveMinDeltaT?: number | null, preheatDeltaT?: number | null, enableSgInput?: boolean | null, sgAffectSh?: boolean | null, sgAffectSc?: boolean | null, sgAffectDhw?: boolean | null, sgAllowBhSh?: boolean | null, sgAllowBhDhw?: boolean | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, roomControlType?: PvtHeatPumpRoomControlType | null, shPasiveEnable?: boolean | null, shCombineEnable?: boolean | null, shActiveEnable?: boolean | null, shBackupEnable?: boolean | null, scPasiveEnable?: boolean | null, scCombineEnable?: boolean | null, scActiveEnable?: boolean | null, shRoomSetpTemp?: number | null, shRoomHysteresisTemp?: number | null, sinkMaxShTemp?: number | null, sinkMinShTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, supplyTempAtHiOutdoorTemp?: number | null, supplyTempAtLowOutdoorTemp?: number | null, outdoorHiTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, auxRelayMode?: PvtHeatPumpAuxRelayMode | null, inputOverrideMask?: Array<PvtHeatPumpInputOverrideMask> | null, bt1OverrideValue?: number | null, bt2OverrideValue?: number | null, bt3OverrideValue?: number | null, bt4OverrideValue?: number | null, bt5OverrideValue?: number | null, bt6OverrideValue?: number | null, bt7OverrideValue?: number | null, btAux1OverrideValue?: number | null, btAux2OverrideValue?: number | null, btAux3OverrideValue?: number | null, outputOverrideMask?: Array<PvtHeatPumpOutputOverrideMask> | null, gq1Compressor1Override?: boolean | null, gq1Compressor2Override?: boolean | null, eb1ElectricHeaterRelayOverride?: boolean | null, qn44WayValveRelayOverride?: boolean | null, auxRelayOverride?: boolean | null, gp1Gp2PumpRelayOverride?: boolean | null, gp1PumpSourcePwmOverride?: number | null, gp2PumpSinkPwmOverride?: number | null, qn2HeatSourceValveOverride?: number | null, qn3HeatSinkValveOverride?: number | null, maxCondensationTemp?: number | null, sourceMinTemp?: number | null, sourceMaxTemp?: number | null, maxDischargeTemp?: number | null, maxLiquidlineCoolTemp?: number | null, minEvapCoolTemp?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, evapMaxTempHeating?: number | null, evapNoCapDt?: number | null, condenserNoCapDt?: number | null, condenserMaxTemp?: number | null, evapNoRefigDt?: number | null, condenserNoRefigDt?: number | null, dhwSinkMinTemp?: number | null, dhwSinkMaxTemp?: number | null, evapMinBt2HeatTemp?: number | null, spaceActiveOrCombinedMinTime?: number | null, dhwActiveOrCombinedMinTime?: number | null, backupByErrorEnabled?: boolean | null, envelopeSinkHighTemp?: number | null, envelopeSinkLowTemp?: number | null, envelopeBackupSourceHighTemp?: number | null, envelopeBackupSourceLowTemp?: number | null, envelopeBackupDhwGoBackHystTemp?: number | null, envelopeBackupShGoBackHystTemp?: number | null, curTimeMin?: number | null, curTimeHour?: number | null, curTimeDay?: number | null, curTimeDate?: number | null, curTimeMonth?: number | null, curTimeYear?: number | null, daylightSavingEnable?: boolean | null, flushingMode?: PvtHeatPumpFlushingMode | null, sourcePumpMaxSpeedPerc?: number | null, sinkPumpMaxSpeedPerc?: number | null, dhwActiveSourceDeltaT?: number | null, dhwCombinedSinkDeltaT?: number | null, dhwActiveSinkDeltaT?: number | null, shActiveSourceDeltaT?: number | null, shFloorActiveSinkDeltaT?: number | null, shRadiatorActiveSinkDeltaT?: number | null, shFloorCombinedSinkDeltaT?: number | null, shRadiatorCombinedSinkDeltaT?: number | null, scActiveSourceDeltaT?: number | null, scActiveSinkDeltaT?: number | null, scCombinedSinkDeltaT?: number | null, scPassiveSinkDeltaT?: number | null, sourcePumpMinSpeedPerc?: number | null, sinkPumpMinSpeedPerc?: number | null, pumpPiRegulatorGain?: number | null, pumpPiRegulatorIntegrationTimeSec?: number | null };

export type ResidentControllerSettingsFieldsFragment = { __typename?: 'ControllerSettingsData', backupHeater: BackupHeaterType, chSetpMaxTemp: number, manualCoolingMode: ManualCoolingMode };

export type CompressorWaitTimeFieldsFragment = { __typename?: 'PvtHeatPumpData', id: string, timestamp: string, compressorOffTime?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, startupCountdown?: number | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, dhwState?: PvtHeatPumpDhwState | null, pauseTimeMin?: number | null, spaceHeatingCoolingPauseTime?: number | null, dhwPauseTime?: number | null };

export type ReadHeatPumpSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null, openThermBoilerConnected: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string }, controller: { __typename?: 'ControllerSettingsData', backupHeater: BackupHeaterType, chSetpMaxTemp: number, manualCoolingMode: ManualCoolingMode }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, dhwMode?: PvtHeatPumpDhwMode | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, roomControlType?: PvtHeatPumpRoomControlType | null, shBackupEnable?: boolean | null, sinkMinShTemp?: number | null, sinkMaxShTemp?: number | null, flushingMode?: PvtHeatPumpFlushingMode | null, dhwAutoTemp?: number | null, shRoomSetpTemp?: number | null, shRoomHysteresisTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, shBoostEnabled?: boolean | null, dhwBoostEnabled?: boolean | null, boostSourceTemp?: number | null, errors?: Array<number> | null, enableSgInput?: boolean | null, sgAffectSh?: boolean | null, sgAffectSc?: boolean | null, sgAffectDhw?: boolean | null, sgAllowBhSh?: boolean | null, sgAllowBhDhw?: boolean | null, dmTOutdoorShEnable?: number | null, dmHeatingThreshold?: number | null, supplyTempMin30CustomHeating?: number | null, supplyTempMin20CustomHeating?: number | null, supplyTempMin10CustomHeating?: number | null, supplyTemp0CustomHeating?: number | null, supplyTemp10CustomHeating?: number | null, supplyTemp20CustomHeating?: number | null, supplyTemp30CustomHeating?: number | null, dmTOutdoorScEnable?: number | null, dmCoolingThreshold?: number | null, supplyTemp20CustomCooling?: number | null, supplyTemp30CustomCooling?: number | null, supplyTemp40CustomCooling?: number | null } | null } | null };

export type ReadHeatPumpSettingsWizardQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpSettingsWizardQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null, openThermThermostatConnected: boolean, openThermBoilerConnected: boolean, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, firmwareVersion?: number | null, dhwMode?: PvtHeatPumpDhwMode | null, flushingMode?: PvtHeatPumpFlushingMode | null, shBackupEnable?: boolean | null, roomControlType?: PvtHeatPumpRoomControlType | null, dhwAutoTemp?: number | null, auxInputTemp?: number | null, shRoomSetpTemp?: number | null, shBoostEnabled?: boolean | null, boostSourceTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, shRoomHysteresisTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, errors?: Array<number> | null } | null, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string }, controller: { __typename?: 'ControllerSettingsData', manualCoolingMode: ManualCoolingMode, chSetpMaxTemp: number, backupHeater: BackupHeaterType }, openTherm?: { __typename?: 'OpenThermData', chSetpTemp?: number | null, chFeedTemp?: number | null, roomTemp?: number | null, roomSetpTemp?: number | null } | null, slave?: { __typename?: 'Interface', id: string } | null } | null };

export type ReadExpertControllerSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;


export type ReadExpertControllerSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, controller: { __typename?: 'ControllerSettingsData', delayHPOnMin: number, hysBHOn: number, sourceBivTemp: number, minCoolingPerc: number, delayHPOffMin?: number, delayHPCheckMin?: number, hysHPOn?: number, hysHPOff?: number, hysBHOff?: number, delayHPPostRunMin?: number } } | null };

export type HeatPumpGroupFieldsFragment = { __typename?: 'Group', id: string, name: string, isOrganization: boolean, isDeleted: boolean, deletedAt?: string | null, heatPumpName?: string | null };

export type ReadHeatPumpGroupSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
  isInternal: Scalars['Boolean']['input'];
}>;


export type ReadHeatPumpGroupSettingsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, isGroupAdmin?: boolean | null, group?: { __typename?: 'Group', id: string } | null }, interface?: { __typename?: 'Interface', id: string, accessLevel?: HeatPumpAccessLevel | null, name?: string | null, interfaceOwner?: { __typename?: 'Group', id: string } | null, groups: Array<{ __typename?: 'Group', id: string, name: string, isOrganization: boolean, isDeleted: boolean, deletedAt?: string | null, heatPumpName?: string | null }> } | null };

export type ReadHeatPumpCountdownFieldsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpCountdownFieldsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, timestamp: string, compressorOffTime?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, startupCountdown?: number | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, dhwState?: PvtHeatPumpDhwState | null, pauseTimeMin?: number | null, spaceHeatingCoolingPauseTime?: number | null, dhwPauseTime?: number | null } | null } | null };

export type PvtHeatPumpStatusFieldsFragment = { __typename?: 'PvtHeatPumpData', id: string, spaceHeatDemand?: boolean | null, spaceCoolDemand?: boolean | null, dhwDemand?: boolean | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, dhwState?: PvtHeatPumpDhwState | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, electricElementOn?: boolean | null, coolingValveEnabled?: boolean | null, pumpRelayOn?: boolean | null, sourcePumpPerc?: number | null, sinkPumpPerc?: number | null, sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, compressorDischarge?: number | null, errors?: Array<number> | null, roomControlType?: PvtHeatPumpRoomControlType | null, shRoomSetpTemp?: number | null, auxInputTemp?: number | null, dmSh?: number | null, dmSc?: number | null, timestamp: string, compressorOffTime?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, startupCountdown?: number | null, pauseTimeMin?: number | null, spaceHeatingCoolingPauseTime?: number | null, dhwPauseTime?: number | null };

export type InterfaceStatusFieldsFragment = { __typename?: 'Interface', id: string, openThermBoilerConnected: boolean, openThermThermostatConnected: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, spaceHeatDemand?: boolean | null, spaceCoolDemand?: boolean | null, dhwDemand?: boolean | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, dhwState?: PvtHeatPumpDhwState | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, electricElementOn?: boolean | null, coolingValveEnabled?: boolean | null, pumpRelayOn?: boolean | null, sourcePumpPerc?: number | null, sinkPumpPerc?: number | null, sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, compressorDischarge?: number | null, errors?: Array<number> | null, roomControlType?: PvtHeatPumpRoomControlType | null, shRoomSetpTemp?: number | null, auxInputTemp?: number | null, dmSh?: number | null, dmSc?: number | null, timestamp: string, compressorOffTime?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, startupCountdown?: number | null, pauseTimeMin?: number | null, spaceHeatingCoolingPauseTime?: number | null, dhwPauseTime?: number | null } | null, openTherm?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null } | null, status?: { __typename?: 'InterfaceStatus', signalStrength: number, operatorName: string } | null };

export type ReadHeatPumpStatusQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpStatusQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, openThermBoilerConnected: boolean, openThermThermostatConnected: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, spaceHeatDemand?: boolean | null, spaceCoolDemand?: boolean | null, dhwDemand?: boolean | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, dhwState?: PvtHeatPumpDhwState | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, electricElementOn?: boolean | null, coolingValveEnabled?: boolean | null, pumpRelayOn?: boolean | null, sourcePumpPerc?: number | null, sinkPumpPerc?: number | null, sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, compressorDischarge?: number | null, errors?: Array<number> | null, roomControlType?: PvtHeatPumpRoomControlType | null, shRoomSetpTemp?: number | null, auxInputTemp?: number | null, dmSh?: number | null, dmSc?: number | null, timestamp: string, compressorOffTime?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, startupCountdown?: number | null, pauseTimeMin?: number | null, spaceHeatingCoolingPauseTime?: number | null, dhwPauseTime?: number | null } | null, openTherm?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null } | null, status?: { __typename?: 'InterfaceStatus', signalStrength: number, operatorName: string } | null } | null };

export type ReadHeatPumpDmFieldsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpDmFieldsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, roomControlType?: PvtHeatPumpRoomControlType | null, dmSh?: number | null, dmSc?: number | null, dmHeatingThreshold?: number | null, dmCoolingThreshold?: number | null, dmBoostHeating?: number | null, dmTOutdoorShEnable?: number | null, dmTOutdoorScEnable?: number | null, dmTOutdoorBoostHeating?: number | null, coolingCurveOffset?: number | null, heatingCurveOffset?: number | null, heatingCurve?: number | null, outdoorTempFilterTime?: number | null, coolingCurve?: number | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, supplyTemp20CustomCooling?: number | null, supplyTemp30CustomCooling?: number | null, supplyTemp40CustomCooling?: number | null, supplyTempMin30CustomHeating?: number | null, supplyTempMin20CustomHeating?: number | null, supplyTempMin10CustomHeating?: number | null, supplyTemp0CustomHeating?: number | null, supplyTemp10CustomHeating?: number | null, supplyTemp20CustomHeating?: number | null, supplyTemp30CustomHeating?: number | null } | null } | null };

export type ReadHeatPumpErrorsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpErrorsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, errors?: Array<number> | null } | null } | null };

export type ReadHeatPumpDhwSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpDhwSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, dhwMode?: PvtHeatPumpDhwMode | null, dhwAutoTemp?: number | null, dhwEcoTemp?: number | null, dhwBoostTemp?: number | null, dhwPassiveEnable?: boolean | null, dhwCombinedEnable?: boolean | null, dhwActiveEnable?: boolean | null, dhwBackupEnable?: boolean | null, dhwLegionelaEnable?: boolean | null, dhwLegionelaTemp?: number | null, dhwLegionelaDay?: PvtHeatPumpDhwLegionelaDay | null, dhwLegionellaMaxCondensationTemp?: number | null, dhwHysteresisUpperBound?: number | null, dhwHysteresisLowerBound?: number | null } | null } | null };

export type ReadHeatPumpGeneralSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpGeneralSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, pauseTimeMin?: number | null, dhwPriorityTimeMin?: number | null, shPriorityTimeMin?: number | null, scPriorityTimeMin?: number | null, pasiveOperationMinSourceTemp?: number | null, passiveMinDeltaT?: number | null, preheatDeltaT?: number | null, enableSgInput?: boolean | null, sgAffectSh?: boolean | null, sgAffectSc?: boolean | null, sgAffectDhw?: boolean | null, sgAllowBhSh?: boolean | null, sgAllowBhDhw?: boolean | null } | null } | null };

export type ReadHeatPumpHeatingCoolingSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpHeatingCoolingSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, firmwareVersion?: number | null, roomTemperatureControl?: PvtHeatPumpRoomTemperatureControl | null, roomControlType?: PvtHeatPumpRoomControlType | null, shPasiveEnable?: boolean | null, shCombineEnable?: boolean | null, shActiveEnable?: boolean | null, shBackupEnable?: boolean | null, scPasiveEnable?: boolean | null, scCombineEnable?: boolean | null, scActiveEnable?: boolean | null, shRoomSetpTemp?: number | null, shRoomHysteresisTemp?: number | null, sinkMaxShTemp?: number | null, sinkMinShTemp?: number | null, scRoomSetpTemp?: number | null, scRoomHysteresisTemp?: number | null, supplyTempAtHiOutdoorTemp?: number | null, supplyTempAtLowOutdoorTemp?: number | null, outdoorHiTemp?: number | null, sinkCoolingPauseThresholdTemp?: number | null, auxRelayMode?: PvtHeatPumpAuxRelayMode | null } | null } | null };

export type ReadHeatPumpPumpsSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpPumpsSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, flushingMode?: PvtHeatPumpFlushingMode | null, sourcePumpMaxSpeedPerc?: number | null, sinkPumpMaxSpeedPerc?: number | null, dhwActiveSourceDeltaT?: number | null, dhwCombinedSinkDeltaT?: number | null, dhwActiveSinkDeltaT?: number | null, shActiveSourceDeltaT?: number | null, shFloorActiveSinkDeltaT?: number | null, shRadiatorActiveSinkDeltaT?: number | null, shFloorCombinedSinkDeltaT?: number | null, shRadiatorCombinedSinkDeltaT?: number | null, scActiveSourceDeltaT?: number | null, scActiveSinkDeltaT?: number | null, scCombinedSinkDeltaT?: number | null, scPassiveSinkDeltaT?: number | null, sourcePumpMinSpeedPerc?: number | null, sinkPumpMinSpeedPerc?: number | null, pumpPiRegulatorGain?: number | null, pumpPiRegulatorIntegrationTimeSec?: number | null } | null } | null };

export type ReadHeatPumpSecuritySettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpSecuritySettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, maxCondensationTemp?: number | null, sourceMinTemp?: number | null, sourceMaxTemp?: number | null, maxDischargeTemp?: number | null, maxLiquidlineCoolTemp?: number | null, minEvapCoolTemp?: number | null, compressorOffToOnDelaySec?: number | null, startupTimeSec?: number | null, evapMaxTempHeating?: number | null, evapNoCapDt?: number | null, condenserNoCapDt?: number | null, condenserMaxTemp?: number | null, evapNoRefigDt?: number | null, condenserNoRefigDt?: number | null, dhwSinkMinTemp?: number | null, dhwSinkMaxTemp?: number | null, evapMinBt2HeatTemp?: number | null, spaceActiveOrCombinedMinTime?: number | null, dhwActiveOrCombinedMinTime?: number | null, backupByErrorEnabled?: boolean | null, envelopeSinkHighTemp?: number | null, envelopeSinkLowTemp?: number | null, envelopeBackupSourceHighTemp?: number | null, envelopeBackupSourceLowTemp?: number | null, envelopeBackupDhwGoBackHystTemp?: number | null, envelopeBackupShGoBackHystTemp?: number | null } | null } | null };

export type ReadHeatPumpOverrideSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpOverrideSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, inputOverrideMask?: Array<PvtHeatPumpInputOverrideMask> | null, bt1OverrideValue?: number | null, bt2OverrideValue?: number | null, bt3OverrideValue?: number | null, bt4OverrideValue?: number | null, bt5OverrideValue?: number | null, bt6OverrideValue?: number | null, bt7OverrideValue?: number | null, btAux1OverrideValue?: number | null, btAux2OverrideValue?: number | null, btAux3OverrideValue?: number | null, outputOverrideMask?: Array<PvtHeatPumpOutputOverrideMask> | null, gq1Compressor1Override?: boolean | null, gq1Compressor2Override?: boolean | null, eb1ElectricHeaterRelayOverride?: boolean | null, qn44WayValveRelayOverride?: boolean | null, auxRelayOverride?: boolean | null, gp1Gp2PumpRelayOverride?: boolean | null, gp1PumpSourcePwmOverride?: number | null, gp2PumpSinkPwmOverride?: number | null, qn2HeatSourceValveOverride?: number | null, qn3HeatSinkValveOverride?: number | null } | null } | null };

export type ReadHeatPumpDateTimeSettingsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpDateTimeSettingsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, curTimeMin?: number | null, curTimeHour?: number | null, curTimeDay?: number | null, curTimeDate?: number | null, curTimeMonth?: number | null, curTimeYear?: number | null, daylightSavingEnable?: boolean | null } | null } | null };

export type ReadHeatPumpAdminStatusQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpAdminStatusQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, ioTHubID: string, certificateValidUntil?: string | null } | null };

export type ReadHeatPumpStatusAppBarQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpStatusAppBarQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', id: string, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, errors?: Array<number> | null } | null } | null };

export type ReadHeatPumpDhwSchedulerQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type ReadHeatPumpDhwSchedulerQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null, id: string, dhwScheduler?: { __typename?: 'DHWScheduler', schedulerEnabled?: boolean | null, blockDHWEnabled?: boolean | null, forceDHWEnabled?: boolean | null, blockOnTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null, blockOffTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null, forceOnTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null, forceOffTime?: { __typename?: 'SchedulerTime', hour?: number | null, minute?: number | null } | null } | null } | null } | null };

export type UpdatePvtHeatPumpSettingsMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pvtHeatPumpdata: PvtHeatPumpInput;
  controllerSettings: ControllerSettingsInput;
  isExpert: Scalars['Boolean']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;


export type UpdatePvtHeatPumpSettingsMutation = { __typename?: 'Mutation', updatePvtHeatPump: boolean, updateControllerSettings: Array<{ __typename?: 'Interface', id: string, controller: { __typename?: 'ControllerSettingsData', delayHPOnMin?: number, hysBHOn?: number, sourceBivTemp?: number, delayHPOffMin?: number, delayHPCheckMin?: number, hysHPOn?: number, hysHPOff?: number, hysBHOff?: number, delayHPPostRunMin?: number, backupHeater: BackupHeaterType, chSetpMaxTemp: number, manualCoolingMode: ManualCoolingMode } }> };

export type UpdatePvtHeatPumpAdminSettingsMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  data: PvtHeatPumpInput;
}>;


export type UpdatePvtHeatPumpAdminSettingsMutation = { __typename?: 'Mutation', updatePvtHeatPump: boolean };

export type RestartPvtHeatPumpMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RestartPvtHeatPumpMutation = { __typename?: 'Mutation', updatePvtHeatPump: boolean };

export type ResetPvtHeatPumpErrorsMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ResetPvtHeatPumpErrorsMutation = { __typename?: 'Mutation', updatePvtHeatPump: boolean };

export type UpdatePvtHeatPumpDhwSchedulerMutationVariables = Exact<{
  interfaceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  data: DhwSchedulerInput;
}>;


export type UpdatePvtHeatPumpDhwSchedulerMutation = { __typename?: 'Mutation', updateDHWScheduler: boolean };

export type HeatPumpSlaveFieldsFragment = { __typename?: 'Interface', id: string, slave?: { __typename?: 'Interface', id: string, name?: string | null } | null };

export type HeatPumpSlaveQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type HeatPumpSlaveQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, slave?: { __typename?: 'Interface', id: string, name?: string | null } | null } | null };

export type SetSlaveMutationVariables = Exact<{
  slaveId?: InputMaybe<Scalars['String']['input']>;
  interfaceId: Scalars['String']['input'];
}>;


export type SetSlaveMutation = { __typename?: 'Mutation', setSlave: { __typename?: 'Interface', id: string, slave?: { __typename?: 'Interface', id: string, name?: string | null } | null } };

export type InterfaceFieldsFragment = { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, lastMessage?: string | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', errors?: Array<number> | null } | null };

export type HeatMeterFieldsFragment = { __typename?: 'HeatData', power: number, flow: number };

export type ElectricityMeterFieldsFragment = { __typename?: 'ElectricityData', power: number };

export type HeatPumpDataFieldsFragment = { __typename?: 'PvtHeatPumpData', sourcePumpPerc?: number | null, sinkPumpPerc?: number | null, sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, errors?: Array<number> | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, auxInputTemp?: number | null, hasOnOffThermostatDemand?: boolean | null };

export type ResidentHeatPumpDataFieldsFragment = { __typename?: 'PvtHeatPumpData', sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, errors?: Array<number> | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, auxInputTemp?: number | null, hasOnOffThermostatDemand?: boolean | null };

export type OpenThermDataFieldsFragment = { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null };

export type ResidentBoilerOpenThermDataFieldsFragment = { __typename?: 'OpenThermData', chFeedTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null };

export type InterfaceLogDataFragment = { __typename?: 'InterfaceLog', timestamp: string, heatPumpElectricityMeter?: { __typename?: 'ElectricityData', power: number } | null, heatingHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, sourceHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', sourcePumpPerc?: number | null, sinkPumpPerc?: number | null, sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, errors?: Array<number> | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, auxInputTemp?: number | null, hasOnOffThermostatDemand?: boolean | null } | null, boiler?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null } | null, thermostat?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null } | null };

export type ResidentInterfaceLogDataFragment = { __typename?: 'InterfaceLog', timestamp: string, heatPumpElectricityMeter?: { __typename?: 'ElectricityData', power: number } | null, heatingHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, sourceHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, errors?: Array<number> | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, auxInputTemp?: number | null, hasOnOffThermostatDemand?: boolean | null } | null, boiler?: { __typename?: 'OpenThermData', chFeedTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null } | null, thermostat?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null } | null };

export type InterfaceIdsFieldsFragment = { __typename?: 'Interface', id: string, name?: string | null };

export type InterfacesQueryVariables = Exact<{ [key: string]: never; }>;


export type InterfacesQuery = { __typename?: 'Query', interfaces: Array<{ __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, lastMessage?: string | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', errors?: Array<number> | null } | null }> };

export type InterfacesListQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InterfacesListQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', id: string, name: string, timestamp: string } } | null };

export type InterfaceIDsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterfaceIDsQuery = { __typename?: 'Query', interfaces: Array<{ __typename?: 'Interface', id: string, name?: string | null }> };

export type InterfaceNameQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InterfaceNameQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null } | null };

export type InterfaceStatusQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InterfaceStatusQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, lastMessage?: string | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', errors?: Array<number> | null } | null } | null };

export type InterfaceQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
  from: Scalars['Time']['input'];
  until?: InputMaybe<Scalars['Time']['input']>;
}>;


export type InterfaceQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, lastMessage?: string | null, logs: { __typename?: 'InterfaceLogs', data: Array<{ __typename?: 'InterfaceLog', timestamp: string, heatPumpElectricityMeter?: { __typename?: 'ElectricityData', power: number } | null, heatingHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, sourceHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', sourcePumpPerc?: number | null, sinkPumpPerc?: number | null, sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, errors?: Array<number> | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, auxInputTemp?: number | null, hasOnOffThermostatDemand?: boolean | null } | null, boiler?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null } | null, thermostat?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null } | null }> }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', errors?: Array<number> | null } | null } | null };

export type ResidentInterfaceQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
  from: Scalars['Time']['input'];
  until?: InputMaybe<Scalars['Time']['input']>;
}>;


export type ResidentInterfaceQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, lastMessage?: string | null, logs: { __typename?: 'InterfaceLogs', data: Array<{ __typename?: 'InterfaceLog', timestamp: string, heatPumpElectricityMeter?: { __typename?: 'ElectricityData', power: number } | null, heatingHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, sourceHeatMeter?: { __typename?: 'HeatData', power: number, flow: number } | null, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', sourceInTemp?: number | null, sourceOutTemp?: number | null, sinkInTemp?: number | null, sinkOutTemp?: number | null, dhwBoilerTemp?: number | null, compressorOn?: boolean | null, errors?: Array<number> | null, dhwState?: PvtHeatPumpDhwState | null, spaceHeatingCoolingState?: PvtHeatPumpSpaceHeatingCoolingState | null, auxInputTemp?: number | null, hasOnOffThermostatDemand?: boolean | null } | null, boiler?: { __typename?: 'OpenThermData', chFeedTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null } | null, thermostat?: { __typename?: 'OpenThermData', roomTemp?: number | null, roomSetpTemp?: number | null, chFeedTemp?: number | null, chSetpTemp?: number | null, modulationLevelPerc?: number | null, chEnable?: boolean | null, coolingEnable?: boolean | null, coolingPercSetp?: number | null } | null }> }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', errors?: Array<number> | null } | null } | null };

export type InterfaceKnownQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InterfaceKnownQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string } | null };

export type InterfaceOnlineQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InterfaceOnlineQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, isOnline: boolean } | null };

export type InterfaceGroupsQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InterfaceGroupsQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', groups: Array<{ __typename?: 'Group', id: string }> } | null };

export type GroupInterfaceNameQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type GroupInterfaceNameQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, name?: string | null } | null };

export type HeatPumpConnectedQueryVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type HeatPumpConnectedQuery = { __typename?: 'Query', interface?: { __typename?: 'Interface', id: string, heatPumpConnected: boolean } | null };

export type InterfacesFieldsFragment = { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string, available: boolean }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null };

export type AllInterfacesQueryVariables = Exact<{
  interfaceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AllInterfacesQuery = { __typename?: 'Query', interfaces: Array<{ __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string, available: boolean }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null }> };

export type BatchUpdateInterfaceFieldsFragment = { __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string, available: boolean }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null, updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null };

export type BatchUpdateInterfacesQueryVariables = Exact<{
  interfaceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BatchUpdateInterfacesQuery = { __typename?: 'Query', interfaces: Array<{ __typename?: 'Interface', id: string, name?: string | null, isOnline: boolean, firmwareVersion: { __typename?: 'InterfaceFirmwareVersion', version: string, timestamp: string, available: boolean }, pvtHeatPump?: { __typename?: 'PvtHeatPumpData', firmwareVersion?: number | null } | null, updateStatus?: { __typename?: 'UpdateStatus', progress: UpdateProgress, message: string, time: string, percentage?: number | null, device: UpdateDevice } | null }> };

export type SetInterfaceNameMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetInterfaceNameMutation = { __typename?: 'Mutation', setInterfaceName: { __typename?: 'Interface', id: string, name?: string | null } };

export type InteractiveSessionMutationVariables = Exact<{
  interfaceId: Scalars['String']['input'];
}>;


export type InteractiveSessionMutation = { __typename?: 'Mutation', interactiveSession: boolean };

export type HeatPumpPageFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type HeatPumpPageFilterQuery = { __typename?: 'Query', heatPumpPageFilter: { __typename?: 'HeatPumpPageFilter', searchText: string, offlineHeatPumps: boolean } };

export type LogPeriodQueryVariables = Exact<{ [key: string]: never; }>;


export type LogPeriodQuery = { __typename?: 'Query', logPeriod: LogPeriod };

export type UserNotificationFieldsFragment = { __typename?: 'Notification', id: string, title: Translation, content: Translation, type: NotificationType, severity?: NotificationSeverity | null, read: boolean, createdAt: string };

export type AdminNotificationFieldsFragment = { __typename?: 'Notification', expirationDate: string, id: string, title: Translation, content: Translation, type: NotificationType, severity?: NotificationSeverity | null, read: boolean, createdAt: string };

export type UserNotificationsQueryVariables = Exact<{
  types?: InputMaybe<Array<NotificationType> | NotificationType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, title: Translation, content: Translation, type: NotificationType, severity?: NotificationSeverity | null, read: boolean, createdAt: string }> };

export type AdminNotificationsQueryVariables = Exact<{
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<NotificationType> | NotificationType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', expirationDate: string, id: string, title: Translation, content: Translation, type: NotificationType, severity?: NotificationSeverity | null, read: boolean, createdAt: string }> };

export type UpsertNotificationMutationVariables = Exact<{
  notification: NotificationInput;
}>;


export type UpsertNotificationMutation = { __typename?: 'Mutation', upsertNotification: { __typename?: 'Notification', expirationDate: string, id: string, title: Translation, content: Translation, type: NotificationType, severity?: NotificationSeverity | null, read: boolean, createdAt: string } };

export type MarkNotificationReadMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type MarkNotificationReadMutation = { __typename?: 'Mutation', markNotificationRead: { __typename?: 'Notification', id: string, read: boolean } };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: boolean };

export type UserFieldsFragment = { __typename?: 'User', id: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumbers: Array<string>, roles: Array<Role>, hasAccount: boolean, isDeleted: boolean, deletedAt?: string | null, group?: { __typename?: 'Group', id: string, name: string, isOrganization: boolean } | null };

export type UserGroupFieldsFragment = { __typename?: 'Group', id: string, name: string, isOrganization: boolean };

export type UsersQueryVariables = Exact<{
  roles?: InputMaybe<Array<Role> | Role>;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumbers: Array<string>, roles: Array<Role>, hasAccount: boolean, isDeleted: boolean, deletedAt?: string | null, group?: { __typename?: 'Group', id: string, name: string, isOrganization: boolean } | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, isGroupAdmin?: boolean | null, firstName: string, lastName: string, email?: string | null, group?: { __typename?: 'Group', id: string, isOrganization: boolean } | null } };

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumbers: Array<string>, roles: Array<Role>, hasAccount: boolean, isDeleted: boolean, deletedAt?: string | null, group?: { __typename?: 'Group', id: string, name: string, isOrganization: boolean } | null } };

export type UpsertUserMutationVariables = Exact<{
  user: NewUser;
}>;


export type UpsertUserMutation = { __typename?: 'Mutation', upsertUser: { __typename?: 'User', id: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumbers: Array<string>, roles: Array<Role>, hasAccount: boolean, isDeleted: boolean, deletedAt?: string | null, group?: { __typename?: 'Group', id: string, name: string, isOrganization: boolean } | null } };

export type SettingsPageFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageFilterQuery = { __typename?: 'Query', settingsPageFilter: { __typename?: 'SettingsPageFilter', searchText?: string | null } };

export const InterfaceFirmwareVersionExpertFragmentDoc = gql`
    fragment InterfaceFirmwareVersionExpert on InterfaceFirmwareVersion {
  id
  timestamp
  version
}
    `;
export const MantovaFirmwareVersionExpertFragmentDoc = gql`
    fragment MantovaFirmwareVersionExpert on MantovaFirmwareVersion {
  id
  version
}
    `;
export const UpdateStatusFragmentDoc = gql`
    fragment UpdateStatus on Interface {
  updateStatus {
    progress
    message
    time
    percentage
    device
  }
}
    `;
export const GetCurrentUpdateStatusListFieldsFragmentDoc = gql`
    fragment GetCurrentUpdateStatusListFields on Interface {
  id
  isOnline
  ...UpdateStatus
  firmwareVersion {
    version
    timestamp
    available
  }
}
    ${UpdateStatusFragmentDoc}`;
export const MemberFieldsFragmentDoc = gql`
    fragment MemberFields on User {
  id
  email
  isGroupAdmin
  name
  isDeleted
  deletedAt
}
    `;
export const GroupFieldsFragmentDoc = gql`
    fragment GroupFields on Group {
  id
  isOrganization
  name
  isDeleted
  members {
    ...MemberFields
  }
}
    ${MemberFieldsFragmentDoc}`;
export const MemberFieldsSettingsFragmentDoc = gql`
    fragment MemberFieldsSettings on User {
  id
  name
  email
  roles
  isDeleted
  firstName
  lastName
  phoneNumbers
  hasAccount
  isGroupAdmin
}
    `;
export const InterfaceGroupFieldsFragmentDoc = gql`
    fragment InterfaceGroupFields on Interface {
  id
  groupInterfaceName
  accessLevel
}
    `;
export const GroupFieldsSettingsFragmentDoc = gql`
    fragment GroupFieldsSettings on Group {
  id
  name
  isDeleted
  isOrganization
  members {
    ...MemberFieldsSettings
  }
  interfaces {
    ...InterfaceGroupFields
  }
}
    ${MemberFieldsSettingsFragmentDoc}
${InterfaceGroupFieldsFragmentDoc}`;
export const PvtHeatPumpSettingsFieldsWizardFragmentDoc = gql`
    fragment PvtHeatPumpSettingsFieldsWizard on PvtHeatPumpData {
  id
  roomTemperatureControl
  firmwareVersion
  dhwMode
  flushingMode
  shBackupEnable
  roomControlType
  dhwAutoTemp
  auxInputTemp
  shRoomSetpTemp
  shBoostEnabled
  boostSourceTemp
  sinkCoolingPauseThresholdTemp
  shRoomHysteresisTemp
  scRoomSetpTemp
  scRoomHysteresisTemp
  errors
}
    `;
export const PvtHeatPumpSupplyCustomHeatingFragmentDoc = gql`
    fragment PvtHeatPumpSupplyCustomHeating on PvtHeatPumpData {
  dmTOutdoorShEnable
  dmHeatingThreshold
  supplyTempMin30CustomHeating
  supplyTempMin20CustomHeating
  supplyTempMin10CustomHeating
  supplyTemp0CustomHeating
  supplyTemp10CustomHeating
  supplyTemp20CustomHeating
  supplyTemp30CustomHeating
}
    `;
export const PvtHeatPumpSupplyCustomCoolingFragmentDoc = gql`
    fragment PvtHeatPumpSupplyCustomCooling on PvtHeatPumpData {
  dmTOutdoorScEnable
  dmCoolingThreshold
  supplyTemp20CustomCooling
  supplyTemp30CustomCooling
  supplyTemp40CustomCooling
}
    `;
export const PvtHeatPumpSettingsFieldsFragmentDoc = gql`
    fragment PvtHeatPumpSettingsFields on PvtHeatPumpData {
  id
  firmwareVersion
  dhwMode
  roomTemperatureControl
  roomControlType
  shBackupEnable
  sinkMinShTemp
  sinkMaxShTemp
  flushingMode
  dhwAutoTemp
  shRoomSetpTemp
  shRoomHysteresisTemp
  scRoomSetpTemp
  scRoomHysteresisTemp
  sinkCoolingPauseThresholdTemp
  dhwState
  spaceHeatingCoolingState
  shBoostEnabled
  dhwBoostEnabled
  boostSourceTemp
  errors
  enableSgInput
  sgAffectSh
  sgAffectSc
  sgAffectDhw
  sgAllowBhSh
  sgAllowBhDhw
  ...PvtHeatPumpSupplyCustomHeating
  ...PvtHeatPumpSupplyCustomCooling
}
    ${PvtHeatPumpSupplyCustomHeatingFragmentDoc}
${PvtHeatPumpSupplyCustomCoolingFragmentDoc}`;
export const PvtHeatPumpDmSetpointsFragmentDoc = gql`
    fragment PvtHeatPumpDMSetpoints on PvtHeatPumpData {
  dmHeatingThreshold
  dmCoolingThreshold
  dmBoostHeating
  dmTOutdoorShEnable
  dmTOutdoorScEnable
  dmTOutdoorBoostHeating
  coolingCurveOffset
  heatingCurveOffset
  heatingCurve
  outdoorTempFilterTime
  coolingCurve
  roomTemperatureControl
  ...PvtHeatPumpSupplyCustomCooling
  ...PvtHeatPumpSupplyCustomHeating
}
    ${PvtHeatPumpSupplyCustomCoolingFragmentDoc}
${PvtHeatPumpSupplyCustomHeatingFragmentDoc}`;
export const PvtHeatPumpDhwSchedulerFragmentDoc = gql`
    fragment PvtHeatPumpDhwScheduler on PvtHeatPumpData {
  id
  dhwScheduler {
    schedulerEnabled
    blockDHWEnabled
    forceDHWEnabled
    blockOnTime {
      hour
      minute
    }
    blockOffTime {
      hour
      minute
    }
    forceOnTime {
      hour
      minute
    }
    forceOffTime {
      hour
      minute
    }
  }
}
    `;
export const PvtHeatPumpAdminStatusFragmentDoc = gql`
    fragment PvtHeatPumpAdminStatus on Interface {
  id
  ioTHubID
  certificateValidUntil
}
    `;
export const HpErrorFieldsFragmentDoc = gql`
    fragment HPErrorFields on HPErrorData {
  errors
}
    `;
export const ModbusChangeFieldsFragmentDoc = gql`
    fragment ModbusChangeFields on ModbusChangeData {
  value
  address
  user {
    name
    email
    isDeleted
  }
}
    `;
export const EventFieldsFragmentDoc = gql`
    fragment EventFields on Event {
  type
  level
  start
  stop
  data {
    ... on HPErrorData {
      ...HPErrorFields
    }
    ... on ModbusChangeData {
      ...ModbusChangeFields
    }
  }
}
    ${HpErrorFieldsFragmentDoc}
${ModbusChangeFieldsFragmentDoc}`;
export const PvtHeatPumpAdminSettingDhwFragmentDoc = gql`
    fragment PvtHeatPumpAdminSettingDHW on PvtHeatPumpData {
  id
  dhwMode
  dhwAutoTemp
  dhwEcoTemp
  dhwBoostTemp
  dhwPassiveEnable
  dhwCombinedEnable
  dhwActiveEnable
  dhwBackupEnable
  dhwLegionelaEnable
  dhwLegionelaTemp
  dhwLegionelaDay
  dhwLegionellaMaxCondensationTemp
  dhwHysteresisUpperBound
  dhwHysteresisLowerBound
}
    `;
export const PvtHeatPumpAdminSettingsGeneralFragmentDoc = gql`
    fragment PvtHeatPumpAdminSettingsGeneral on PvtHeatPumpData {
  id
  firmwareVersion
  pauseTimeMin
  dhwPriorityTimeMin
  shPriorityTimeMin
  scPriorityTimeMin
  pasiveOperationMinSourceTemp
  passiveMinDeltaT
  preheatDeltaT
  enableSgInput
  sgAffectSh
  sgAffectSc
  sgAffectDhw
  sgAllowBhSh
  sgAllowBhDhw
}
    `;
export const PvtHeatPumpAdminSettingsHeatingCoolingFragmentDoc = gql`
    fragment PvtHeatPumpAdminSettingsHeatingCooling on PvtHeatPumpData {
  id
  firmwareVersion
  roomTemperatureControl
  roomControlType
  shPasiveEnable
  shCombineEnable
  shActiveEnable
  shBackupEnable
  scPasiveEnable
  scCombineEnable
  scActiveEnable
  shRoomSetpTemp
  shRoomHysteresisTemp
  sinkMaxShTemp
  sinkMinShTemp
  scRoomSetpTemp
  scRoomHysteresisTemp
  supplyTempAtHiOutdoorTemp
  supplyTempAtLowOutdoorTemp
  outdoorHiTemp
  sinkCoolingPauseThresholdTemp
  auxRelayMode
}
    `;
export const PvtHeatPumpAdminOverrideFragmentDoc = gql`
    fragment PvtHeatPumpAdminOverride on PvtHeatPumpData {
  id
  inputOverrideMask
  bt1OverrideValue
  bt2OverrideValue
  bt3OverrideValue
  bt4OverrideValue
  bt5OverrideValue
  bt6OverrideValue
  bt7OverrideValue
  btAux1OverrideValue
  btAux2OverrideValue
  btAux3OverrideValue
  outputOverrideMask
  gq1Compressor1Override
  gq1Compressor2Override
  eb1ElectricHeaterRelayOverride
  qn44WayValveRelayOverride
  auxRelayOverride
  gp1Gp2PumpRelayOverride
  gp1PumpSourcePwmOverride
  gp2PumpSinkPwmOverride
  qn2HeatSourceValveOverride
  qn3HeatSinkValveOverride
}
    `;
export const PvtHeatPumpAdminSecurityFragmentDoc = gql`
    fragment PvtHeatPumpAdminSecurity on PvtHeatPumpData {
  id
  maxCondensationTemp
  sourceMinTemp
  sourceMaxTemp
  maxDischargeTemp
  maxLiquidlineCoolTemp
  minEvapCoolTemp
  compressorOffToOnDelaySec
  startupTimeSec
  evapMaxTempHeating
  evapNoCapDt
  condenserNoCapDt
  condenserMaxTemp
  evapNoRefigDt
  condenserNoRefigDt
  dhwSinkMinTemp
  dhwSinkMaxTemp
  evapMinBt2HeatTemp
  spaceActiveOrCombinedMinTime
  dhwActiveOrCombinedMinTime
  backupByErrorEnabled
  envelopeSinkHighTemp
  envelopeSinkLowTemp
  envelopeBackupSourceHighTemp
  envelopeBackupSourceLowTemp
  envelopeBackupDhwGoBackHystTemp
  envelopeBackupShGoBackHystTemp
}
    `;
export const PvtHeatPumpAdminDateTimeFragmentDoc = gql`
    fragment PvtHeatPumpAdminDateTime on PvtHeatPumpData {
  id
  curTimeMin
  curTimeHour
  curTimeDay
  curTimeDate
  curTimeMonth
  curTimeYear
  daylightSavingEnable
}
    `;
export const PvtHeatPumpAdminSettingsPumpsFragmentDoc = gql`
    fragment PvtHeatPumpAdminSettingsPumps on PvtHeatPumpData {
  id
  flushingMode
  sourcePumpMaxSpeedPerc
  sinkPumpMaxSpeedPerc
  dhwActiveSourceDeltaT
  dhwCombinedSinkDeltaT
  dhwActiveSinkDeltaT
  shActiveSourceDeltaT
  shFloorActiveSinkDeltaT
  shRadiatorActiveSinkDeltaT
  shFloorCombinedSinkDeltaT
  shRadiatorCombinedSinkDeltaT
  scActiveSourceDeltaT
  scActiveSinkDeltaT
  scCombinedSinkDeltaT
  scPassiveSinkDeltaT
  sourcePumpMinSpeedPerc
  sinkPumpMinSpeedPerc
  pumpPiRegulatorGain
  pumpPiRegulatorIntegrationTimeSec
}
    `;
export const PvtHeatPumpAdminSettingsFragmentDoc = gql`
    fragment PvtHeatPumpAdminSettings on PvtHeatPumpData {
  id
  ...PvtHeatPumpAdminSettingDHW
  ...PvtHeatPumpAdminSettingsGeneral
  ...PvtHeatPumpAdminSettingsHeatingCooling
  ...PvtHeatPumpAdminOverride
  ...PvtHeatPumpAdminSecurity
  ...PvtHeatPumpAdminDateTime
  ...PvtHeatPumpAdminSettingsPumps
}
    ${PvtHeatPumpAdminSettingDhwFragmentDoc}
${PvtHeatPumpAdminSettingsGeneralFragmentDoc}
${PvtHeatPumpAdminSettingsHeatingCoolingFragmentDoc}
${PvtHeatPumpAdminOverrideFragmentDoc}
${PvtHeatPumpAdminSecurityFragmentDoc}
${PvtHeatPumpAdminDateTimeFragmentDoc}
${PvtHeatPumpAdminSettingsPumpsFragmentDoc}`;
export const ResidentControllerSettingsFieldsFragmentDoc = gql`
    fragment ResidentControllerSettingsFields on ControllerSettingsData {
  backupHeater
  chSetpMaxTemp
  manualCoolingMode
}
    `;
export const HeatPumpGroupFieldsFragmentDoc = gql`
    fragment HeatPumpGroupFields on Group {
  id
  name
  isOrganization
  isDeleted
  deletedAt
  heatPumpName @include(if: $isInternal)
}
    `;
export const CompressorWaitTimeFieldsFragmentDoc = gql`
    fragment CompressorWaitTimeFields on PvtHeatPumpData {
  id
  timestamp
  compressorOffTime
  compressorOffToOnDelaySec
  startupTimeSec
  startupCountdown
  spaceHeatingCoolingState
  dhwState
  pauseTimeMin
  spaceHeatingCoolingPauseTime
  dhwPauseTime
}
    `;
export const PvtHeatPumpStatusFieldsFragmentDoc = gql`
    fragment PvtHeatPumpStatusFields on PvtHeatPumpData {
  id
  spaceHeatDemand
  spaceCoolDemand
  dhwDemand
  spaceHeatingCoolingState
  dhwState
  dhwBoilerTemp
  compressorOn
  electricElementOn
  coolingValveEnabled
  pumpRelayOn
  sourcePumpPerc
  sinkPumpPerc
  sourceInTemp
  sourceOutTemp
  sinkInTemp
  sinkOutTemp
  compressorDischarge
  errors
  roomControlType
  shRoomSetpTemp
  auxInputTemp
  dmSh
  dmSc
  ...CompressorWaitTimeFields
}
    ${CompressorWaitTimeFieldsFragmentDoc}`;
export const InterfaceStatusFieldsFragmentDoc = gql`
    fragment InterfaceStatusFields on Interface {
  id
  firmwareVersion {
    version
    timestamp
  }
  openThermBoilerConnected
  openThermThermostatConnected
  pvtHeatPump {
    ...PvtHeatPumpStatusFields
  }
  openTherm {
    roomTemp
    roomSetpTemp
  }
  status {
    signalStrength
    operatorName
  }
}
    ${PvtHeatPumpStatusFieldsFragmentDoc}`;
export const HeatPumpSlaveFieldsFragmentDoc = gql`
    fragment HeatPumpSlaveFields on Interface {
  id
  slave {
    id
    name
  }
}
    `;
export const InterfaceFieldsFragmentDoc = gql`
    fragment InterfaceFields on Interface {
  id
  name
  isOnline
  lastMessage
  pvtHeatPump(fromDB: true) {
    errors
  }
}
    `;
export const ElectricityMeterFieldsFragmentDoc = gql`
    fragment ElectricityMeterFields on ElectricityData {
  power
}
    `;
export const HeatMeterFieldsFragmentDoc = gql`
    fragment HeatMeterFields on HeatData {
  power
  flow
}
    `;
export const ResidentHeatPumpDataFieldsFragmentDoc = gql`
    fragment ResidentHeatPumpDataFields on PvtHeatPumpData {
  sourceInTemp
  sourceOutTemp
  sinkInTemp
  sinkOutTemp
  dhwBoilerTemp
  compressorOn
  errors
  dhwState
  spaceHeatingCoolingState
  auxInputTemp
  hasOnOffThermostatDemand
}
    `;
export const HeatPumpDataFieldsFragmentDoc = gql`
    fragment HeatPumpDataFields on PvtHeatPumpData {
  ...ResidentHeatPumpDataFields
  sourcePumpPerc
  sinkPumpPerc
}
    ${ResidentHeatPumpDataFieldsFragmentDoc}`;
export const OpenThermDataFieldsFragmentDoc = gql`
    fragment OpenThermDataFields on OpenThermData {
  roomTemp
  roomSetpTemp
  chFeedTemp
  chSetpTemp
  modulationLevelPerc
  chEnable
  coolingEnable
  coolingPercSetp
}
    `;
export const InterfaceLogDataFragmentDoc = gql`
    fragment InterfaceLogData on InterfaceLog {
  timestamp
  heatPumpElectricityMeter {
    ...ElectricityMeterFields
  }
  heatingHeatMeter {
    ...HeatMeterFields
  }
  sourceHeatMeter {
    ...HeatMeterFields
  }
  pvtHeatPump {
    ...HeatPumpDataFields
  }
  boiler {
    ...OpenThermDataFields
  }
  thermostat {
    ...OpenThermDataFields
  }
}
    ${ElectricityMeterFieldsFragmentDoc}
${HeatMeterFieldsFragmentDoc}
${HeatPumpDataFieldsFragmentDoc}
${OpenThermDataFieldsFragmentDoc}`;
export const ResidentBoilerOpenThermDataFieldsFragmentDoc = gql`
    fragment ResidentBoilerOpenThermDataFields on OpenThermData {
  chFeedTemp
  modulationLevelPerc
  chEnable
}
    `;
export const ResidentInterfaceLogDataFragmentDoc = gql`
    fragment ResidentInterfaceLogData on InterfaceLog {
  timestamp
  heatPumpElectricityMeter {
    ...ElectricityMeterFields
  }
  heatingHeatMeter {
    ...HeatMeterFields
  }
  sourceHeatMeter {
    ...HeatMeterFields
  }
  pvtHeatPump {
    ...ResidentHeatPumpDataFields
  }
  boiler {
    ...ResidentBoilerOpenThermDataFields
  }
  thermostat {
    ...OpenThermDataFields
  }
}
    ${ElectricityMeterFieldsFragmentDoc}
${HeatMeterFieldsFragmentDoc}
${ResidentHeatPumpDataFieldsFragmentDoc}
${ResidentBoilerOpenThermDataFieldsFragmentDoc}
${OpenThermDataFieldsFragmentDoc}`;
export const InterfaceIdsFieldsFragmentDoc = gql`
    fragment InterfaceIdsFields on Interface {
  id
  name
}
    `;
export const InterfacesFieldsFragmentDoc = gql`
    fragment InterfacesFields on Interface {
  id
  name
  isOnline
  firmwareVersion {
    version
    timestamp
    available
  }
  pvtHeatPump {
    firmwareVersion
  }
}
    `;
export const BatchUpdateInterfaceFieldsFragmentDoc = gql`
    fragment BatchUpdateInterfaceFields on Interface {
  ...InterfacesFields
  ...UpdateStatus
}
    ${InterfacesFieldsFragmentDoc}
${UpdateStatusFragmentDoc}`;
export const UserNotificationFieldsFragmentDoc = gql`
    fragment UserNotificationFields on Notification {
  id
  title
  content
  type
  severity
  read
  createdAt
}
    `;
export const AdminNotificationFieldsFragmentDoc = gql`
    fragment AdminNotificationFields on Notification {
  ...UserNotificationFields
  expirationDate
}
    ${UserNotificationFieldsFragmentDoc}`;
export const UserGroupFieldsFragmentDoc = gql`
    fragment UserGroupFields on Group {
  id
  name
  isOrganization
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  name
  firstName
  lastName
  email
  phoneNumbers
  roles
  hasAccount
  isDeleted
  deletedAt
  group {
    ...UserGroupFields
  }
}
    ${UserGroupFieldsFragmentDoc}`;
export const GetInterfaceFirmwareUpdatesInternalDocument = gql`
    query GetInterfaceFirmwareUpdatesInternal {
  getInterfaceFirmwareUpdates {
    id
    default
    description
    name
    timestamp
    version
    available
  }
}
    `;

/**
 * __useGetInterfaceFirmwareUpdatesInternalQuery__
 *
 * To run a query within a React component, call `useGetInterfaceFirmwareUpdatesInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterfaceFirmwareUpdatesInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterfaceFirmwareUpdatesInternalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterfaceFirmwareUpdatesInternalQuery(baseOptions?: Apollo.QueryHookOptions<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>(GetInterfaceFirmwareUpdatesInternalDocument, options);
      }
export function useGetInterfaceFirmwareUpdatesInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>(GetInterfaceFirmwareUpdatesInternalDocument, options);
        }
export function useGetInterfaceFirmwareUpdatesInternalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>(GetInterfaceFirmwareUpdatesInternalDocument, options);
        }
export type GetInterfaceFirmwareUpdatesInternalQueryHookResult = ReturnType<typeof useGetInterfaceFirmwareUpdatesInternalQuery>;
export type GetInterfaceFirmwareUpdatesInternalLazyQueryHookResult = ReturnType<typeof useGetInterfaceFirmwareUpdatesInternalLazyQuery>;
export type GetInterfaceFirmwareUpdatesInternalSuspenseQueryHookResult = ReturnType<typeof useGetInterfaceFirmwareUpdatesInternalSuspenseQuery>;
export type GetInterfaceFirmwareUpdatesInternalQueryResult = Apollo.QueryResult<GetInterfaceFirmwareUpdatesInternalQuery, GetInterfaceFirmwareUpdatesInternalQueryVariables>;
export const GetMantovaFirmwareUpdatesInternalDocument = gql`
    query GetMantovaFirmwareUpdatesInternal {
  getMantovaFirmwareUpdates {
    id
    name
    available
    default
    version
    description
  }
}
    `;

/**
 * __useGetMantovaFirmwareUpdatesInternalQuery__
 *
 * To run a query within a React component, call `useGetMantovaFirmwareUpdatesInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMantovaFirmwareUpdatesInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMantovaFirmwareUpdatesInternalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMantovaFirmwareUpdatesInternalQuery(baseOptions?: Apollo.QueryHookOptions<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>(GetMantovaFirmwareUpdatesInternalDocument, options);
      }
export function useGetMantovaFirmwareUpdatesInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>(GetMantovaFirmwareUpdatesInternalDocument, options);
        }
export function useGetMantovaFirmwareUpdatesInternalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>(GetMantovaFirmwareUpdatesInternalDocument, options);
        }
export type GetMantovaFirmwareUpdatesInternalQueryHookResult = ReturnType<typeof useGetMantovaFirmwareUpdatesInternalQuery>;
export type GetMantovaFirmwareUpdatesInternalLazyQueryHookResult = ReturnType<typeof useGetMantovaFirmwareUpdatesInternalLazyQuery>;
export type GetMantovaFirmwareUpdatesInternalSuspenseQueryHookResult = ReturnType<typeof useGetMantovaFirmwareUpdatesInternalSuspenseQuery>;
export type GetMantovaFirmwareUpdatesInternalQueryResult = Apollo.QueryResult<GetMantovaFirmwareUpdatesInternalQuery, GetMantovaFirmwareUpdatesInternalQueryVariables>;
export const GetInterfaceFirmwareUpdatesExpertDocument = gql`
    query GetInterfaceFirmwareUpdatesExpert {
  getInterfaceFirmwareUpdates {
    ...InterfaceFirmwareVersionExpert
  }
}
    ${InterfaceFirmwareVersionExpertFragmentDoc}`;

/**
 * __useGetInterfaceFirmwareUpdatesExpertQuery__
 *
 * To run a query within a React component, call `useGetInterfaceFirmwareUpdatesExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterfaceFirmwareUpdatesExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterfaceFirmwareUpdatesExpertQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterfaceFirmwareUpdatesExpertQuery(baseOptions?: Apollo.QueryHookOptions<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>(GetInterfaceFirmwareUpdatesExpertDocument, options);
      }
export function useGetInterfaceFirmwareUpdatesExpertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>(GetInterfaceFirmwareUpdatesExpertDocument, options);
        }
export function useGetInterfaceFirmwareUpdatesExpertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>(GetInterfaceFirmwareUpdatesExpertDocument, options);
        }
export type GetInterfaceFirmwareUpdatesExpertQueryHookResult = ReturnType<typeof useGetInterfaceFirmwareUpdatesExpertQuery>;
export type GetInterfaceFirmwareUpdatesExpertLazyQueryHookResult = ReturnType<typeof useGetInterfaceFirmwareUpdatesExpertLazyQuery>;
export type GetInterfaceFirmwareUpdatesExpertSuspenseQueryHookResult = ReturnType<typeof useGetInterfaceFirmwareUpdatesExpertSuspenseQuery>;
export type GetInterfaceFirmwareUpdatesExpertQueryResult = Apollo.QueryResult<GetInterfaceFirmwareUpdatesExpertQuery, GetInterfaceFirmwareUpdatesExpertQueryVariables>;
export const GetMantovaFirmwareUpdatesExpertDocument = gql`
    query GetMantovaFirmwareUpdatesExpert {
  getMantovaFirmwareUpdates {
    ...MantovaFirmwareVersionExpert
  }
}
    ${MantovaFirmwareVersionExpertFragmentDoc}`;

/**
 * __useGetMantovaFirmwareUpdatesExpertQuery__
 *
 * To run a query within a React component, call `useGetMantovaFirmwareUpdatesExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMantovaFirmwareUpdatesExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMantovaFirmwareUpdatesExpertQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMantovaFirmwareUpdatesExpertQuery(baseOptions?: Apollo.QueryHookOptions<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>(GetMantovaFirmwareUpdatesExpertDocument, options);
      }
export function useGetMantovaFirmwareUpdatesExpertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>(GetMantovaFirmwareUpdatesExpertDocument, options);
        }
export function useGetMantovaFirmwareUpdatesExpertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>(GetMantovaFirmwareUpdatesExpertDocument, options);
        }
export type GetMantovaFirmwareUpdatesExpertQueryHookResult = ReturnType<typeof useGetMantovaFirmwareUpdatesExpertQuery>;
export type GetMantovaFirmwareUpdatesExpertLazyQueryHookResult = ReturnType<typeof useGetMantovaFirmwareUpdatesExpertLazyQuery>;
export type GetMantovaFirmwareUpdatesExpertSuspenseQueryHookResult = ReturnType<typeof useGetMantovaFirmwareUpdatesExpertSuspenseQuery>;
export type GetMantovaFirmwareUpdatesExpertQueryResult = Apollo.QueryResult<GetMantovaFirmwareUpdatesExpertQuery, GetMantovaFirmwareUpdatesExpertQueryVariables>;
export const GetCurrentInterfaceFirmwareVersionExpertDocument = gql`
    query GetCurrentInterfaceFirmwareVersionExpert($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    firmwareVersion {
      ...InterfaceFirmwareVersionExpert
    }
  }
}
    ${InterfaceFirmwareVersionExpertFragmentDoc}`;

/**
 * __useGetCurrentInterfaceFirmwareVersionExpertQuery__
 *
 * To run a query within a React component, call `useGetCurrentInterfaceFirmwareVersionExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentInterfaceFirmwareVersionExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentInterfaceFirmwareVersionExpertQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useGetCurrentInterfaceFirmwareVersionExpertQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables> & ({ variables: GetCurrentInterfaceFirmwareVersionExpertQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables>(GetCurrentInterfaceFirmwareVersionExpertDocument, options);
      }
export function useGetCurrentInterfaceFirmwareVersionExpertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables>(GetCurrentInterfaceFirmwareVersionExpertDocument, options);
        }
export function useGetCurrentInterfaceFirmwareVersionExpertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables>(GetCurrentInterfaceFirmwareVersionExpertDocument, options);
        }
export type GetCurrentInterfaceFirmwareVersionExpertQueryHookResult = ReturnType<typeof useGetCurrentInterfaceFirmwareVersionExpertQuery>;
export type GetCurrentInterfaceFirmwareVersionExpertLazyQueryHookResult = ReturnType<typeof useGetCurrentInterfaceFirmwareVersionExpertLazyQuery>;
export type GetCurrentInterfaceFirmwareVersionExpertSuspenseQueryHookResult = ReturnType<typeof useGetCurrentInterfaceFirmwareVersionExpertSuspenseQuery>;
export type GetCurrentInterfaceFirmwareVersionExpertQueryResult = Apollo.QueryResult<GetCurrentInterfaceFirmwareVersionExpertQuery, GetCurrentInterfaceFirmwareVersionExpertQueryVariables>;
export const GetCurrentInterfaceFirmwareVersionInternalDocument = gql`
    query GetCurrentInterfaceFirmwareVersionInternal($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    firmwareVersion {
      name
      timestamp
    }
  }
}
    `;

/**
 * __useGetCurrentInterfaceFirmwareVersionInternalQuery__
 *
 * To run a query within a React component, call `useGetCurrentInterfaceFirmwareVersionInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentInterfaceFirmwareVersionInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentInterfaceFirmwareVersionInternalQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useGetCurrentInterfaceFirmwareVersionInternalQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables> & ({ variables: GetCurrentInterfaceFirmwareVersionInternalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables>(GetCurrentInterfaceFirmwareVersionInternalDocument, options);
      }
export function useGetCurrentInterfaceFirmwareVersionInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables>(GetCurrentInterfaceFirmwareVersionInternalDocument, options);
        }
export function useGetCurrentInterfaceFirmwareVersionInternalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables>(GetCurrentInterfaceFirmwareVersionInternalDocument, options);
        }
export type GetCurrentInterfaceFirmwareVersionInternalQueryHookResult = ReturnType<typeof useGetCurrentInterfaceFirmwareVersionInternalQuery>;
export type GetCurrentInterfaceFirmwareVersionInternalLazyQueryHookResult = ReturnType<typeof useGetCurrentInterfaceFirmwareVersionInternalLazyQuery>;
export type GetCurrentInterfaceFirmwareVersionInternalSuspenseQueryHookResult = ReturnType<typeof useGetCurrentInterfaceFirmwareVersionInternalSuspenseQuery>;
export type GetCurrentInterfaceFirmwareVersionInternalQueryResult = Apollo.QueryResult<GetCurrentInterfaceFirmwareVersionInternalQuery, GetCurrentInterfaceFirmwareVersionInternalQueryVariables>;
export const GetCurrentFirmwareVersionExpertDocument = gql`
    query GetCurrentFirmwareVersionExpert($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      firmwareVersion
    }
    firmwareVersion {
      timestamp
    }
  }
}
    `;

/**
 * __useGetCurrentFirmwareVersionExpertQuery__
 *
 * To run a query within a React component, call `useGetCurrentFirmwareVersionExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentFirmwareVersionExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentFirmwareVersionExpertQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useGetCurrentFirmwareVersionExpertQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables> & ({ variables: GetCurrentFirmwareVersionExpertQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables>(GetCurrentFirmwareVersionExpertDocument, options);
      }
export function useGetCurrentFirmwareVersionExpertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables>(GetCurrentFirmwareVersionExpertDocument, options);
        }
export function useGetCurrentFirmwareVersionExpertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables>(GetCurrentFirmwareVersionExpertDocument, options);
        }
export type GetCurrentFirmwareVersionExpertQueryHookResult = ReturnType<typeof useGetCurrentFirmwareVersionExpertQuery>;
export type GetCurrentFirmwareVersionExpertLazyQueryHookResult = ReturnType<typeof useGetCurrentFirmwareVersionExpertLazyQuery>;
export type GetCurrentFirmwareVersionExpertSuspenseQueryHookResult = ReturnType<typeof useGetCurrentFirmwareVersionExpertSuspenseQuery>;
export type GetCurrentFirmwareVersionExpertQueryResult = Apollo.QueryResult<GetCurrentFirmwareVersionExpertQuery, GetCurrentFirmwareVersionExpertQueryVariables>;
export const GetCurrentFirmwareVersionDocument = gql`
    query GetCurrentFirmwareVersion($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      firmwareVersion
    }
    firmwareVersion {
      name
      timestamp
    }
  }
}
    `;

/**
 * __useGetCurrentFirmwareVersionQuery__
 *
 * To run a query within a React component, call `useGetCurrentFirmwareVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentFirmwareVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentFirmwareVersionQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useGetCurrentFirmwareVersionQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables> & ({ variables: GetCurrentFirmwareVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables>(GetCurrentFirmwareVersionDocument, options);
      }
export function useGetCurrentFirmwareVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables>(GetCurrentFirmwareVersionDocument, options);
        }
export function useGetCurrentFirmwareVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables>(GetCurrentFirmwareVersionDocument, options);
        }
export type GetCurrentFirmwareVersionQueryHookResult = ReturnType<typeof useGetCurrentFirmwareVersionQuery>;
export type GetCurrentFirmwareVersionLazyQueryHookResult = ReturnType<typeof useGetCurrentFirmwareVersionLazyQuery>;
export type GetCurrentFirmwareVersionSuspenseQueryHookResult = ReturnType<typeof useGetCurrentFirmwareVersionSuspenseQuery>;
export type GetCurrentFirmwareVersionQueryResult = Apollo.QueryResult<GetCurrentFirmwareVersionQuery, GetCurrentFirmwareVersionQueryVariables>;
export const GetCurrentUpdateStatusDocument = gql`
    query GetCurrentUpdateStatus($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    ...UpdateStatus
  }
}
    ${UpdateStatusFragmentDoc}`;

/**
 * __useGetCurrentUpdateStatusQuery__
 *
 * To run a query within a React component, call `useGetCurrentUpdateStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUpdateStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUpdateStatusQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useGetCurrentUpdateStatusQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables> & ({ variables: GetCurrentUpdateStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables>(GetCurrentUpdateStatusDocument, options);
      }
export function useGetCurrentUpdateStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables>(GetCurrentUpdateStatusDocument, options);
        }
export function useGetCurrentUpdateStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables>(GetCurrentUpdateStatusDocument, options);
        }
export type GetCurrentUpdateStatusQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusQuery>;
export type GetCurrentUpdateStatusLazyQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusLazyQuery>;
export type GetCurrentUpdateStatusSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusSuspenseQuery>;
export type GetCurrentUpdateStatusQueryResult = Apollo.QueryResult<GetCurrentUpdateStatusQuery, GetCurrentUpdateStatusQueryVariables>;
export const GetCurrentUpdateStatusListDocument = gql`
    query GetCurrentUpdateStatusList($interfaceIds: [String!]!) {
  interfaces(interfaceIds: $interfaceIds) {
    ...GetCurrentUpdateStatusListFields
  }
}
    ${GetCurrentUpdateStatusListFieldsFragmentDoc}`;

/**
 * __useGetCurrentUpdateStatusListQuery__
 *
 * To run a query within a React component, call `useGetCurrentUpdateStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUpdateStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUpdateStatusListQuery({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *   },
 * });
 */
export function useGetCurrentUpdateStatusListQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables> & ({ variables: GetCurrentUpdateStatusListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables>(GetCurrentUpdateStatusListDocument, options);
      }
export function useGetCurrentUpdateStatusListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables>(GetCurrentUpdateStatusListDocument, options);
        }
export function useGetCurrentUpdateStatusListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables>(GetCurrentUpdateStatusListDocument, options);
        }
export type GetCurrentUpdateStatusListQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusListQuery>;
export type GetCurrentUpdateStatusListLazyQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusListLazyQuery>;
export type GetCurrentUpdateStatusListSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusListSuspenseQuery>;
export type GetCurrentUpdateStatusListQueryResult = Apollo.QueryResult<GetCurrentUpdateStatusListQuery, GetCurrentUpdateStatusListQueryVariables>;
export const GetCurrentUpdateStatusHeatPumpListDocument = gql`
    query GetCurrentUpdateStatusHeatPumpList($interfaceIds: [String!]!) {
  interfaces(interfaceIds: $interfaceIds) {
    id
    pvtHeatPump {
      firmwareVersion
    }
    ...UpdateStatus
  }
}
    ${UpdateStatusFragmentDoc}`;

/**
 * __useGetCurrentUpdateStatusHeatPumpListQuery__
 *
 * To run a query within a React component, call `useGetCurrentUpdateStatusHeatPumpListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUpdateStatusHeatPumpListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUpdateStatusHeatPumpListQuery({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *   },
 * });
 */
export function useGetCurrentUpdateStatusHeatPumpListQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables> & ({ variables: GetCurrentUpdateStatusHeatPumpListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables>(GetCurrentUpdateStatusHeatPumpListDocument, options);
      }
export function useGetCurrentUpdateStatusHeatPumpListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables>(GetCurrentUpdateStatusHeatPumpListDocument, options);
        }
export function useGetCurrentUpdateStatusHeatPumpListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables>(GetCurrentUpdateStatusHeatPumpListDocument, options);
        }
export type GetCurrentUpdateStatusHeatPumpListQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusHeatPumpListQuery>;
export type GetCurrentUpdateStatusHeatPumpListLazyQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusHeatPumpListLazyQuery>;
export type GetCurrentUpdateStatusHeatPumpListSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUpdateStatusHeatPumpListSuspenseQuery>;
export type GetCurrentUpdateStatusHeatPumpListQueryResult = Apollo.QueryResult<GetCurrentUpdateStatusHeatPumpListQuery, GetCurrentUpdateStatusHeatPumpListQueryVariables>;
export const UpdateInterfaceFirmwareDocument = gql`
    mutation UpdateInterfaceFirmware($interfaceIds: [String!]!, $firmwareId: ID) {
  updateInterfaceFirmware(interfaceIds: $interfaceIds, firmwareId: $firmwareId)
}
    `;
export type UpdateInterfaceFirmwareMutationFn = Apollo.MutationFunction<UpdateInterfaceFirmwareMutation, UpdateInterfaceFirmwareMutationVariables>;

/**
 * __useUpdateInterfaceFirmwareMutation__
 *
 * To run a mutation, you first call `useUpdateInterfaceFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterfaceFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterfaceFirmwareMutation, { data, loading, error }] = useUpdateInterfaceFirmwareMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *      firmwareId: // value for 'firmwareId'
 *   },
 * });
 */
export function useUpdateInterfaceFirmwareMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterfaceFirmwareMutation, UpdateInterfaceFirmwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterfaceFirmwareMutation, UpdateInterfaceFirmwareMutationVariables>(UpdateInterfaceFirmwareDocument, options);
      }
export type UpdateInterfaceFirmwareMutationHookResult = ReturnType<typeof useUpdateInterfaceFirmwareMutation>;
export type UpdateInterfaceFirmwareMutationResult = Apollo.MutationResult<UpdateInterfaceFirmwareMutation>;
export type UpdateInterfaceFirmwareMutationOptions = Apollo.BaseMutationOptions<UpdateInterfaceFirmwareMutation, UpdateInterfaceFirmwareMutationVariables>;
export const UpdateMantovaFirmwareDocument = gql`
    mutation UpdateMantovaFirmware($interfaceIds: [String!]!, $firmwareId: ID) {
  updateMantovaFirmware(interfaceIds: $interfaceIds, firmwareId: $firmwareId)
}
    `;
export type UpdateMantovaFirmwareMutationFn = Apollo.MutationFunction<UpdateMantovaFirmwareMutation, UpdateMantovaFirmwareMutationVariables>;

/**
 * __useUpdateMantovaFirmwareMutation__
 *
 * To run a mutation, you first call `useUpdateMantovaFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMantovaFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMantovaFirmwareMutation, { data, loading, error }] = useUpdateMantovaFirmwareMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *      firmwareId: // value for 'firmwareId'
 *   },
 * });
 */
export function useUpdateMantovaFirmwareMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMantovaFirmwareMutation, UpdateMantovaFirmwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMantovaFirmwareMutation, UpdateMantovaFirmwareMutationVariables>(UpdateMantovaFirmwareDocument, options);
      }
export type UpdateMantovaFirmwareMutationHookResult = ReturnType<typeof useUpdateMantovaFirmwareMutation>;
export type UpdateMantovaFirmwareMutationResult = Apollo.MutationResult<UpdateMantovaFirmwareMutation>;
export type UpdateMantovaFirmwareMutationOptions = Apollo.BaseMutationOptions<UpdateMantovaFirmwareMutation, UpdateMantovaFirmwareMutationVariables>;
export const SetDefaultInterfaceFirmwareDocument = gql`
    mutation setDefaultInterfaceFirmware($firmwareId: ID!) {
  setDefaultInterfaceFirmware(id: $firmwareId) {
    id
    default
  }
}
    `;
export type SetDefaultInterfaceFirmwareMutationFn = Apollo.MutationFunction<SetDefaultInterfaceFirmwareMutation, SetDefaultInterfaceFirmwareMutationVariables>;

/**
 * __useSetDefaultInterfaceFirmwareMutation__
 *
 * To run a mutation, you first call `useSetDefaultInterfaceFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultInterfaceFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultInterfaceFirmwareMutation, { data, loading, error }] = useSetDefaultInterfaceFirmwareMutation({
 *   variables: {
 *      firmwareId: // value for 'firmwareId'
 *   },
 * });
 */
export function useSetDefaultInterfaceFirmwareMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultInterfaceFirmwareMutation, SetDefaultInterfaceFirmwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultInterfaceFirmwareMutation, SetDefaultInterfaceFirmwareMutationVariables>(SetDefaultInterfaceFirmwareDocument, options);
      }
export type SetDefaultInterfaceFirmwareMutationHookResult = ReturnType<typeof useSetDefaultInterfaceFirmwareMutation>;
export type SetDefaultInterfaceFirmwareMutationResult = Apollo.MutationResult<SetDefaultInterfaceFirmwareMutation>;
export type SetDefaultInterfaceFirmwareMutationOptions = Apollo.BaseMutationOptions<SetDefaultInterfaceFirmwareMutation, SetDefaultInterfaceFirmwareMutationVariables>;
export const SetDefaultMantovaFirmwareDocument = gql`
    mutation SetDefaultMantovaFirmware($firmwareId: ID!) {
  setDefaultMantovaFirmware(id: $firmwareId) {
    id
    default
  }
}
    `;
export type SetDefaultMantovaFirmwareMutationFn = Apollo.MutationFunction<SetDefaultMantovaFirmwareMutation, SetDefaultMantovaFirmwareMutationVariables>;

/**
 * __useSetDefaultMantovaFirmwareMutation__
 *
 * To run a mutation, you first call `useSetDefaultMantovaFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultMantovaFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultMantovaFirmwareMutation, { data, loading, error }] = useSetDefaultMantovaFirmwareMutation({
 *   variables: {
 *      firmwareId: // value for 'firmwareId'
 *   },
 * });
 */
export function useSetDefaultMantovaFirmwareMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultMantovaFirmwareMutation, SetDefaultMantovaFirmwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultMantovaFirmwareMutation, SetDefaultMantovaFirmwareMutationVariables>(SetDefaultMantovaFirmwareDocument, options);
      }
export type SetDefaultMantovaFirmwareMutationHookResult = ReturnType<typeof useSetDefaultMantovaFirmwareMutation>;
export type SetDefaultMantovaFirmwareMutationResult = Apollo.MutationResult<SetDefaultMantovaFirmwareMutation>;
export type SetDefaultMantovaFirmwareMutationOptions = Apollo.BaseMutationOptions<SetDefaultMantovaFirmwareMutation, SetDefaultMantovaFirmwareMutationVariables>;
export const MyGroupDocument = gql`
    query MyGroup {
  me {
    id
    name
    isGroupAdmin
    group {
      ...GroupFields
      interfaces {
        ...InterfaceFields
      }
    }
  }
}
    ${GroupFieldsFragmentDoc}
${InterfaceFieldsFragmentDoc}`;

/**
 * __useMyGroupQuery__
 *
 * To run a query within a React component, call `useMyGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupQuery(baseOptions?: Apollo.QueryHookOptions<MyGroupQuery, MyGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupQuery, MyGroupQueryVariables>(MyGroupDocument, options);
      }
export function useMyGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupQuery, MyGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupQuery, MyGroupQueryVariables>(MyGroupDocument, options);
        }
export function useMyGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyGroupQuery, MyGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGroupQuery, MyGroupQueryVariables>(MyGroupDocument, options);
        }
export type MyGroupQueryHookResult = ReturnType<typeof useMyGroupQuery>;
export type MyGroupLazyQueryHookResult = ReturnType<typeof useMyGroupLazyQuery>;
export type MyGroupSuspenseQueryHookResult = ReturnType<typeof useMyGroupSuspenseQuery>;
export type MyGroupQueryResult = Apollo.QueryResult<MyGroupQuery, MyGroupQueryVariables>;
export const MyGroupMembersDocument = gql`
    query MyGroupMembers {
  me {
    id
    group {
      id
      members {
        id
      }
    }
  }
}
    `;

/**
 * __useMyGroupMembersQuery__
 *
 * To run a query within a React component, call `useMyGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupMembersQuery(baseOptions?: Apollo.QueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
      }
export function useMyGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
        }
export function useMyGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
        }
export type MyGroupMembersQueryHookResult = ReturnType<typeof useMyGroupMembersQuery>;
export type MyGroupMembersLazyQueryHookResult = ReturnType<typeof useMyGroupMembersLazyQuery>;
export type MyGroupMembersSuspenseQueryHookResult = ReturnType<typeof useMyGroupMembersSuspenseQuery>;
export type MyGroupMembersQueryResult = Apollo.QueryResult<MyGroupMembersQuery, MyGroupMembersQueryVariables>;
export const GroupsDocument = gql`
    query Groups {
  groups {
    ...GroupFieldsSettings
  }
}
    ${GroupFieldsSettingsFragmentDoc}`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<typeof useGroupsSuspenseQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const GroupDocument = gql`
    query Group($groupId: ID!) {
  group(groupId: $groupId) {
    ...GroupFieldsSettings
  }
}
    ${GroupFieldsSettingsFragmentDoc}`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> & ({ variables: GroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export function useGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupSuspenseQueryHookResult = ReturnType<typeof useGroupSuspenseQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const HeatPumpOwnerDocument = gql`
    query HeatPumpOwner($heatPumpId: String!) {
  heatPumpOwner(heatPumpId: $heatPumpId) {
    name
  }
}
    `;

/**
 * __useHeatPumpOwnerQuery__
 *
 * To run a query within a React component, call `useHeatPumpOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeatPumpOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeatPumpOwnerQuery({
 *   variables: {
 *      heatPumpId: // value for 'heatPumpId'
 *   },
 * });
 */
export function useHeatPumpOwnerQuery(baseOptions: Apollo.QueryHookOptions<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables> & ({ variables: HeatPumpOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables>(HeatPumpOwnerDocument, options);
      }
export function useHeatPumpOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables>(HeatPumpOwnerDocument, options);
        }
export function useHeatPumpOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables>(HeatPumpOwnerDocument, options);
        }
export type HeatPumpOwnerQueryHookResult = ReturnType<typeof useHeatPumpOwnerQuery>;
export type HeatPumpOwnerLazyQueryHookResult = ReturnType<typeof useHeatPumpOwnerLazyQuery>;
export type HeatPumpOwnerSuspenseQueryHookResult = ReturnType<typeof useHeatPumpOwnerSuspenseQuery>;
export type HeatPumpOwnerQueryResult = Apollo.QueryResult<HeatPumpOwnerQuery, HeatPumpOwnerQueryVariables>;
export const RemoveUserFromGroupDocument = gql`
    mutation RemoveUserFromGroup($groupId: ID!, $userId: ID!) {
  removeUserFromGroup(groupId: $groupId, userId: $userId) {
    id
    members {
      id
    }
  }
}
    `;
export type RemoveUserFromGroupMutationFn = Apollo.MutationFunction<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;

/**
 * __useRemoveUserFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromGroupMutation, { data, loading, error }] = useRemoveUserFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(RemoveUserFromGroupDocument, options);
      }
export type RemoveUserFromGroupMutationHookResult = ReturnType<typeof useRemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationResult = Apollo.MutationResult<RemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;
export const LeaveGroupDocument = gql`
    mutation LeaveGroup($groupId: ID!, $userId: ID!) {
  removeUserFromGroup(groupId: $groupId, userId: $userId) {
    id
  }
}
    `;
export type LeaveGroupMutationFn = Apollo.MutationFunction<LeaveGroupMutation, LeaveGroupMutationVariables>;

/**
 * __useLeaveGroupMutation__
 *
 * To run a mutation, you first call `useLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveGroupMutation, { data, loading, error }] = useLeaveGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveGroupMutation, LeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveGroupMutation, LeaveGroupMutationVariables>(LeaveGroupDocument, options);
      }
export type LeaveGroupMutationHookResult = ReturnType<typeof useLeaveGroupMutation>;
export type LeaveGroupMutationResult = Apollo.MutationResult<LeaveGroupMutation>;
export type LeaveGroupMutationOptions = Apollo.BaseMutationOptions<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const ClaimHeatPumpDocument = gql`
    mutation ClaimHeatPump($groupId: ID!, $heatPumpId: String!) {
  claimHeatPump(groupId: $groupId, heatPumpId: $heatPumpId) {
    id
    interfaces {
      id
      accessLevel
    }
  }
}
    `;
export type ClaimHeatPumpMutationFn = Apollo.MutationFunction<ClaimHeatPumpMutation, ClaimHeatPumpMutationVariables>;

/**
 * __useClaimHeatPumpMutation__
 *
 * To run a mutation, you first call `useClaimHeatPumpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimHeatPumpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimHeatPumpMutation, { data, loading, error }] = useClaimHeatPumpMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      heatPumpId: // value for 'heatPumpId'
 *   },
 * });
 */
export function useClaimHeatPumpMutation(baseOptions?: Apollo.MutationHookOptions<ClaimHeatPumpMutation, ClaimHeatPumpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimHeatPumpMutation, ClaimHeatPumpMutationVariables>(ClaimHeatPumpDocument, options);
      }
export type ClaimHeatPumpMutationHookResult = ReturnType<typeof useClaimHeatPumpMutation>;
export type ClaimHeatPumpMutationResult = Apollo.MutationResult<ClaimHeatPumpMutation>;
export type ClaimHeatPumpMutationOptions = Apollo.BaseMutationOptions<ClaimHeatPumpMutation, ClaimHeatPumpMutationVariables>;
export const RemoveHeatPumpFromGroupDocument = gql`
    mutation RemoveHeatPumpFromGroup($groupId: ID!, $heatPumpId: String!) {
  removeHeatPumpFromGroup(groupId: $groupId, heatPumpId: $heatPumpId) {
    id
    interfaces {
      id
    }
  }
}
    `;
export type RemoveHeatPumpFromGroupMutationFn = Apollo.MutationFunction<RemoveHeatPumpFromGroupMutation, RemoveHeatPumpFromGroupMutationVariables>;

/**
 * __useRemoveHeatPumpFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveHeatPumpFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHeatPumpFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHeatPumpFromGroupMutation, { data, loading, error }] = useRemoveHeatPumpFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      heatPumpId: // value for 'heatPumpId'
 *   },
 * });
 */
export function useRemoveHeatPumpFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHeatPumpFromGroupMutation, RemoveHeatPumpFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveHeatPumpFromGroupMutation, RemoveHeatPumpFromGroupMutationVariables>(RemoveHeatPumpFromGroupDocument, options);
      }
export type RemoveHeatPumpFromGroupMutationHookResult = ReturnType<typeof useRemoveHeatPumpFromGroupMutation>;
export type RemoveHeatPumpFromGroupMutationResult = Apollo.MutationResult<RemoveHeatPumpFromGroupMutation>;
export type RemoveHeatPumpFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveHeatPumpFromGroupMutation, RemoveHeatPumpFromGroupMutationVariables>;
export const RemoveGroupFromHeatPumpDocument = gql`
    mutation RemoveGroupFromHeatPump($groupId: ID!, $heatPumpId: String!) {
  removeHeatPumpFromGroup(groupId: $groupId, heatPumpId: $heatPumpId) {
    id
  }
}
    `;
export type RemoveGroupFromHeatPumpMutationFn = Apollo.MutationFunction<RemoveGroupFromHeatPumpMutation, RemoveGroupFromHeatPumpMutationVariables>;

/**
 * __useRemoveGroupFromHeatPumpMutation__
 *
 * To run a mutation, you first call `useRemoveGroupFromHeatPumpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupFromHeatPumpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupFromHeatPumpMutation, { data, loading, error }] = useRemoveGroupFromHeatPumpMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      heatPumpId: // value for 'heatPumpId'
 *   },
 * });
 */
export function useRemoveGroupFromHeatPumpMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupFromHeatPumpMutation, RemoveGroupFromHeatPumpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupFromHeatPumpMutation, RemoveGroupFromHeatPumpMutationVariables>(RemoveGroupFromHeatPumpDocument, options);
      }
export type RemoveGroupFromHeatPumpMutationHookResult = ReturnType<typeof useRemoveGroupFromHeatPumpMutation>;
export type RemoveGroupFromHeatPumpMutationResult = Apollo.MutationResult<RemoveGroupFromHeatPumpMutation>;
export type RemoveGroupFromHeatPumpMutationOptions = Apollo.BaseMutationOptions<RemoveGroupFromHeatPumpMutation, RemoveGroupFromHeatPumpMutationVariables>;
export const UpdateGroupHeatPumpNameDocument = gql`
    mutation UpdateGroupHeatPumpName($heatPumpId: String!, $name: String) {
  updateGroupHeatPumpName(heatPumpId: $heatPumpId, name: $name) {
    id
    interfaces {
      id
      name
    }
  }
}
    `;
export type UpdateGroupHeatPumpNameMutationFn = Apollo.MutationFunction<UpdateGroupHeatPumpNameMutation, UpdateGroupHeatPumpNameMutationVariables>;

/**
 * __useUpdateGroupHeatPumpNameMutation__
 *
 * To run a mutation, you first call `useUpdateGroupHeatPumpNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupHeatPumpNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupHeatPumpNameMutation, { data, loading, error }] = useUpdateGroupHeatPumpNameMutation({
 *   variables: {
 *      heatPumpId: // value for 'heatPumpId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateGroupHeatPumpNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupHeatPumpNameMutation, UpdateGroupHeatPumpNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupHeatPumpNameMutation, UpdateGroupHeatPumpNameMutationVariables>(UpdateGroupHeatPumpNameDocument, options);
      }
export type UpdateGroupHeatPumpNameMutationHookResult = ReturnType<typeof useUpdateGroupHeatPumpNameMutation>;
export type UpdateGroupHeatPumpNameMutationResult = Apollo.MutationResult<UpdateGroupHeatPumpNameMutation>;
export type UpdateGroupHeatPumpNameMutationOptions = Apollo.BaseMutationOptions<UpdateGroupHeatPumpNameMutation, UpdateGroupHeatPumpNameMutationVariables>;
export const UpdateGroupNameDocument = gql`
    mutation UpdateGroupName($groupId: ID!, $name: String!) {
  updateGroupName(groupId: $groupId, name: $name) {
    id
    name
    isOrganization
    isDeleted
    members {
      id
      name
      isDeleted
    }
  }
}
    `;
export type UpdateGroupNameMutationFn = Apollo.MutationFunction<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>;

/**
 * __useUpdateGroupNameMutation__
 *
 * To run a mutation, you first call `useUpdateGroupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupNameMutation, { data, loading, error }] = useUpdateGroupNameMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateGroupNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>(UpdateGroupNameDocument, options);
      }
export type UpdateGroupNameMutationHookResult = ReturnType<typeof useUpdateGroupNameMutation>;
export type UpdateGroupNameMutationResult = Apollo.MutationResult<UpdateGroupNameMutation>;
export type UpdateGroupNameMutationOptions = Apollo.BaseMutationOptions<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>;
export const InviteNewUserToGroupDocument = gql`
    mutation InviteNewUserToGroup($email: Email!, $groupId: ID!) {
  inviteNewUserToGroup(email: $email, groupId: $groupId)
}
    `;
export type InviteNewUserToGroupMutationFn = Apollo.MutationFunction<InviteNewUserToGroupMutation, InviteNewUserToGroupMutationVariables>;

/**
 * __useInviteNewUserToGroupMutation__
 *
 * To run a mutation, you first call `useInviteNewUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteNewUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteNewUserToGroupMutation, { data, loading, error }] = useInviteNewUserToGroupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useInviteNewUserToGroupMutation(baseOptions?: Apollo.MutationHookOptions<InviteNewUserToGroupMutation, InviteNewUserToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteNewUserToGroupMutation, InviteNewUserToGroupMutationVariables>(InviteNewUserToGroupDocument, options);
      }
export type InviteNewUserToGroupMutationHookResult = ReturnType<typeof useInviteNewUserToGroupMutation>;
export type InviteNewUserToGroupMutationResult = Apollo.MutationResult<InviteNewUserToGroupMutation>;
export type InviteNewUserToGroupMutationOptions = Apollo.BaseMutationOptions<InviteNewUserToGroupMutation, InviteNewUserToGroupMutationVariables>;
export const UpdateGroupAdminDocument = gql`
    mutation UpdateGroupAdmin($admin: Boolean!, $groupId: ID!, $userId: ID!) {
  updateGroupAdmin(admin: $admin, groupId: $groupId, userId: $userId) {
    id
    members {
      id
      isGroupAdmin
    }
  }
}
    `;
export type UpdateGroupAdminMutationFn = Apollo.MutationFunction<UpdateGroupAdminMutation, UpdateGroupAdminMutationVariables>;

/**
 * __useUpdateGroupAdminMutation__
 *
 * To run a mutation, you first call `useUpdateGroupAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupAdminMutation, { data, loading, error }] = useUpdateGroupAdminMutation({
 *   variables: {
 *      admin: // value for 'admin'
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateGroupAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupAdminMutation, UpdateGroupAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupAdminMutation, UpdateGroupAdminMutationVariables>(UpdateGroupAdminDocument, options);
      }
export type UpdateGroupAdminMutationHookResult = ReturnType<typeof useUpdateGroupAdminMutation>;
export type UpdateGroupAdminMutationResult = Apollo.MutationResult<UpdateGroupAdminMutation>;
export type UpdateGroupAdminMutationOptions = Apollo.BaseMutationOptions<UpdateGroupAdminMutation, UpdateGroupAdminMutationVariables>;
export const TransferHeatPumpOwnershipDocument = gql`
    mutation TransferHeatPumpOwnership($groupId: ID!, $heatPumpId: String!) {
  updateHeatPumpAccessLevel(
    accessLevel: Owner
    groupId: $groupId
    heatPumpId: $heatPumpId
  ) {
    id
  }
}
    `;
export type TransferHeatPumpOwnershipMutationFn = Apollo.MutationFunction<TransferHeatPumpOwnershipMutation, TransferHeatPumpOwnershipMutationVariables>;

/**
 * __useTransferHeatPumpOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferHeatPumpOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferHeatPumpOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferHeatPumpOwnershipMutation, { data, loading, error }] = useTransferHeatPumpOwnershipMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      heatPumpId: // value for 'heatPumpId'
 *   },
 * });
 */
export function useTransferHeatPumpOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferHeatPumpOwnershipMutation, TransferHeatPumpOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferHeatPumpOwnershipMutation, TransferHeatPumpOwnershipMutationVariables>(TransferHeatPumpOwnershipDocument, options);
      }
export type TransferHeatPumpOwnershipMutationHookResult = ReturnType<typeof useTransferHeatPumpOwnershipMutation>;
export type TransferHeatPumpOwnershipMutationResult = Apollo.MutationResult<TransferHeatPumpOwnershipMutation>;
export type TransferHeatPumpOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferHeatPumpOwnershipMutation, TransferHeatPumpOwnershipMutationVariables>;
export const InviteUserToHeatPumpDocument = gql`
    mutation InviteUserToHeatPump($email: Email!, $heatPumpId: String!) {
  inviteUserToHeatPump(email: $email, heatPumpId: $heatPumpId)
}
    `;
export type InviteUserToHeatPumpMutationFn = Apollo.MutationFunction<InviteUserToHeatPumpMutation, InviteUserToHeatPumpMutationVariables>;

/**
 * __useInviteUserToHeatPumpMutation__
 *
 * To run a mutation, you first call `useInviteUserToHeatPumpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserToHeatPumpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserToHeatPumpMutation, { data, loading, error }] = useInviteUserToHeatPumpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      heatPumpId: // value for 'heatPumpId'
 *   },
 * });
 */
export function useInviteUserToHeatPumpMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserToHeatPumpMutation, InviteUserToHeatPumpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserToHeatPumpMutation, InviteUserToHeatPumpMutationVariables>(InviteUserToHeatPumpDocument, options);
      }
export type InviteUserToHeatPumpMutationHookResult = ReturnType<typeof useInviteUserToHeatPumpMutation>;
export type InviteUserToHeatPumpMutationResult = Apollo.MutationResult<InviteUserToHeatPumpMutation>;
export type InviteUserToHeatPumpMutationOptions = Apollo.BaseMutationOptions<InviteUserToHeatPumpMutation, InviteUserToHeatPumpMutationVariables>;
export const ReadInterfaceEventLogDocument = gql`
    query ReadInterfaceEventLog($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    eventLog {
      ...EventFields
    }
  }
}
    ${EventFieldsFragmentDoc}`;

/**
 * __useReadInterfaceEventLogQuery__
 *
 * To run a query within a React component, call `useReadInterfaceEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInterfaceEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInterfaceEventLogQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadInterfaceEventLogQuery(baseOptions: Apollo.QueryHookOptions<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables> & ({ variables: ReadInterfaceEventLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables>(ReadInterfaceEventLogDocument, options);
      }
export function useReadInterfaceEventLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables>(ReadInterfaceEventLogDocument, options);
        }
export function useReadInterfaceEventLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables>(ReadInterfaceEventLogDocument, options);
        }
export type ReadInterfaceEventLogQueryHookResult = ReturnType<typeof useReadInterfaceEventLogQuery>;
export type ReadInterfaceEventLogLazyQueryHookResult = ReturnType<typeof useReadInterfaceEventLogLazyQuery>;
export type ReadInterfaceEventLogSuspenseQueryHookResult = ReturnType<typeof useReadInterfaceEventLogSuspenseQuery>;
export type ReadInterfaceEventLogQueryResult = Apollo.QueryResult<ReadInterfaceEventLogQuery, ReadInterfaceEventLogQueryVariables>;
export const ReadHeatPumpSettingsDocument = gql`
    query ReadHeatPumpSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    firmwareVersion {
      version
      timestamp
    }
    controller {
      ...ResidentControllerSettingsFields
    }
    name
    openThermBoilerConnected
    pvtHeatPump {
      ...PvtHeatPumpSettingsFields
    }
  }
}
    ${ResidentControllerSettingsFieldsFragmentDoc}
${PvtHeatPumpSettingsFieldsFragmentDoc}`;

/**
 * __useReadHeatPumpSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables> & ({ variables: ReadHeatPumpSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables>(ReadHeatPumpSettingsDocument, options);
      }
export function useReadHeatPumpSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables>(ReadHeatPumpSettingsDocument, options);
        }
export function useReadHeatPumpSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables>(ReadHeatPumpSettingsDocument, options);
        }
export type ReadHeatPumpSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpSettingsQuery>;
export type ReadHeatPumpSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpSettingsLazyQuery>;
export type ReadHeatPumpSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpSettingsSuspenseQuery>;
export type ReadHeatPumpSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpSettingsQuery, ReadHeatPumpSettingsQueryVariables>;
export const ReadHeatPumpSettingsWizardDocument = gql`
    query ReadHeatPumpSettingsWizard($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    name
    openThermThermostatConnected
    openThermBoilerConnected
    pvtHeatPump {
      ...PvtHeatPumpSettingsFieldsWizard
    }
    firmwareVersion {
      version
      timestamp
    }
    controller {
      manualCoolingMode
      chSetpMaxTemp
      backupHeater
    }
    openTherm {
      chSetpTemp
      chFeedTemp
      roomTemp
      roomSetpTemp
    }
    slave {
      id
    }
  }
}
    ${PvtHeatPumpSettingsFieldsWizardFragmentDoc}`;

/**
 * __useReadHeatPumpSettingsWizardQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpSettingsWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpSettingsWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpSettingsWizardQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpSettingsWizardQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables> & ({ variables: ReadHeatPumpSettingsWizardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables>(ReadHeatPumpSettingsWizardDocument, options);
      }
export function useReadHeatPumpSettingsWizardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables>(ReadHeatPumpSettingsWizardDocument, options);
        }
export function useReadHeatPumpSettingsWizardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables>(ReadHeatPumpSettingsWizardDocument, options);
        }
export type ReadHeatPumpSettingsWizardQueryHookResult = ReturnType<typeof useReadHeatPumpSettingsWizardQuery>;
export type ReadHeatPumpSettingsWizardLazyQueryHookResult = ReturnType<typeof useReadHeatPumpSettingsWizardLazyQuery>;
export type ReadHeatPumpSettingsWizardSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpSettingsWizardSuspenseQuery>;
export type ReadHeatPumpSettingsWizardQueryResult = Apollo.QueryResult<ReadHeatPumpSettingsWizardQuery, ReadHeatPumpSettingsWizardQueryVariables>;
export const ReadExpertControllerSettingsDocument = gql`
    query ReadExpertControllerSettings($interfaceId: String!, $isAdmin: Boolean!) {
  interface(interfaceId: $interfaceId) {
    id
    controller {
      delayHPOnMin
      hysBHOn
      sourceBivTemp
      minCoolingPerc
      delayHPOffMin @include(if: $isAdmin)
      delayHPCheckMin @include(if: $isAdmin)
      hysHPOn @include(if: $isAdmin)
      hysHPOff @include(if: $isAdmin)
      hysBHOff @include(if: $isAdmin)
      delayHPPostRunMin @include(if: $isAdmin)
    }
  }
}
    `;

/**
 * __useReadExpertControllerSettingsQuery__
 *
 * To run a query within a React component, call `useReadExpertControllerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadExpertControllerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadExpertControllerSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useReadExpertControllerSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables> & ({ variables: ReadExpertControllerSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables>(ReadExpertControllerSettingsDocument, options);
      }
export function useReadExpertControllerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables>(ReadExpertControllerSettingsDocument, options);
        }
export function useReadExpertControllerSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables>(ReadExpertControllerSettingsDocument, options);
        }
export type ReadExpertControllerSettingsQueryHookResult = ReturnType<typeof useReadExpertControllerSettingsQuery>;
export type ReadExpertControllerSettingsLazyQueryHookResult = ReturnType<typeof useReadExpertControllerSettingsLazyQuery>;
export type ReadExpertControllerSettingsSuspenseQueryHookResult = ReturnType<typeof useReadExpertControllerSettingsSuspenseQuery>;
export type ReadExpertControllerSettingsQueryResult = Apollo.QueryResult<ReadExpertControllerSettingsQuery, ReadExpertControllerSettingsQueryVariables>;
export const ReadHeatPumpGroupSettingsDocument = gql`
    query ReadHeatPumpGroupSettings($interfaceId: String!, $isInternal: Boolean!) {
  me {
    id
    group {
      id
    }
    isGroupAdmin
  }
  interface(interfaceId: $interfaceId) {
    id
    interfaceOwner {
      id
    }
    accessLevel
    name
    groups {
      ...HeatPumpGroupFields
    }
  }
}
    ${HeatPumpGroupFieldsFragmentDoc}`;

/**
 * __useReadHeatPumpGroupSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpGroupSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpGroupSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpGroupSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *      isInternal: // value for 'isInternal'
 *   },
 * });
 */
export function useReadHeatPumpGroupSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables> & ({ variables: ReadHeatPumpGroupSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables>(ReadHeatPumpGroupSettingsDocument, options);
      }
export function useReadHeatPumpGroupSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables>(ReadHeatPumpGroupSettingsDocument, options);
        }
export function useReadHeatPumpGroupSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables>(ReadHeatPumpGroupSettingsDocument, options);
        }
export type ReadHeatPumpGroupSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpGroupSettingsQuery>;
export type ReadHeatPumpGroupSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpGroupSettingsLazyQuery>;
export type ReadHeatPumpGroupSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpGroupSettingsSuspenseQuery>;
export type ReadHeatPumpGroupSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpGroupSettingsQuery, ReadHeatPumpGroupSettingsQueryVariables>;
export const ReadHeatPumpCountdownFieldsDocument = gql`
    query ReadHeatPumpCountdownFields($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...CompressorWaitTimeFields
    }
  }
}
    ${CompressorWaitTimeFieldsFragmentDoc}`;

/**
 * __useReadHeatPumpCountdownFieldsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpCountdownFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpCountdownFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpCountdownFieldsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpCountdownFieldsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables> & ({ variables: ReadHeatPumpCountdownFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables>(ReadHeatPumpCountdownFieldsDocument, options);
      }
export function useReadHeatPumpCountdownFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables>(ReadHeatPumpCountdownFieldsDocument, options);
        }
export function useReadHeatPumpCountdownFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables>(ReadHeatPumpCountdownFieldsDocument, options);
        }
export type ReadHeatPumpCountdownFieldsQueryHookResult = ReturnType<typeof useReadHeatPumpCountdownFieldsQuery>;
export type ReadHeatPumpCountdownFieldsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpCountdownFieldsLazyQuery>;
export type ReadHeatPumpCountdownFieldsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpCountdownFieldsSuspenseQuery>;
export type ReadHeatPumpCountdownFieldsQueryResult = Apollo.QueryResult<ReadHeatPumpCountdownFieldsQuery, ReadHeatPumpCountdownFieldsQueryVariables>;
export const ReadHeatPumpStatusDocument = gql`
    query ReadHeatPumpStatus($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    ...InterfaceStatusFields
  }
}
    ${InterfaceStatusFieldsFragmentDoc}`;

/**
 * __useReadHeatPumpStatusQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpStatusQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables> & ({ variables: ReadHeatPumpStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables>(ReadHeatPumpStatusDocument, options);
      }
export function useReadHeatPumpStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables>(ReadHeatPumpStatusDocument, options);
        }
export function useReadHeatPumpStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables>(ReadHeatPumpStatusDocument, options);
        }
export type ReadHeatPumpStatusQueryHookResult = ReturnType<typeof useReadHeatPumpStatusQuery>;
export type ReadHeatPumpStatusLazyQueryHookResult = ReturnType<typeof useReadHeatPumpStatusLazyQuery>;
export type ReadHeatPumpStatusSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpStatusSuspenseQuery>;
export type ReadHeatPumpStatusQueryResult = Apollo.QueryResult<ReadHeatPumpStatusQuery, ReadHeatPumpStatusQueryVariables>;
export const ReadHeatPumpDmFieldsDocument = gql`
    query ReadHeatPumpDmFields($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      id
      firmwareVersion
      roomControlType
      dmSh
      dmSc
      ...PvtHeatPumpDMSetpoints
    }
  }
}
    ${PvtHeatPumpDmSetpointsFragmentDoc}`;

/**
 * __useReadHeatPumpDmFieldsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpDmFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpDmFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpDmFieldsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpDmFieldsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables> & ({ variables: ReadHeatPumpDmFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables>(ReadHeatPumpDmFieldsDocument, options);
      }
export function useReadHeatPumpDmFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables>(ReadHeatPumpDmFieldsDocument, options);
        }
export function useReadHeatPumpDmFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables>(ReadHeatPumpDmFieldsDocument, options);
        }
export type ReadHeatPumpDmFieldsQueryHookResult = ReturnType<typeof useReadHeatPumpDmFieldsQuery>;
export type ReadHeatPumpDmFieldsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpDmFieldsLazyQuery>;
export type ReadHeatPumpDmFieldsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpDmFieldsSuspenseQuery>;
export type ReadHeatPumpDmFieldsQueryResult = Apollo.QueryResult<ReadHeatPumpDmFieldsQuery, ReadHeatPumpDmFieldsQueryVariables>;
export const ReadHeatPumpErrorsDocument = gql`
    query ReadHeatPumpErrors($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      id
      errors
    }
  }
}
    `;

/**
 * __useReadHeatPumpErrorsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpErrorsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpErrorsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables> & ({ variables: ReadHeatPumpErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables>(ReadHeatPumpErrorsDocument, options);
      }
export function useReadHeatPumpErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables>(ReadHeatPumpErrorsDocument, options);
        }
export function useReadHeatPumpErrorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables>(ReadHeatPumpErrorsDocument, options);
        }
export type ReadHeatPumpErrorsQueryHookResult = ReturnType<typeof useReadHeatPumpErrorsQuery>;
export type ReadHeatPumpErrorsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpErrorsLazyQuery>;
export type ReadHeatPumpErrorsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpErrorsSuspenseQuery>;
export type ReadHeatPumpErrorsQueryResult = Apollo.QueryResult<ReadHeatPumpErrorsQuery, ReadHeatPumpErrorsQueryVariables>;
export const ReadHeatPumpDhwSettingsDocument = gql`
    query ReadHeatPumpDHWSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminSettingDHW
    }
  }
}
    ${PvtHeatPumpAdminSettingDhwFragmentDoc}`;

/**
 * __useReadHeatPumpDhwSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpDhwSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpDhwSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpDhwSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpDhwSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables> & ({ variables: ReadHeatPumpDhwSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables>(ReadHeatPumpDhwSettingsDocument, options);
      }
export function useReadHeatPumpDhwSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables>(ReadHeatPumpDhwSettingsDocument, options);
        }
export function useReadHeatPumpDhwSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables>(ReadHeatPumpDhwSettingsDocument, options);
        }
export type ReadHeatPumpDhwSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpDhwSettingsQuery>;
export type ReadHeatPumpDhwSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpDhwSettingsLazyQuery>;
export type ReadHeatPumpDhwSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpDhwSettingsSuspenseQuery>;
export type ReadHeatPumpDhwSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpDhwSettingsQuery, ReadHeatPumpDhwSettingsQueryVariables>;
export const ReadHeatPumpGeneralSettingsDocument = gql`
    query ReadHeatPumpGeneralSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminSettingsGeneral
    }
  }
}
    ${PvtHeatPumpAdminSettingsGeneralFragmentDoc}`;

/**
 * __useReadHeatPumpGeneralSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpGeneralSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpGeneralSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpGeneralSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpGeneralSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables> & ({ variables: ReadHeatPumpGeneralSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables>(ReadHeatPumpGeneralSettingsDocument, options);
      }
export function useReadHeatPumpGeneralSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables>(ReadHeatPumpGeneralSettingsDocument, options);
        }
export function useReadHeatPumpGeneralSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables>(ReadHeatPumpGeneralSettingsDocument, options);
        }
export type ReadHeatPumpGeneralSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpGeneralSettingsQuery>;
export type ReadHeatPumpGeneralSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpGeneralSettingsLazyQuery>;
export type ReadHeatPumpGeneralSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpGeneralSettingsSuspenseQuery>;
export type ReadHeatPumpGeneralSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpGeneralSettingsQuery, ReadHeatPumpGeneralSettingsQueryVariables>;
export const ReadHeatPumpHeatingCoolingSettingsDocument = gql`
    query ReadHeatPumpHeatingCoolingSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminSettingsHeatingCooling
    }
  }
}
    ${PvtHeatPumpAdminSettingsHeatingCoolingFragmentDoc}`;

/**
 * __useReadHeatPumpHeatingCoolingSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpHeatingCoolingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpHeatingCoolingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpHeatingCoolingSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpHeatingCoolingSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables> & ({ variables: ReadHeatPumpHeatingCoolingSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables>(ReadHeatPumpHeatingCoolingSettingsDocument, options);
      }
export function useReadHeatPumpHeatingCoolingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables>(ReadHeatPumpHeatingCoolingSettingsDocument, options);
        }
export function useReadHeatPumpHeatingCoolingSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables>(ReadHeatPumpHeatingCoolingSettingsDocument, options);
        }
export type ReadHeatPumpHeatingCoolingSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpHeatingCoolingSettingsQuery>;
export type ReadHeatPumpHeatingCoolingSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpHeatingCoolingSettingsLazyQuery>;
export type ReadHeatPumpHeatingCoolingSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpHeatingCoolingSettingsSuspenseQuery>;
export type ReadHeatPumpHeatingCoolingSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpHeatingCoolingSettingsQuery, ReadHeatPumpHeatingCoolingSettingsQueryVariables>;
export const ReadHeatPumpPumpsSettingsDocument = gql`
    query ReadHeatPumpPumpsSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminSettingsPumps
    }
  }
}
    ${PvtHeatPumpAdminSettingsPumpsFragmentDoc}`;

/**
 * __useReadHeatPumpPumpsSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpPumpsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpPumpsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpPumpsSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpPumpsSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables> & ({ variables: ReadHeatPumpPumpsSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables>(ReadHeatPumpPumpsSettingsDocument, options);
      }
export function useReadHeatPumpPumpsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables>(ReadHeatPumpPumpsSettingsDocument, options);
        }
export function useReadHeatPumpPumpsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables>(ReadHeatPumpPumpsSettingsDocument, options);
        }
export type ReadHeatPumpPumpsSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpPumpsSettingsQuery>;
export type ReadHeatPumpPumpsSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpPumpsSettingsLazyQuery>;
export type ReadHeatPumpPumpsSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpPumpsSettingsSuspenseQuery>;
export type ReadHeatPumpPumpsSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpPumpsSettingsQuery, ReadHeatPumpPumpsSettingsQueryVariables>;
export const ReadHeatPumpSecuritySettingsDocument = gql`
    query ReadHeatPumpSecuritySettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminSecurity
    }
  }
}
    ${PvtHeatPumpAdminSecurityFragmentDoc}`;

/**
 * __useReadHeatPumpSecuritySettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpSecuritySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpSecuritySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpSecuritySettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpSecuritySettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables> & ({ variables: ReadHeatPumpSecuritySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables>(ReadHeatPumpSecuritySettingsDocument, options);
      }
export function useReadHeatPumpSecuritySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables>(ReadHeatPumpSecuritySettingsDocument, options);
        }
export function useReadHeatPumpSecuritySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables>(ReadHeatPumpSecuritySettingsDocument, options);
        }
export type ReadHeatPumpSecuritySettingsQueryHookResult = ReturnType<typeof useReadHeatPumpSecuritySettingsQuery>;
export type ReadHeatPumpSecuritySettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpSecuritySettingsLazyQuery>;
export type ReadHeatPumpSecuritySettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpSecuritySettingsSuspenseQuery>;
export type ReadHeatPumpSecuritySettingsQueryResult = Apollo.QueryResult<ReadHeatPumpSecuritySettingsQuery, ReadHeatPumpSecuritySettingsQueryVariables>;
export const ReadHeatPumpOverrideSettingsDocument = gql`
    query ReadHeatPumpOverrideSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminOverride
    }
  }
}
    ${PvtHeatPumpAdminOverrideFragmentDoc}`;

/**
 * __useReadHeatPumpOverrideSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpOverrideSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpOverrideSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpOverrideSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpOverrideSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables> & ({ variables: ReadHeatPumpOverrideSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables>(ReadHeatPumpOverrideSettingsDocument, options);
      }
export function useReadHeatPumpOverrideSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables>(ReadHeatPumpOverrideSettingsDocument, options);
        }
export function useReadHeatPumpOverrideSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables>(ReadHeatPumpOverrideSettingsDocument, options);
        }
export type ReadHeatPumpOverrideSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpOverrideSettingsQuery>;
export type ReadHeatPumpOverrideSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpOverrideSettingsLazyQuery>;
export type ReadHeatPumpOverrideSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpOverrideSettingsSuspenseQuery>;
export type ReadHeatPumpOverrideSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpOverrideSettingsQuery, ReadHeatPumpOverrideSettingsQueryVariables>;
export const ReadHeatPumpDateTimeSettingsDocument = gql`
    query ReadHeatPumpDateTimeSettings($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      ...PvtHeatPumpAdminDateTime
    }
  }
}
    ${PvtHeatPumpAdminDateTimeFragmentDoc}`;

/**
 * __useReadHeatPumpDateTimeSettingsQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpDateTimeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpDateTimeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpDateTimeSettingsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpDateTimeSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables> & ({ variables: ReadHeatPumpDateTimeSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables>(ReadHeatPumpDateTimeSettingsDocument, options);
      }
export function useReadHeatPumpDateTimeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables>(ReadHeatPumpDateTimeSettingsDocument, options);
        }
export function useReadHeatPumpDateTimeSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables>(ReadHeatPumpDateTimeSettingsDocument, options);
        }
export type ReadHeatPumpDateTimeSettingsQueryHookResult = ReturnType<typeof useReadHeatPumpDateTimeSettingsQuery>;
export type ReadHeatPumpDateTimeSettingsLazyQueryHookResult = ReturnType<typeof useReadHeatPumpDateTimeSettingsLazyQuery>;
export type ReadHeatPumpDateTimeSettingsSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpDateTimeSettingsSuspenseQuery>;
export type ReadHeatPumpDateTimeSettingsQueryResult = Apollo.QueryResult<ReadHeatPumpDateTimeSettingsQuery, ReadHeatPumpDateTimeSettingsQueryVariables>;
export const ReadHeatPumpAdminStatusDocument = gql`
    query ReadHeatPumpAdminStatus($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    ...PvtHeatPumpAdminStatus
  }
}
    ${PvtHeatPumpAdminStatusFragmentDoc}`;

/**
 * __useReadHeatPumpAdminStatusQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpAdminStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpAdminStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpAdminStatusQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpAdminStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables> & ({ variables: ReadHeatPumpAdminStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables>(ReadHeatPumpAdminStatusDocument, options);
      }
export function useReadHeatPumpAdminStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables>(ReadHeatPumpAdminStatusDocument, options);
        }
export function useReadHeatPumpAdminStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables>(ReadHeatPumpAdminStatusDocument, options);
        }
export type ReadHeatPumpAdminStatusQueryHookResult = ReturnType<typeof useReadHeatPumpAdminStatusQuery>;
export type ReadHeatPumpAdminStatusLazyQueryHookResult = ReturnType<typeof useReadHeatPumpAdminStatusLazyQuery>;
export type ReadHeatPumpAdminStatusSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpAdminStatusSuspenseQuery>;
export type ReadHeatPumpAdminStatusQueryResult = Apollo.QueryResult<ReadHeatPumpAdminStatusQuery, ReadHeatPumpAdminStatusQueryVariables>;
export const ReadHeatPumpStatusAppBarDocument = gql`
    query ReadHeatPumpStatusAppBar($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      id
      dhwState
      spaceHeatingCoolingState
      errors
    }
  }
}
    `;

/**
 * __useReadHeatPumpStatusAppBarQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpStatusAppBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpStatusAppBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpStatusAppBarQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpStatusAppBarQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables> & ({ variables: ReadHeatPumpStatusAppBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables>(ReadHeatPumpStatusAppBarDocument, options);
      }
export function useReadHeatPumpStatusAppBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables>(ReadHeatPumpStatusAppBarDocument, options);
        }
export function useReadHeatPumpStatusAppBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables>(ReadHeatPumpStatusAppBarDocument, options);
        }
export type ReadHeatPumpStatusAppBarQueryHookResult = ReturnType<typeof useReadHeatPumpStatusAppBarQuery>;
export type ReadHeatPumpStatusAppBarLazyQueryHookResult = ReturnType<typeof useReadHeatPumpStatusAppBarLazyQuery>;
export type ReadHeatPumpStatusAppBarSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpStatusAppBarSuspenseQuery>;
export type ReadHeatPumpStatusAppBarQueryResult = Apollo.QueryResult<ReadHeatPumpStatusAppBarQuery, ReadHeatPumpStatusAppBarQueryVariables>;
export const ReadHeatPumpDhwSchedulerDocument = gql`
    query ReadHeatPumpDhwScheduler($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    pvtHeatPump {
      firmwareVersion
      ...PvtHeatPumpDhwScheduler
    }
  }
}
    ${PvtHeatPumpDhwSchedulerFragmentDoc}`;

/**
 * __useReadHeatPumpDhwSchedulerQuery__
 *
 * To run a query within a React component, call `useReadHeatPumpDhwSchedulerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadHeatPumpDhwSchedulerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadHeatPumpDhwSchedulerQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useReadHeatPumpDhwSchedulerQuery(baseOptions: Apollo.QueryHookOptions<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables> & ({ variables: ReadHeatPumpDhwSchedulerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables>(ReadHeatPumpDhwSchedulerDocument, options);
      }
export function useReadHeatPumpDhwSchedulerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables>(ReadHeatPumpDhwSchedulerDocument, options);
        }
export function useReadHeatPumpDhwSchedulerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables>(ReadHeatPumpDhwSchedulerDocument, options);
        }
export type ReadHeatPumpDhwSchedulerQueryHookResult = ReturnType<typeof useReadHeatPumpDhwSchedulerQuery>;
export type ReadHeatPumpDhwSchedulerLazyQueryHookResult = ReturnType<typeof useReadHeatPumpDhwSchedulerLazyQuery>;
export type ReadHeatPumpDhwSchedulerSuspenseQueryHookResult = ReturnType<typeof useReadHeatPumpDhwSchedulerSuspenseQuery>;
export type ReadHeatPumpDhwSchedulerQueryResult = Apollo.QueryResult<ReadHeatPumpDhwSchedulerQuery, ReadHeatPumpDhwSchedulerQueryVariables>;
export const UpdatePvtHeatPumpSettingsDocument = gql`
    mutation UpdatePvtHeatPumpSettings($interfaceIds: [String!]!, $pvtHeatPumpdata: PvtHeatPumpInput!, $controllerSettings: ControllerSettingsInput!, $isExpert: Boolean!, $isAdmin: Boolean!) {
  updatePvtHeatPump(data: $pvtHeatPumpdata, interfaceIds: $interfaceIds)
  updateControllerSettings(
    interfaceIds: $interfaceIds
    settings: $controllerSettings
  ) {
    id
    controller {
      ...ResidentControllerSettingsFields
      delayHPOnMin @include(if: $isExpert)
      hysBHOn @include(if: $isExpert)
      sourceBivTemp @include(if: $isExpert)
      delayHPOffMin @include(if: $isAdmin)
      delayHPCheckMin @include(if: $isAdmin)
      hysHPOn @include(if: $isAdmin)
      hysHPOff @include(if: $isAdmin)
      hysBHOff @include(if: $isAdmin)
      delayHPPostRunMin @include(if: $isAdmin)
    }
  }
}
    ${ResidentControllerSettingsFieldsFragmentDoc}`;
export type UpdatePvtHeatPumpSettingsMutationFn = Apollo.MutationFunction<UpdatePvtHeatPumpSettingsMutation, UpdatePvtHeatPumpSettingsMutationVariables>;

/**
 * __useUpdatePvtHeatPumpSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePvtHeatPumpSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePvtHeatPumpSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePvtHeatPumpSettingsMutation, { data, loading, error }] = useUpdatePvtHeatPumpSettingsMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *      pvtHeatPumpdata: // value for 'pvtHeatPumpdata'
 *      controllerSettings: // value for 'controllerSettings'
 *      isExpert: // value for 'isExpert'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useUpdatePvtHeatPumpSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePvtHeatPumpSettingsMutation, UpdatePvtHeatPumpSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePvtHeatPumpSettingsMutation, UpdatePvtHeatPumpSettingsMutationVariables>(UpdatePvtHeatPumpSettingsDocument, options);
      }
export type UpdatePvtHeatPumpSettingsMutationHookResult = ReturnType<typeof useUpdatePvtHeatPumpSettingsMutation>;
export type UpdatePvtHeatPumpSettingsMutationResult = Apollo.MutationResult<UpdatePvtHeatPumpSettingsMutation>;
export type UpdatePvtHeatPumpSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePvtHeatPumpSettingsMutation, UpdatePvtHeatPumpSettingsMutationVariables>;
export const UpdatePvtHeatPumpAdminSettingsDocument = gql`
    mutation UpdatePvtHeatPumpAdminSettings($interfaceIds: [String!]!, $data: PvtHeatPumpInput!) {
  updatePvtHeatPump(data: $data, interfaceIds: $interfaceIds)
}
    `;
export type UpdatePvtHeatPumpAdminSettingsMutationFn = Apollo.MutationFunction<UpdatePvtHeatPumpAdminSettingsMutation, UpdatePvtHeatPumpAdminSettingsMutationVariables>;

/**
 * __useUpdatePvtHeatPumpAdminSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePvtHeatPumpAdminSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePvtHeatPumpAdminSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePvtHeatPumpAdminSettingsMutation, { data, loading, error }] = useUpdatePvtHeatPumpAdminSettingsMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePvtHeatPumpAdminSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePvtHeatPumpAdminSettingsMutation, UpdatePvtHeatPumpAdminSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePvtHeatPumpAdminSettingsMutation, UpdatePvtHeatPumpAdminSettingsMutationVariables>(UpdatePvtHeatPumpAdminSettingsDocument, options);
      }
export type UpdatePvtHeatPumpAdminSettingsMutationHookResult = ReturnType<typeof useUpdatePvtHeatPumpAdminSettingsMutation>;
export type UpdatePvtHeatPumpAdminSettingsMutationResult = Apollo.MutationResult<UpdatePvtHeatPumpAdminSettingsMutation>;
export type UpdatePvtHeatPumpAdminSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePvtHeatPumpAdminSettingsMutation, UpdatePvtHeatPumpAdminSettingsMutationVariables>;
export const RestartPvtHeatPumpDocument = gql`
    mutation RestartPvtHeatPump($interfaceIds: [String!]!) {
  updatePvtHeatPump(interfaceIds: $interfaceIds, data: {restartUnit: true})
}
    `;
export type RestartPvtHeatPumpMutationFn = Apollo.MutationFunction<RestartPvtHeatPumpMutation, RestartPvtHeatPumpMutationVariables>;

/**
 * __useRestartPvtHeatPumpMutation__
 *
 * To run a mutation, you first call `useRestartPvtHeatPumpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartPvtHeatPumpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartPvtHeatPumpMutation, { data, loading, error }] = useRestartPvtHeatPumpMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *   },
 * });
 */
export function useRestartPvtHeatPumpMutation(baseOptions?: Apollo.MutationHookOptions<RestartPvtHeatPumpMutation, RestartPvtHeatPumpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartPvtHeatPumpMutation, RestartPvtHeatPumpMutationVariables>(RestartPvtHeatPumpDocument, options);
      }
export type RestartPvtHeatPumpMutationHookResult = ReturnType<typeof useRestartPvtHeatPumpMutation>;
export type RestartPvtHeatPumpMutationResult = Apollo.MutationResult<RestartPvtHeatPumpMutation>;
export type RestartPvtHeatPumpMutationOptions = Apollo.BaseMutationOptions<RestartPvtHeatPumpMutation, RestartPvtHeatPumpMutationVariables>;
export const ResetPvtHeatPumpErrorsDocument = gql`
    mutation ResetPvtHeatPumpErrors($interfaceIds: [String!]!) {
  updatePvtHeatPump(interfaceIds: $interfaceIds, data: {resetErrors: true})
}
    `;
export type ResetPvtHeatPumpErrorsMutationFn = Apollo.MutationFunction<ResetPvtHeatPumpErrorsMutation, ResetPvtHeatPumpErrorsMutationVariables>;

/**
 * __useResetPvtHeatPumpErrorsMutation__
 *
 * To run a mutation, you first call `useResetPvtHeatPumpErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPvtHeatPumpErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPvtHeatPumpErrorsMutation, { data, loading, error }] = useResetPvtHeatPumpErrorsMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *   },
 * });
 */
export function useResetPvtHeatPumpErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ResetPvtHeatPumpErrorsMutation, ResetPvtHeatPumpErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPvtHeatPumpErrorsMutation, ResetPvtHeatPumpErrorsMutationVariables>(ResetPvtHeatPumpErrorsDocument, options);
      }
export type ResetPvtHeatPumpErrorsMutationHookResult = ReturnType<typeof useResetPvtHeatPumpErrorsMutation>;
export type ResetPvtHeatPumpErrorsMutationResult = Apollo.MutationResult<ResetPvtHeatPumpErrorsMutation>;
export type ResetPvtHeatPumpErrorsMutationOptions = Apollo.BaseMutationOptions<ResetPvtHeatPumpErrorsMutation, ResetPvtHeatPumpErrorsMutationVariables>;
export const UpdatePvtHeatPumpDhwSchedulerDocument = gql`
    mutation UpdatePvtHeatPumpDhwScheduler($interfaceIds: [String!]!, $data: DHWSchedulerInput!) {
  updateDHWScheduler(data: $data, interfaceIds: $interfaceIds)
}
    `;
export type UpdatePvtHeatPumpDhwSchedulerMutationFn = Apollo.MutationFunction<UpdatePvtHeatPumpDhwSchedulerMutation, UpdatePvtHeatPumpDhwSchedulerMutationVariables>;

/**
 * __useUpdatePvtHeatPumpDhwSchedulerMutation__
 *
 * To run a mutation, you first call `useUpdatePvtHeatPumpDhwSchedulerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePvtHeatPumpDhwSchedulerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePvtHeatPumpDhwSchedulerMutation, { data, loading, error }] = useUpdatePvtHeatPumpDhwSchedulerMutation({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePvtHeatPumpDhwSchedulerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePvtHeatPumpDhwSchedulerMutation, UpdatePvtHeatPumpDhwSchedulerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePvtHeatPumpDhwSchedulerMutation, UpdatePvtHeatPumpDhwSchedulerMutationVariables>(UpdatePvtHeatPumpDhwSchedulerDocument, options);
      }
export type UpdatePvtHeatPumpDhwSchedulerMutationHookResult = ReturnType<typeof useUpdatePvtHeatPumpDhwSchedulerMutation>;
export type UpdatePvtHeatPumpDhwSchedulerMutationResult = Apollo.MutationResult<UpdatePvtHeatPumpDhwSchedulerMutation>;
export type UpdatePvtHeatPumpDhwSchedulerMutationOptions = Apollo.BaseMutationOptions<UpdatePvtHeatPumpDhwSchedulerMutation, UpdatePvtHeatPumpDhwSchedulerMutationVariables>;
export const HeatPumpSlaveDocument = gql`
    query HeatPumpSlave($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    ...HeatPumpSlaveFields
  }
}
    ${HeatPumpSlaveFieldsFragmentDoc}`;

/**
 * __useHeatPumpSlaveQuery__
 *
 * To run a query within a React component, call `useHeatPumpSlaveQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeatPumpSlaveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeatPumpSlaveQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useHeatPumpSlaveQuery(baseOptions: Apollo.QueryHookOptions<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables> & ({ variables: HeatPumpSlaveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables>(HeatPumpSlaveDocument, options);
      }
export function useHeatPumpSlaveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables>(HeatPumpSlaveDocument, options);
        }
export function useHeatPumpSlaveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables>(HeatPumpSlaveDocument, options);
        }
export type HeatPumpSlaveQueryHookResult = ReturnType<typeof useHeatPumpSlaveQuery>;
export type HeatPumpSlaveLazyQueryHookResult = ReturnType<typeof useHeatPumpSlaveLazyQuery>;
export type HeatPumpSlaveSuspenseQueryHookResult = ReturnType<typeof useHeatPumpSlaveSuspenseQuery>;
export type HeatPumpSlaveQueryResult = Apollo.QueryResult<HeatPumpSlaveQuery, HeatPumpSlaveQueryVariables>;
export const SetSlaveDocument = gql`
    mutation SetSlave($slaveId: String, $interfaceId: String!) {
  setSlave(slaveId: $slaveId, interfaceId: $interfaceId) {
    ...HeatPumpSlaveFields
  }
}
    ${HeatPumpSlaveFieldsFragmentDoc}`;
export type SetSlaveMutationFn = Apollo.MutationFunction<SetSlaveMutation, SetSlaveMutationVariables>;

/**
 * __useSetSlaveMutation__
 *
 * To run a mutation, you first call `useSetSlaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSlaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSlaveMutation, { data, loading, error }] = useSetSlaveMutation({
 *   variables: {
 *      slaveId: // value for 'slaveId'
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useSetSlaveMutation(baseOptions?: Apollo.MutationHookOptions<SetSlaveMutation, SetSlaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSlaveMutation, SetSlaveMutationVariables>(SetSlaveDocument, options);
      }
export type SetSlaveMutationHookResult = ReturnType<typeof useSetSlaveMutation>;
export type SetSlaveMutationResult = Apollo.MutationResult<SetSlaveMutation>;
export type SetSlaveMutationOptions = Apollo.BaseMutationOptions<SetSlaveMutation, SetSlaveMutationVariables>;
export const InterfacesDocument = gql`
    query Interfaces {
  interfaces {
    ...InterfaceFields
  }
}
    ${InterfaceFieldsFragmentDoc}`;

/**
 * __useInterfacesQuery__
 *
 * To run a query within a React component, call `useInterfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterfacesQuery(baseOptions?: Apollo.QueryHookOptions<InterfacesQuery, InterfacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfacesQuery, InterfacesQueryVariables>(InterfacesDocument, options);
      }
export function useInterfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfacesQuery, InterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfacesQuery, InterfacesQueryVariables>(InterfacesDocument, options);
        }
export function useInterfacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfacesQuery, InterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfacesQuery, InterfacesQueryVariables>(InterfacesDocument, options);
        }
export type InterfacesQueryHookResult = ReturnType<typeof useInterfacesQuery>;
export type InterfacesLazyQueryHookResult = ReturnType<typeof useInterfacesLazyQuery>;
export type InterfacesSuspenseQueryHookResult = ReturnType<typeof useInterfacesSuspenseQuery>;
export type InterfacesQueryResult = Apollo.QueryResult<InterfacesQuery, InterfacesQueryVariables>;
export const InterfacesListDocument = gql`
    query InterfacesList($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    name
    isOnline
    pvtHeatPump {
      firmwareVersion
    }
    firmwareVersion {
      id
      name
      timestamp
    }
  }
}
    `;

/**
 * __useInterfacesListQuery__
 *
 * To run a query within a React component, call `useInterfacesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfacesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfacesListQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInterfacesListQuery(baseOptions: Apollo.QueryHookOptions<InterfacesListQuery, InterfacesListQueryVariables> & ({ variables: InterfacesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfacesListQuery, InterfacesListQueryVariables>(InterfacesListDocument, options);
      }
export function useInterfacesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfacesListQuery, InterfacesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfacesListQuery, InterfacesListQueryVariables>(InterfacesListDocument, options);
        }
export function useInterfacesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfacesListQuery, InterfacesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfacesListQuery, InterfacesListQueryVariables>(InterfacesListDocument, options);
        }
export type InterfacesListQueryHookResult = ReturnType<typeof useInterfacesListQuery>;
export type InterfacesListLazyQueryHookResult = ReturnType<typeof useInterfacesListLazyQuery>;
export type InterfacesListSuspenseQueryHookResult = ReturnType<typeof useInterfacesListSuspenseQuery>;
export type InterfacesListQueryResult = Apollo.QueryResult<InterfacesListQuery, InterfacesListQueryVariables>;
export const InterfaceIDsDocument = gql`
    query interfaceIDs {
  interfaces {
    ...InterfaceIdsFields
  }
}
    ${InterfaceIdsFieldsFragmentDoc}`;

/**
 * __useInterfaceIDsQuery__
 *
 * To run a query within a React component, call `useInterfaceIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceIDsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterfaceIDsQuery(baseOptions?: Apollo.QueryHookOptions<InterfaceIDsQuery, InterfaceIDsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceIDsQuery, InterfaceIDsQueryVariables>(InterfaceIDsDocument, options);
      }
export function useInterfaceIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceIDsQuery, InterfaceIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceIDsQuery, InterfaceIDsQueryVariables>(InterfaceIDsDocument, options);
        }
export function useInterfaceIDsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceIDsQuery, InterfaceIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceIDsQuery, InterfaceIDsQueryVariables>(InterfaceIDsDocument, options);
        }
export type InterfaceIDsQueryHookResult = ReturnType<typeof useInterfaceIDsQuery>;
export type InterfaceIDsLazyQueryHookResult = ReturnType<typeof useInterfaceIDsLazyQuery>;
export type InterfaceIDsSuspenseQueryHookResult = ReturnType<typeof useInterfaceIDsSuspenseQuery>;
export type InterfaceIDsQueryResult = Apollo.QueryResult<InterfaceIDsQuery, InterfaceIDsQueryVariables>;
export const InterfaceNameDocument = gql`
    query InterfaceName($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    name
  }
}
    `;

/**
 * __useInterfaceNameQuery__
 *
 * To run a query within a React component, call `useInterfaceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceNameQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInterfaceNameQuery(baseOptions: Apollo.QueryHookOptions<InterfaceNameQuery, InterfaceNameQueryVariables> & ({ variables: InterfaceNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceNameQuery, InterfaceNameQueryVariables>(InterfaceNameDocument, options);
      }
export function useInterfaceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceNameQuery, InterfaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceNameQuery, InterfaceNameQueryVariables>(InterfaceNameDocument, options);
        }
export function useInterfaceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceNameQuery, InterfaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceNameQuery, InterfaceNameQueryVariables>(InterfaceNameDocument, options);
        }
export type InterfaceNameQueryHookResult = ReturnType<typeof useInterfaceNameQuery>;
export type InterfaceNameLazyQueryHookResult = ReturnType<typeof useInterfaceNameLazyQuery>;
export type InterfaceNameSuspenseQueryHookResult = ReturnType<typeof useInterfaceNameSuspenseQuery>;
export type InterfaceNameQueryResult = Apollo.QueryResult<InterfaceNameQuery, InterfaceNameQueryVariables>;
export const InterfaceStatusDocument = gql`
    query InterfaceStatus($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    ...InterfaceFields
  }
}
    ${InterfaceFieldsFragmentDoc}`;

/**
 * __useInterfaceStatusQuery__
 *
 * To run a query within a React component, call `useInterfaceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceStatusQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInterfaceStatusQuery(baseOptions: Apollo.QueryHookOptions<InterfaceStatusQuery, InterfaceStatusQueryVariables> & ({ variables: InterfaceStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceStatusQuery, InterfaceStatusQueryVariables>(InterfaceStatusDocument, options);
      }
export function useInterfaceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceStatusQuery, InterfaceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceStatusQuery, InterfaceStatusQueryVariables>(InterfaceStatusDocument, options);
        }
export function useInterfaceStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceStatusQuery, InterfaceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceStatusQuery, InterfaceStatusQueryVariables>(InterfaceStatusDocument, options);
        }
export type InterfaceStatusQueryHookResult = ReturnType<typeof useInterfaceStatusQuery>;
export type InterfaceStatusLazyQueryHookResult = ReturnType<typeof useInterfaceStatusLazyQuery>;
export type InterfaceStatusSuspenseQueryHookResult = ReturnType<typeof useInterfaceStatusSuspenseQuery>;
export type InterfaceStatusQueryResult = Apollo.QueryResult<InterfaceStatusQuery, InterfaceStatusQueryVariables>;
export const InterfaceDocument = gql`
    query Interface($interfaceId: String!, $from: Time!, $until: Time) {
  interface(interfaceId: $interfaceId) {
    ...InterfaceFields
    logs(from: $from, until: $until) {
      data {
        ...InterfaceLogData
      }
    }
  }
}
    ${InterfaceFieldsFragmentDoc}
${InterfaceLogDataFragmentDoc}`;

/**
 * __useInterfaceQuery__
 *
 * To run a query within a React component, call `useInterfaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *      from: // value for 'from'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useInterfaceQuery(baseOptions: Apollo.QueryHookOptions<InterfaceQuery, InterfaceQueryVariables> & ({ variables: InterfaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceQuery, InterfaceQueryVariables>(InterfaceDocument, options);
      }
export function useInterfaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceQuery, InterfaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceQuery, InterfaceQueryVariables>(InterfaceDocument, options);
        }
export function useInterfaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceQuery, InterfaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceQuery, InterfaceQueryVariables>(InterfaceDocument, options);
        }
export type InterfaceQueryHookResult = ReturnType<typeof useInterfaceQuery>;
export type InterfaceLazyQueryHookResult = ReturnType<typeof useInterfaceLazyQuery>;
export type InterfaceSuspenseQueryHookResult = ReturnType<typeof useInterfaceSuspenseQuery>;
export type InterfaceQueryResult = Apollo.QueryResult<InterfaceQuery, InterfaceQueryVariables>;
export const ResidentInterfaceDocument = gql`
    query ResidentInterface($interfaceId: String!, $from: Time!, $until: Time) {
  interface(interfaceId: $interfaceId) {
    ...InterfaceFields
    logs(from: $from, until: $until) {
      data {
        ...ResidentInterfaceLogData
      }
    }
  }
}
    ${InterfaceFieldsFragmentDoc}
${ResidentInterfaceLogDataFragmentDoc}`;

/**
 * __useResidentInterfaceQuery__
 *
 * To run a query within a React component, call `useResidentInterfaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResidentInterfaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResidentInterfaceQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *      from: // value for 'from'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useResidentInterfaceQuery(baseOptions: Apollo.QueryHookOptions<ResidentInterfaceQuery, ResidentInterfaceQueryVariables> & ({ variables: ResidentInterfaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResidentInterfaceQuery, ResidentInterfaceQueryVariables>(ResidentInterfaceDocument, options);
      }
export function useResidentInterfaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResidentInterfaceQuery, ResidentInterfaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResidentInterfaceQuery, ResidentInterfaceQueryVariables>(ResidentInterfaceDocument, options);
        }
export function useResidentInterfaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResidentInterfaceQuery, ResidentInterfaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResidentInterfaceQuery, ResidentInterfaceQueryVariables>(ResidentInterfaceDocument, options);
        }
export type ResidentInterfaceQueryHookResult = ReturnType<typeof useResidentInterfaceQuery>;
export type ResidentInterfaceLazyQueryHookResult = ReturnType<typeof useResidentInterfaceLazyQuery>;
export type ResidentInterfaceSuspenseQueryHookResult = ReturnType<typeof useResidentInterfaceSuspenseQuery>;
export type ResidentInterfaceQueryResult = Apollo.QueryResult<ResidentInterfaceQuery, ResidentInterfaceQueryVariables>;
export const InterfaceKnownDocument = gql`
    query InterfaceKnown($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
  }
}
    `;

/**
 * __useInterfaceKnownQuery__
 *
 * To run a query within a React component, call `useInterfaceKnownQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceKnownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceKnownQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInterfaceKnownQuery(baseOptions: Apollo.QueryHookOptions<InterfaceKnownQuery, InterfaceKnownQueryVariables> & ({ variables: InterfaceKnownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceKnownQuery, InterfaceKnownQueryVariables>(InterfaceKnownDocument, options);
      }
export function useInterfaceKnownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceKnownQuery, InterfaceKnownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceKnownQuery, InterfaceKnownQueryVariables>(InterfaceKnownDocument, options);
        }
export function useInterfaceKnownSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceKnownQuery, InterfaceKnownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceKnownQuery, InterfaceKnownQueryVariables>(InterfaceKnownDocument, options);
        }
export type InterfaceKnownQueryHookResult = ReturnType<typeof useInterfaceKnownQuery>;
export type InterfaceKnownLazyQueryHookResult = ReturnType<typeof useInterfaceKnownLazyQuery>;
export type InterfaceKnownSuspenseQueryHookResult = ReturnType<typeof useInterfaceKnownSuspenseQuery>;
export type InterfaceKnownQueryResult = Apollo.QueryResult<InterfaceKnownQuery, InterfaceKnownQueryVariables>;
export const InterfaceOnlineDocument = gql`
    query InterfaceOnline($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    isOnline(pingDevice: true)
  }
}
    `;

/**
 * __useInterfaceOnlineQuery__
 *
 * To run a query within a React component, call `useInterfaceOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceOnlineQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInterfaceOnlineQuery(baseOptions: Apollo.QueryHookOptions<InterfaceOnlineQuery, InterfaceOnlineQueryVariables> & ({ variables: InterfaceOnlineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceOnlineQuery, InterfaceOnlineQueryVariables>(InterfaceOnlineDocument, options);
      }
export function useInterfaceOnlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceOnlineQuery, InterfaceOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceOnlineQuery, InterfaceOnlineQueryVariables>(InterfaceOnlineDocument, options);
        }
export function useInterfaceOnlineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceOnlineQuery, InterfaceOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceOnlineQuery, InterfaceOnlineQueryVariables>(InterfaceOnlineDocument, options);
        }
export type InterfaceOnlineQueryHookResult = ReturnType<typeof useInterfaceOnlineQuery>;
export type InterfaceOnlineLazyQueryHookResult = ReturnType<typeof useInterfaceOnlineLazyQuery>;
export type InterfaceOnlineSuspenseQueryHookResult = ReturnType<typeof useInterfaceOnlineSuspenseQuery>;
export type InterfaceOnlineQueryResult = Apollo.QueryResult<InterfaceOnlineQuery, InterfaceOnlineQueryVariables>;
export const InterfaceGroupsDocument = gql`
    query InterfaceGroups($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    groups {
      id
    }
  }
}
    `;

/**
 * __useInterfaceGroupsQuery__
 *
 * To run a query within a React component, call `useInterfaceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterfaceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterfaceGroupsQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInterfaceGroupsQuery(baseOptions: Apollo.QueryHookOptions<InterfaceGroupsQuery, InterfaceGroupsQueryVariables> & ({ variables: InterfaceGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterfaceGroupsQuery, InterfaceGroupsQueryVariables>(InterfaceGroupsDocument, options);
      }
export function useInterfaceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterfaceGroupsQuery, InterfaceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterfaceGroupsQuery, InterfaceGroupsQueryVariables>(InterfaceGroupsDocument, options);
        }
export function useInterfaceGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterfaceGroupsQuery, InterfaceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterfaceGroupsQuery, InterfaceGroupsQueryVariables>(InterfaceGroupsDocument, options);
        }
export type InterfaceGroupsQueryHookResult = ReturnType<typeof useInterfaceGroupsQuery>;
export type InterfaceGroupsLazyQueryHookResult = ReturnType<typeof useInterfaceGroupsLazyQuery>;
export type InterfaceGroupsSuspenseQueryHookResult = ReturnType<typeof useInterfaceGroupsSuspenseQuery>;
export type InterfaceGroupsQueryResult = Apollo.QueryResult<InterfaceGroupsQuery, InterfaceGroupsQueryVariables>;
export const GroupInterfaceNameDocument = gql`
    query GroupInterfaceName($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    name
  }
}
    `;

/**
 * __useGroupInterfaceNameQuery__
 *
 * To run a query within a React component, call `useGroupInterfaceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupInterfaceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupInterfaceNameQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useGroupInterfaceNameQuery(baseOptions: Apollo.QueryHookOptions<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables> & ({ variables: GroupInterfaceNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables>(GroupInterfaceNameDocument, options);
      }
export function useGroupInterfaceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables>(GroupInterfaceNameDocument, options);
        }
export function useGroupInterfaceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables>(GroupInterfaceNameDocument, options);
        }
export type GroupInterfaceNameQueryHookResult = ReturnType<typeof useGroupInterfaceNameQuery>;
export type GroupInterfaceNameLazyQueryHookResult = ReturnType<typeof useGroupInterfaceNameLazyQuery>;
export type GroupInterfaceNameSuspenseQueryHookResult = ReturnType<typeof useGroupInterfaceNameSuspenseQuery>;
export type GroupInterfaceNameQueryResult = Apollo.QueryResult<GroupInterfaceNameQuery, GroupInterfaceNameQueryVariables>;
export const HeatPumpConnectedDocument = gql`
    query HeatPumpConnected($interfaceId: String!) {
  interface(interfaceId: $interfaceId) {
    id
    heatPumpConnected
  }
}
    `;

/**
 * __useHeatPumpConnectedQuery__
 *
 * To run a query within a React component, call `useHeatPumpConnectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeatPumpConnectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeatPumpConnectedQuery({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useHeatPumpConnectedQuery(baseOptions: Apollo.QueryHookOptions<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables> & ({ variables: HeatPumpConnectedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables>(HeatPumpConnectedDocument, options);
      }
export function useHeatPumpConnectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables>(HeatPumpConnectedDocument, options);
        }
export function useHeatPumpConnectedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables>(HeatPumpConnectedDocument, options);
        }
export type HeatPumpConnectedQueryHookResult = ReturnType<typeof useHeatPumpConnectedQuery>;
export type HeatPumpConnectedLazyQueryHookResult = ReturnType<typeof useHeatPumpConnectedLazyQuery>;
export type HeatPumpConnectedSuspenseQueryHookResult = ReturnType<typeof useHeatPumpConnectedSuspenseQuery>;
export type HeatPumpConnectedQueryResult = Apollo.QueryResult<HeatPumpConnectedQuery, HeatPumpConnectedQueryVariables>;
export const AllInterfacesDocument = gql`
    query AllInterfaces($interfaceIds: [String!]) {
  interfaces(interfaceIds: $interfaceIds) {
    ...InterfacesFields
  }
}
    ${InterfacesFieldsFragmentDoc}`;

/**
 * __useAllInterfacesQuery__
 *
 * To run a query within a React component, call `useAllInterfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInterfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInterfacesQuery({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *   },
 * });
 */
export function useAllInterfacesQuery(baseOptions?: Apollo.QueryHookOptions<AllInterfacesQuery, AllInterfacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllInterfacesQuery, AllInterfacesQueryVariables>(AllInterfacesDocument, options);
      }
export function useAllInterfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllInterfacesQuery, AllInterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllInterfacesQuery, AllInterfacesQueryVariables>(AllInterfacesDocument, options);
        }
export function useAllInterfacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllInterfacesQuery, AllInterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllInterfacesQuery, AllInterfacesQueryVariables>(AllInterfacesDocument, options);
        }
export type AllInterfacesQueryHookResult = ReturnType<typeof useAllInterfacesQuery>;
export type AllInterfacesLazyQueryHookResult = ReturnType<typeof useAllInterfacesLazyQuery>;
export type AllInterfacesSuspenseQueryHookResult = ReturnType<typeof useAllInterfacesSuspenseQuery>;
export type AllInterfacesQueryResult = Apollo.QueryResult<AllInterfacesQuery, AllInterfacesQueryVariables>;
export const BatchUpdateInterfacesDocument = gql`
    query BatchUpdateInterfaces($interfaceIds: [String!]) {
  interfaces(interfaceIds: $interfaceIds) {
    ...BatchUpdateInterfaceFields
  }
}
    ${BatchUpdateInterfaceFieldsFragmentDoc}`;

/**
 * __useBatchUpdateInterfacesQuery__
 *
 * To run a query within a React component, call `useBatchUpdateInterfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateInterfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchUpdateInterfacesQuery({
 *   variables: {
 *      interfaceIds: // value for 'interfaceIds'
 *   },
 * });
 */
export function useBatchUpdateInterfacesQuery(baseOptions?: Apollo.QueryHookOptions<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>(BatchUpdateInterfacesDocument, options);
      }
export function useBatchUpdateInterfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>(BatchUpdateInterfacesDocument, options);
        }
export function useBatchUpdateInterfacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>(BatchUpdateInterfacesDocument, options);
        }
export type BatchUpdateInterfacesQueryHookResult = ReturnType<typeof useBatchUpdateInterfacesQuery>;
export type BatchUpdateInterfacesLazyQueryHookResult = ReturnType<typeof useBatchUpdateInterfacesLazyQuery>;
export type BatchUpdateInterfacesSuspenseQueryHookResult = ReturnType<typeof useBatchUpdateInterfacesSuspenseQuery>;
export type BatchUpdateInterfacesQueryResult = Apollo.QueryResult<BatchUpdateInterfacesQuery, BatchUpdateInterfacesQueryVariables>;
export const SetInterfaceNameDocument = gql`
    mutation SetInterfaceName($id: String!, $name: String) {
  setInterfaceName(interfaceId: $id, name: $name) {
    id
    name
  }
}
    `;
export type SetInterfaceNameMutationFn = Apollo.MutationFunction<SetInterfaceNameMutation, SetInterfaceNameMutationVariables>;

/**
 * __useSetInterfaceNameMutation__
 *
 * To run a mutation, you first call `useSetInterfaceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInterfaceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInterfaceNameMutation, { data, loading, error }] = useSetInterfaceNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetInterfaceNameMutation(baseOptions?: Apollo.MutationHookOptions<SetInterfaceNameMutation, SetInterfaceNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInterfaceNameMutation, SetInterfaceNameMutationVariables>(SetInterfaceNameDocument, options);
      }
export type SetInterfaceNameMutationHookResult = ReturnType<typeof useSetInterfaceNameMutation>;
export type SetInterfaceNameMutationResult = Apollo.MutationResult<SetInterfaceNameMutation>;
export type SetInterfaceNameMutationOptions = Apollo.BaseMutationOptions<SetInterfaceNameMutation, SetInterfaceNameMutationVariables>;
export const InteractiveSessionDocument = gql`
    mutation InteractiveSession($interfaceId: String!) {
  interactiveSession(interfaceId: $interfaceId)
}
    `;
export type InteractiveSessionMutationFn = Apollo.MutationFunction<InteractiveSessionMutation, InteractiveSessionMutationVariables>;

/**
 * __useInteractiveSessionMutation__
 *
 * To run a mutation, you first call `useInteractiveSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInteractiveSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interactiveSessionMutation, { data, loading, error }] = useInteractiveSessionMutation({
 *   variables: {
 *      interfaceId: // value for 'interfaceId'
 *   },
 * });
 */
export function useInteractiveSessionMutation(baseOptions?: Apollo.MutationHookOptions<InteractiveSessionMutation, InteractiveSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InteractiveSessionMutation, InteractiveSessionMutationVariables>(InteractiveSessionDocument, options);
      }
export type InteractiveSessionMutationHookResult = ReturnType<typeof useInteractiveSessionMutation>;
export type InteractiveSessionMutationResult = Apollo.MutationResult<InteractiveSessionMutation>;
export type InteractiveSessionMutationOptions = Apollo.BaseMutationOptions<InteractiveSessionMutation, InteractiveSessionMutationVariables>;
export const HeatPumpPageFilterDocument = gql`
    query HeatPumpPageFilter {
  heatPumpPageFilter {
    searchText
    offlineHeatPumps
  }
}
    `;

/**
 * __useHeatPumpPageFilterQuery__
 *
 * To run a query within a React component, call `useHeatPumpPageFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeatPumpPageFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeatPumpPageFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeatPumpPageFilterQuery(baseOptions?: Apollo.QueryHookOptions<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>(HeatPumpPageFilterDocument, options);
      }
export function useHeatPumpPageFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>(HeatPumpPageFilterDocument, options);
        }
export function useHeatPumpPageFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>(HeatPumpPageFilterDocument, options);
        }
export type HeatPumpPageFilterQueryHookResult = ReturnType<typeof useHeatPumpPageFilterQuery>;
export type HeatPumpPageFilterLazyQueryHookResult = ReturnType<typeof useHeatPumpPageFilterLazyQuery>;
export type HeatPumpPageFilterSuspenseQueryHookResult = ReturnType<typeof useHeatPumpPageFilterSuspenseQuery>;
export type HeatPumpPageFilterQueryResult = Apollo.QueryResult<HeatPumpPageFilterQuery, HeatPumpPageFilterQueryVariables>;
export const LogPeriodDocument = gql`
    query LogPeriod {
  logPeriod @client
}
    `;

/**
 * __useLogPeriodQuery__
 *
 * To run a query within a React component, call `useLogPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogPeriodQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogPeriodQuery(baseOptions?: Apollo.QueryHookOptions<LogPeriodQuery, LogPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogPeriodQuery, LogPeriodQueryVariables>(LogPeriodDocument, options);
      }
export function useLogPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogPeriodQuery, LogPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogPeriodQuery, LogPeriodQueryVariables>(LogPeriodDocument, options);
        }
export function useLogPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LogPeriodQuery, LogPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogPeriodQuery, LogPeriodQueryVariables>(LogPeriodDocument, options);
        }
export type LogPeriodQueryHookResult = ReturnType<typeof useLogPeriodQuery>;
export type LogPeriodLazyQueryHookResult = ReturnType<typeof useLogPeriodLazyQuery>;
export type LogPeriodSuspenseQueryHookResult = ReturnType<typeof useLogPeriodSuspenseQuery>;
export type LogPeriodQueryResult = Apollo.QueryResult<LogPeriodQuery, LogPeriodQueryVariables>;
export const UserNotificationsDocument = gql`
    query UserNotifications($types: [NotificationType!], $limit: Int) {
  notifications(types: $types, limit: $limit) {
    ...UserNotificationFields
  }
}
    ${UserNotificationFieldsFragmentDoc}`;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *      types: // value for 'types'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export function useUserNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsSuspenseQueryHookResult = ReturnType<typeof useUserNotificationsSuspenseQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const AdminNotificationsDocument = gql`
    query AdminNotifications($includeExpired: Boolean, $types: [NotificationType!], $limit: Int) {
  notifications(includeExpired: $includeExpired, types: $types, limit: $limit) {
    ...AdminNotificationFields
  }
}
    ${AdminNotificationFieldsFragmentDoc}`;

/**
 * __useAdminNotificationsQuery__
 *
 * To run a query within a React component, call `useAdminNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNotificationsQuery({
 *   variables: {
 *      includeExpired: // value for 'includeExpired'
 *      types: // value for 'types'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
      }
export function useAdminNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
        }
export function useAdminNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
        }
export type AdminNotificationsQueryHookResult = ReturnType<typeof useAdminNotificationsQuery>;
export type AdminNotificationsLazyQueryHookResult = ReturnType<typeof useAdminNotificationsLazyQuery>;
export type AdminNotificationsSuspenseQueryHookResult = ReturnType<typeof useAdminNotificationsSuspenseQuery>;
export type AdminNotificationsQueryResult = Apollo.QueryResult<AdminNotificationsQuery, AdminNotificationsQueryVariables>;
export const UpsertNotificationDocument = gql`
    mutation UpsertNotification($notification: NotificationInput!) {
  upsertNotification(notification: $notification) {
    ...AdminNotificationFields
  }
}
    ${AdminNotificationFieldsFragmentDoc}`;
export type UpsertNotificationMutationFn = Apollo.MutationFunction<UpsertNotificationMutation, UpsertNotificationMutationVariables>;

/**
 * __useUpsertNotificationMutation__
 *
 * To run a mutation, you first call `useUpsertNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNotificationMutation, { data, loading, error }] = useUpsertNotificationMutation({
 *   variables: {
 *      notification: // value for 'notification'
 *   },
 * });
 */
export function useUpsertNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNotificationMutation, UpsertNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNotificationMutation, UpsertNotificationMutationVariables>(UpsertNotificationDocument, options);
      }
export type UpsertNotificationMutationHookResult = ReturnType<typeof useUpsertNotificationMutation>;
export type UpsertNotificationMutationResult = Apollo.MutationResult<UpsertNotificationMutation>;
export type UpsertNotificationMutationOptions = Apollo.BaseMutationOptions<UpsertNotificationMutation, UpsertNotificationMutationVariables>;
export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($notificationId: ID!) {
  markNotificationRead(notificationId: $notificationId) {
    id
    read
  }
}
    `;
export type MarkNotificationReadMutationFn = Apollo.MutationFunction<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;

/**
 * __useMarkNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationReadMutation, { data, loading, error }] = useMarkNotificationReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>(MarkNotificationReadDocument, options);
      }
export type MarkNotificationReadMutationHookResult = ReturnType<typeof useMarkNotificationReadMutation>;
export type MarkNotificationReadMutationResult = Apollo.MutationResult<MarkNotificationReadMutation>;
export type MarkNotificationReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($notificationId: ID!) {
  deleteNotification(notificationId: $notificationId)
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const UsersDocument = gql`
    query Users($roles: [Role!]) {
  users(roles: $roles) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    isGroupAdmin
    firstName
    lastName
    email
    group {
      id
      isOrganization
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyAccountDocument = gql`
    query MyAccount {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMyAccountQuery__
 *
 * To run a query within a React component, call `useMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
      }
export function useMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export function useMyAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export type MyAccountQueryHookResult = ReturnType<typeof useMyAccountQuery>;
export type MyAccountLazyQueryHookResult = ReturnType<typeof useMyAccountLazyQuery>;
export type MyAccountSuspenseQueryHookResult = ReturnType<typeof useMyAccountSuspenseQuery>;
export type MyAccountQueryResult = Apollo.QueryResult<MyAccountQuery, MyAccountQueryVariables>;
export const UpsertUserDocument = gql`
    mutation UpsertUser($user: NewUser!) {
  upsertUser(user: $user) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpsertUserMutationFn = Apollo.MutationFunction<UpsertUserMutation, UpsertUserMutationVariables>;

/**
 * __useUpsertUserMutation__
 *
 * To run a mutation, you first call `useUpsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserMutation, { data, loading, error }] = useUpsertUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpsertUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserMutation, UpsertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserMutation, UpsertUserMutationVariables>(UpsertUserDocument, options);
      }
export type UpsertUserMutationHookResult = ReturnType<typeof useUpsertUserMutation>;
export type UpsertUserMutationResult = Apollo.MutationResult<UpsertUserMutation>;
export type UpsertUserMutationOptions = Apollo.BaseMutationOptions<UpsertUserMutation, UpsertUserMutationVariables>;
export const SettingsPageFilterDocument = gql`
    query SettingsPageFilter {
  settingsPageFilter {
    searchText
  }
}
    `;

/**
 * __useSettingsPageFilterQuery__
 *
 * To run a query within a React component, call `useSettingsPageFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsPageFilterQuery(baseOptions?: Apollo.QueryHookOptions<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>(SettingsPageFilterDocument, options);
      }
export function useSettingsPageFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>(SettingsPageFilterDocument, options);
        }
export function useSettingsPageFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>(SettingsPageFilterDocument, options);
        }
export type SettingsPageFilterQueryHookResult = ReturnType<typeof useSettingsPageFilterQuery>;
export type SettingsPageFilterLazyQueryHookResult = ReturnType<typeof useSettingsPageFilterLazyQuery>;
export type SettingsPageFilterSuspenseQueryHookResult = ReturnType<typeof useSettingsPageFilterSuspenseQuery>;
export type SettingsPageFilterQueryResult = Apollo.QueryResult<SettingsPageFilterQuery, SettingsPageFilterQueryVariables>;